/**
 *      culguraGlistado.js
 *          Script de culturaGlistado.vue
 *          Obtiene los evaluacionesT de evaluación ya registrados permitiendo editarlos y eliminarlos
 */
/* ======================================================================================================== */
import JsonExcel from 'vue-json-excel'
     Vue.component('downloadExcel', JsonExcel)

import M from 'materialize-css'

import moment from 'moment'
import ingreso from './ingreso.vue'

import Vue from 'vue';
import jsPDF from 'jspdf'
Vue.use(jsPDF)

import { store } from './../store/store'

// import 'materialize-css/dist/css/materialize.min.css'

export default {
     name: 'evconsultas',
     components: {
          'moment': moment,
          'input-date': ingreso,
     },
     template: `#evconsultas`,
     data() {
          return {
               limite: 0,

               eval_tipolo: {}, res: {},
               eval_16pf: {}, res_16pf: {},
               eval_npf: {},
               eval_cpf: {},
               eval_fig: {},

               evaluacionesT: [],
               eval_copia: null,                  //* Necesario  una copia para borrar una encuesta después buscar por Descripción o Responsable.

               busqueda: "", busquedaR: "",       //* Variables para la búsqueda}
               busquedaI: "",
               lfuente: "C",

               lc_ini: 0,

               eval_aedp: {},
               res_aedp: {},

               //? Para la exportación para la gráfica
               aedp_grafica: [
                    {
                         columna1: "Variables Evaluadas",
                         columna2: "Cautela",
                         columna3: "Vulnerable",
                         columna4: "Diestro",
                         columna5: "Óptimo"
                    },
                    {
                         columna1: "Sucesos de la vida",
                         columna2: 29,
                         columna3: "",
                         columna4: "",
                         columna5: ""
                    },
                    {
                         columna1: "Presiones laborales",
                         columna2: "",
                         columna3: 15,
                         columna4: "",
                         columna5: ""
                    },
                    {
                         columna1: "Presiones personales",
                         columna2: "",
                         columna3: 17,
                         columna4: "",
                         columna5: ""
                    },
                    {
                         columna1: "Expresión Emocional",
                         columna2: "",
                         columna3: 13,
                         columna4: "",
                         columna5: ""
                    },
               ],

               json_fields: {
                    "Variables evaluadas": "variable",
                    "Cautela": "cautela",
                    "Vulnerable": "vulnerable",
                    "Diestro": "diestro",
                    "Optimo": "optimo",
                  },
               // json_data: [
               //      {
               //           variable: "Sucesos de la vida",
               //           cautela: "29",
               //           vulnerable: "",
               //           diestro: "",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Presiones laborales",
               //           cautela: "",
               //           vulnerable: "15",
               //           diestro: "",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Presiones personales",
               //           cautela: "",
               //           vulnerable: "17",
               //           diestro: "",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Expresión Emocional",
               //           cautela: "",
               //           vulnerable: "13",
               //           diestro: "",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Conciencia Emocional de otros",
               //           cautela: "",
               //           vulnerable: "",
               //           diestro: "25",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Intención",
               //           cautela: "",
               //           vulnerable: "25",
               //           diestro: "",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Creatividad",
               //           cautela: "",
               //           vulnerable: "",
               //           diestro: "19",
               //           optimo: "",
               //      },
               //      {
               //           variable: "Flexibilidad",
               //           cautela: "",
               //           vulnerable: "",
               //           diestro: "31",
               //           optimo: "",
               //      },

               // ],
               json_data: [],
               json_meta: [
                    [
                         {
                         key: "charset",
                         value: "utf-8",
                         },
                    ],
               ],
          } // return
     }, // data()
     mounted() {

          //* Definiciones para el uso de las secciones tipo slide y tooltips 
          var elems = document.querySelectorAll('.collapsible');
          var instances = M.Collapsible.init(elems, {});

          var elems = document.querySelectorAll('.tooltipped');
          var instances = M.Tooltip.init(elems, {});

          this.bdRead();                          // CAMBIO 2: Leyendo la info de FireBase.
     },
     computed: {
          filtrarEvaluaciones: function () {
               return this.evaluacionesT.filter((evaluacion) => {

                    //* steval
                    /* Preserva el índice las tareas recién instanciadas ya que cuando se realiza una búsqueda y se quiere 
                       eliminar una tarea, el índice cambia y borra otra tarea. [ Ver función eliminar() ] en tareas.vue.  */
                    if (evaluacion.empresa.toUpperCase().includes(this.busqueda.toUpperCase()) && 
                         evaluacion.nombre.toUpperCase().includes(this.busquedaR.toUpperCase()) && 
                         evaluacion.steval.toUpperCase().includes(this.busquedaI.toUpperCase()) ) {
                         return evaluacion
                    }
               })
          }, // filtarTareas()
     },
     methods: {
          dateToYYYYMMDD: function (date) {

               date = new Date(date);              // convierte a tipo Date la fecha de fcapturadatos y Vencimiento (.split(' ')[0])
               return date && date.toString()
          }, // datetoYYYMMDD()                     
          getRuta(elTipoEval) {

               console.log("Tipo de Evaluación ? ", elTipoEval);
               var laRuta = "";
               switch (elTipoEval) {
                    case "TIPOLOGIA":
                         laRuta = store.state.st_rutaEvalTipolo;
                         break;
                    case "FACTORES":
                         laRuta = store.state.st_rutaEvalFactor;
                         break;
                    case "ESTABILIDAD":
                         laRuta = store.state.st_rutaEvalEstabi;
                         break;
                    case "SOCIABILIDAD":
                         laRuta = store.state.st_rutaEvalSociab;
                         break;
                    case "PEFIL":
                         laRuta = store.state.st_rutaEvalPerfil;
                         break;
                    case "MOSS":
                         laRuta = store.state.st_rutaEvalSuperv;
                         break;
                    case "TAV":
                         laRuta = store.state.st_rutaEvalApvtas;
                         break;
                    case "SOLEMP":
                         laRuta = store.state.st_rutaEvalSolemp;
                         break;
                    case "EMOCIONES":
                         laRuta = store.state.st_rutaEvalEmoc;
                         break;
                    case "ORIENTACION":
                         laRuta = store.state.st_rutaEvalApVtas2;
                         break;
                    case "AEDP":
                         laRuta = store.state.st_rutaEvalAEDP;
                         break;

                    default:
                    // code block
               }

               return laRuta;
          },
          eliminarEvaluacion(laEvaluacion, index) {

               console.log("Tipo de Evaluación ? ", laEvaluacion.steval);
               var lnuevaRuta = this.getRuta(laEvaluacion.steval);

               var confirma = confirm("Seguro de eliminar la evaluación de ( " + laEvaluacion.nombre.trim() + " ? " + index + " )");
               if (confirma === true) {

                    lnuevaRuta = lnuevaRuta + "/" + index;
                    console.log("la nueva Ruta ? ", lnuevaRuta);
                    var dbEvaluaciones = store.state.st_db.ref(lnuevaRuta);

                    var elRegTarea = dbEvaluaciones.remove();
               };

               this.bdRead();
          },
          mostrarEvaluacion(laEvaluacion) {

               console.log("La evaluación es ");
               console.log(laEvaluacion);

               let elTipoEval = laEvaluacion.steval;
               console.log("el tipo es ? ", elTipoEval);

               switch (elTipoEval) {
                    case "TIPOLOGIA":

                         this.eval_tipolo = store.state.st_ev01;        // Crea el nodo para todos los campos.
                         this.res = store.state.st_rs01;

                         console.log("1. eval_tipolo ? ", this.eval_tipolo);
                         this.eval_tipolo = laEvaluacion;
                         console.log("2. eval_tipolo ? ", this.eval_tipolo);

                         this.crearPDF_Tipolo();

                         break;
                    case "FACTORES":

                         this.eval_16pf = store.state.st_ev02;        // Crea el nodo para todos los campos.
                         this.res_16pf = store.state.st_rs02;

                         console.log("1. eval_16pf ? ", this.eval_16pf);
                         this.eval_16pf = laEvaluacion;
                         console.log("2. eval_16pf ? ", this.eval_16pf);

                         this.crearPDF_16pf();
                         break;
                    case "ESTABILIDAD":

                         this.eval_npf = store.state.st_ev03;        // Crea el nodo para todos los campos.
                         this.res_npf = store.state.st_rs03;

                         console.log("===============================================");
                         console.log("1. eval_npf ? ", this.eval_npf);
                         this.eval_npf = laEvaluacion;
                         console.log("2. eval_npf ? ", this.eval_npf);
                         console.log("===============================================");
                         console.log("3. res_npf ? ", this.res_npf);

                         this.crearPDF_npf();
                         break;
                    case "SOCIABILIDAD":

                         this.eval_cpf = store.state.st_ev04;        // Crea el nodo para todos los campos.
                         this.res_cpf = store.state.st_rs04;

                         console.log("===============================================");
                         console.log("1.- eval_cpf ? ", this.eval_cpf);
                         this.eval_cpf = laEvaluacion;
                         console.log("2.- eval_cpf ? ", this.eval_cpf);
                         console.log("===============================================");
                         console.log("3.- res_cpf ? ", this.res_cpf);

                         this.crearPDF_cpf();

                         store.state.st_rs04= {
                              Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
                              cpreviaIzq: 0, cpreviaDer: 0,
                              rangos: 0,
                         }
               
                         break;
                    case "PERFIL":

                         this.eval_fig = store.state.st_ev05;        // Crea el nodo para todos los campos.
                         this.res_fig = store.state.st_rs05;

                         console.log("===============================================");
                         console.log("1. eval_fig ? ", this.eval_fig);
                         this.eval_fig = laEvaluacion;
                         console.log("2. eval_fig ? ", this.eval_fig);
                         console.log("===============================================");
                         console.log("3. res_fig ? ", this.res_fig);

                         this.crearPDF_fig();
                         break;
                    case "MOSS":

                         this.eval_moss = store.state.st_ev06;        // Crea el nodo para todos los campos.
                         this.res_moss = store.state.st_rs06;

                         console.log("===============================================");
                         console.log("1. eval_moss ? ", this.eval_moss);
                         this.eval_moss = laEvaluacion;
                         console.log("2. eval_mos ? ", this.eval_moss);
                         console.log("===============================================");
                         console.log("3. res_moss ? ", this.res_moss);

                         this.crearPDF_moss();
                         break;
                    case "TAV":

                         this.eval_tav = store.state.st_ev07;        // Crea el nodo para todos los campos.
                         this.res_tav = store.state.st_rs07;

                         console.log("===============================================");
                         console.log("1. eval_tav ? ", this.eval_tav);
                         this.eval_tav = laEvaluacion;
                         console.log("2. eval_tav ? ", this.eval_tav);
                         console.log("===============================================");
                         console.log("3. res_tav ? ", this.res_tav);

                         this.crearPDF_tav();
                         break;
                    case "SOLEMP":

                         this.eval_solemp = store.state.st_ev08;        // Crea el nodo para todos los campos.
                         this.res_solemp = store.state.st_rs08;

                         console.log("===============================================");
                         console.log("1. eval_solemp ? ", this.eval_solemp);
                         this.eval_solemp = laEvaluacion;
                         console.log("2. eval_solemp ? ", this.eval_solemp);
                         console.log("===============================================");
                         console.log("3. res_solemp ? ", this.res_solemp);

                         this.crearPDF_solemp();
                         break;
                    case "EMOCIONES":

                         this.eval_emoc = store.state.st_ev09;        // Crea el nodo para todos los campos.
                         this.res_emoc = store.state.st_rs09;

                         console.log("===============================================");
                         console.log("1. eval_emoc ? ", this.eval_emoc);
                         this.eval_emoc = laEvaluacion;
                         console.log("2. eval_emoc ? ", this.eval_emoc);
                         console.log("===============================================");
                         console.log("3. res_emoc ? ", this.res_emoc);

                         this.crearPDF_emoc();
                         break;
                    case "ORIENTACION":

                         this.eval_vtas = store.state.st_ev10;        // Crea el nodo para todos los campos.
                         this.res_vtas = store.state.st_rs10;

                         console.log("===============================================");
                         console.log("1. eval_vtas ? ", this.eval_vtas);
                         this.eval_vtas = laEvaluacion;
                         console.log("2. eval_vtas ? ", this.eval_vtas);
                         console.log("===============================================");
                         console.log("3. res_vtas ? ", this.res_vtas);

                         this.crearPDF_vtas2();
                         break;
                    case "AEDP":

                         this.eval_aedp = store.state.st_ev12;        // Crea el nodo para todos los campos.
                         this.res_aedp = store.state.st_rs12;

                         console.log("1. eval_aedp ? ", this.eval_aedp);
                         this.eval_aedp = laEvaluacion;
                         console.log("2. eval_aedp ? ", this.eval_aedp);

                         this.crearPDF_AEDP();

                         break;
     
                    default:
                    // code block
               }

          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_AEDP(){

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_aedp.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "AEDP_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);
               
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(5, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(5, 30, "Evaluación AUTOEXPLORACIÓN EMOCIONAL PARA EL DESARROLLO PERSONAL de " + 
               this.eval_aedp.nombre + " de " + this.eval_aedp.empresa);
               

               this.respuestas_aedp(doc);
               this.resultados_aedp(doc);
               

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');               
          },
               respuestas_aedp(doc){
                    doc.setLineWidth(0.25);

                    doc.text(5, 40, "SECCION DE RESPUESTAS ")
                    doc.line(5, 42, 209, 42);
                    
                    doc.text(5,45,'| Escala |');

                    let colum=16;
                    for (let i = 1; i <= 32; i++) {
                         
                         colum= colum + 2;
                         doc.text(colum, 45, i.toString());
                         colum= colum + 4;
                         doc.text(colum, 45, '|');
                    }                    

                    let espacio= '';

                    //? ESCALA 1
                    doc.line(5,48, 209,48);
                    doc.text(5,51,'|'); doc.text(8,51, '01');
                    doc.text(17,51,'|'); doc.text(19,51,this.eval_aedp.pg001);
                    doc.text(23,51,'|'); doc.text(25,51,this.eval_aedp.pg002);
                    doc.text(29,51,'|'); doc.text(31,51,this.eval_aedp.pg003);
                    doc.text(34,51,'|'); doc.text(36,51,this.eval_aedp.pg004);
                    doc.text(40,51,'|'); doc.text(42,51,this.eval_aedp.pg005);
                    doc.text(46,51,'|'); doc.text(48,51,this.eval_aedp.pg006);
                    doc.text(52,51,'|'); doc.text(54,51,this.eval_aedp.pg007);
                    doc.text(58,51,'|'); doc.text(60,51,this.eval_aedp.pg008);
                    doc.text(64,51,'|'); doc.text(66,51,this.eval_aedp.pg009);
                    doc.text(70,51,'|'); doc.text(72,51,this.eval_aedp.pg010);
                    doc.text(76,51,'|'); doc.text(78,51,this.eval_aedp.pg011);
                    doc.text(82,51,'|'); doc.text(84,51,this.eval_aedp.pg012);
                    doc.text(88,51,'|'); doc.text(90,51,this.eval_aedp.pg013);
                    doc.text(94,51,'|'); doc.text(96,51,this.eval_aedp.pg014);
                    doc.text(100,51,'|'); doc.text(102,51,this.eval_aedp.pg015);
                    doc.text(106,51,'|'); doc.text(108,51,this.eval_aedp.pg016);
                    doc.text(112,51,'|'); doc.text(114,51,this.eval_aedp.pg017);
                    doc.text(118,51,'|'); doc.text(120,51,this.eval_aedp.pg018);
                    doc.text(124,51,'|');
                    doc.line(5, 53, 209, 53);
                    
                    //? ESCALA 2
                    doc.text(5,56,'|'); doc.text(8,56, '02');
                    doc.text(17,56,'|'); doc.text(19,56,this.eval_aedp.pg019);
                    doc.text(23,56,'|'); doc.text(25,56,this.eval_aedp.pg020);
                    doc.text(29,56,'|'); doc.text(31,56,this.eval_aedp.pg021);
                    doc.text(34,56,'|'); doc.text(36,56,this.eval_aedp.pg022);
                    doc.text(40,56,'|'); doc.text(42,56,this.eval_aedp.pg023);
                    doc.text(46,56,'|'); doc.text(48,56,this.eval_aedp.pg024);
                    doc.text(52,56,'|'); doc.text(54,56,this.eval_aedp.pg025);
                    doc.text(58,56,'|'); doc.text(60,56,this.eval_aedp.pg026);
                    doc.text(64,56,'|'); doc.text(66,56,this.eval_aedp.pg027);
                    doc.text(70,56,'|'); doc.text(72,56,this.eval_aedp.pg028);
                    doc.text(76,56,'|'); doc.text(78,56,this.eval_aedp.pg029);
                    doc.text(82,56,'|'); doc.text(84,56,this.eval_aedp.pg030);
                    doc.text(88,56,'|'); doc.text(90,56,this.eval_aedp.pg031);
                    doc.text(94,56,'|'); doc.text(96,56,this.eval_aedp.pg032);
                    doc.text(100,56,'|'); doc.text(102,56,this.eval_aedp.pg033);
                    doc.text(106,56,'|'); doc.text(108,56,this.eval_aedp.pg034);
                    doc.text(112,56,'|'); doc.text(114,56,this.eval_aedp.pg035);
                    doc.text(118,56,'|');                    
                    doc.line(5, 58, 209, 58);

                    //? ESCALA 3
                    doc.text(5,61,'|'); doc.text(8,61, '03');
                    doc.text(17,61,'|'); doc.text(19,61,this.eval_aedp.pg036);
                    doc.text(23,61,'|'); doc.text(25,61,this.eval_aedp.pg037);
                    doc.text(29,61,'|'); doc.text(31,61,this.eval_aedp.pg038);
                    doc.text(34,61,'|'); doc.text(36,61,this.eval_aedp.pg039);
                    doc.text(40,61,'|'); doc.text(42,61,this.eval_aedp.pg040);
                    doc.text(46,61,'|'); doc.text(48,61,this.eval_aedp.pg041);
                    doc.text(52,61,'|'); doc.text(54,61,this.eval_aedp.pg042);
                    doc.text(58,61,'|'); doc.text(60,61,this.eval_aedp.pg043);
                    doc.text(64,61,'|'); doc.text(66,61,this.eval_aedp.pg044);
                    doc.text(70,61,'|'); doc.text(72,61,this.eval_aedp.pg045);
                    doc.text(76,61,'|'); doc.text(78,61,this.eval_aedp.pg046);
                    doc.text(82,61,'|'); doc.text(84,61,this.eval_aedp.pg047);
                    doc.text(88,61,'|'); doc.text(90,61,this.eval_aedp.pg048);
                    doc.text(94,61,'|'); doc.text(96,61,this.eval_aedp.pg049);
                    doc.text(100,61,'|');
                    doc.line(5, 63, 209, 63);

                    //? ESCALA 4
                    doc.text(5,66,'|'); doc.text(8,66, '04');
                    doc.text(17,66,'|'); doc.text(19,66,this.eval_aedp.pg050);
                    doc.text(23,66,'|'); doc.text(25,66,this.eval_aedp.pg051);
                    doc.text(29,66,'|'); doc.text(31,66,this.eval_aedp.pg052);
                    doc.text(34,66,'|'); doc.text(36,66,this.eval_aedp.pg053);
                    doc.text(40,66,'|'); doc.text(42,66,this.eval_aedp.pg054);
                    doc.text(46,66,'|'); doc.text(48,66,this.eval_aedp.pg055);
                    doc.text(52,66,'|'); doc.text(54,66,this.eval_aedp.pg056);
                    doc.text(58,66,'|'); doc.text(60,66,this.eval_aedp.pg057);
                    doc.text(64,66,'|'); doc.text(66,66,this.eval_aedp.pg058);
                    doc.text(70,66,'|'); doc.text(72,66,this.eval_aedp.pg059);
                    doc.text(76,66,'|'); doc.text(78,66,this.eval_aedp.pg060);
                    doc.text(82,66,'|');
                    doc.line(5, 68, 209, 68);
                    //? ESCALA 5
                    doc.text(5,71,'|'); doc.text(8,71, '05');
                    doc.text(17,71,'|'); doc.text(19,71,this.eval_aedp.pg061);
                    doc.text(23,71,'|'); doc.text(25,71,this.eval_aedp.pg062);
                    doc.text(29,71,'|'); doc.text(31,71,this.eval_aedp.pg063);
                    doc.text(34,71,'|'); doc.text(36,71,this.eval_aedp.pg064);
                    doc.text(40,71,'|'); doc.text(42,71,this.eval_aedp.pg065);
                    doc.text(46,71,'|'); doc.text(48,71,this.eval_aedp.pg071);
                    doc.text(52,71,'|'); doc.text(54,71,this.eval_aedp.pg067);
                    doc.text(58,71,'|'); doc.text(60,71,this.eval_aedp.pg068);
                    doc.text(64,71,'|'); doc.text(66,71,this.eval_aedp.pg069);
                    doc.text(70,71,'|');
                    doc.line(5, 73, 209, 73);
                    //? ESCALA 6
                    doc.text(5,76,'|'); doc.text(8,76, '06');
                    doc.text(17,76,'|'); doc.text(19,76,this.eval_aedp.pg070);
                    doc.text(23,76,'|'); doc.text(25,76,this.eval_aedp.pg071);
                    doc.text(29,76,'|'); doc.text(31,76,this.eval_aedp.pg072);
                    doc.text(34,76,'|'); doc.text(36,76,this.eval_aedp.pg073);
                    doc.text(40,76,'|'); doc.text(42,76,this.eval_aedp.pg074);
                    doc.text(46,76,'|'); doc.text(48,76,this.eval_aedp.pg074b);
                    doc.text(52,76,'|'); doc.text(54,76,this.eval_aedp.pg074c);
                    doc.text(58,76,'|'); doc.text(60,76,this.eval_aedp.pg074d);
                    doc.text(64,76,'|'); doc.text(66,76,this.eval_aedp.pg074e);
                    doc.text(70,76,'|'); doc.text(72,76,this.eval_aedp.pg074f);
                    doc.text(76,76,'|'); doc.text(78,76,this.eval_aedp.pg074g);
                    doc.text(82,76,'|'); doc.text(84,76,this.eval_aedp.pg074h);
                    doc.text(88,76,'|'); doc.text(90,76,this.eval_aedp.pg074i);
                    doc.text(94,76,'|');
                    doc.line(5, 78, 209, 78);
                    //? ESCALA 7
                    doc.text(5,81,'|'); doc.text(8,81, '07');
                    doc.text(17,81,'|'); doc.text(19,81,this.eval_aedp.pg075);
                    doc.text(23,81,'|'); doc.text(25,81,this.eval_aedp.pg081);
                    doc.text(29,81,'|'); doc.text(31,81,this.eval_aedp.pg077);
                    doc.text(34,81,'|'); doc.text(36,81,this.eval_aedp.pg078);
                    doc.text(40,81,'|'); doc.text(42,81,this.eval_aedp.pg079);
                    doc.text(46,81,'|'); doc.text(48,81,this.eval_aedp.pg080);
                    doc.text(52,81,'|'); doc.text(54,81,this.eval_aedp.pg081);
                    doc.text(58,81,'|'); doc.text(60,81,this.eval_aedp.pg082);
                    doc.text(64,81,'|'); doc.text(66,81,this.eval_aedp.pg083);
                    doc.text(70,81,'|'); doc.text(72,81,this.eval_aedp.pg084);
                    doc.text(76,81,'|'); doc.text(78,81,this.eval_aedp.pg085);
                    doc.text(82,81,'|'); doc.text(84,81,this.eval_aedp.pg086);
                    doc.text(88,81,'|'); doc.text(90,81,this.eval_aedp.pg087);
                    doc.text(94,81,'|'); doc.text(96,81,this.eval_aedp.pg088);                    
                    doc.text(100,81,'|');
                    doc.line(5, 83, 209, 83);
                    //? ESCALA 8
                    doc.text(5,86,'|'); doc.text(8,86, '08');
                    doc.text(17,86,'|'); doc.text(19,86,this.eval_aedp.pg089);
                    doc.text(23,86,'|'); doc.text(25,86,this.eval_aedp.pg090);
                    doc.text(29,86,'|'); doc.text(31,86,this.eval_aedp.pg091);
                    doc.text(34,86,'|'); doc.text(36,86,this.eval_aedp.pg092);
                    doc.text(40,86,'|'); doc.text(42,86,this.eval_aedp.pg093);
                    doc.text(46,86,'|'); doc.text(48,86,this.eval_aedp.pg094);
                    doc.text(52,86,'|'); doc.text(54,86,this.eval_aedp.pg095);
                    doc.text(58,86,'|'); doc.text(60,86,this.eval_aedp.pg096);
                    doc.text(64,86,'|'); doc.text(66,86,this.eval_aedp.pg097);
                    doc.text(70,86,'|'); doc.text(72,86,this.eval_aedp.pg098);
                    doc.text(76,86,'|');
                    doc.line(5, 88, 209, 88);
                    //? ESCALA 9
                    doc.text(5,91,'|'); doc.text(8,91, '09');
                    doc.text(17,91,'|'); doc.text(19,91,this.eval_aedp.pg099);
                    doc.text(23,91,'|'); doc.text(25,91,this.eval_aedp.pg100);
                    doc.text(29,91,'|'); doc.text(31,91,this.eval_aedp.pg101);
                    doc.text(34,91,'|'); doc.text(36,91,this.eval_aedp.pg102);
                    doc.text(40,91,'|'); doc.text(42,91,this.eval_aedp.pg103);
                    doc.text(46,91,'|'); doc.text(48,91,this.eval_aedp.pg104);
                    doc.text(52,91,'|'); doc.text(54,91,this.eval_aedp.pg105);
                    doc.text(58,91,'|'); doc.text(60,91,this.eval_aedp.pg106);
                    doc.text(64,91,'|'); doc.text(66,91,this.eval_aedp.pg107);
                    doc.text(70,91,'|'); doc.text(72,91,this.eval_aedp.pg108);
                    doc.text(76,91,'|'); doc.text(78,91,this.eval_aedp.pg109);
                    doc.text(82,91,'|'); doc.text(84,91,this.eval_aedp.pg110);
                    doc.text(88,91,'|'); doc.text(90,91,this.eval_aedp.pg111);
                    doc.text(94,91,'|');
                    doc.line(5, 93, 209, 93);
                    //? ESCALA 10
                    doc.text(5,96,'|'); doc.text(8,96, '10');
                    doc.text(17,96,'|'); doc.text(19,96,this.eval_aedp.pg112);
                    doc.text(23,96,'|'); doc.text(25,96,this.eval_aedp.pg113);
                    doc.text(29,96,'|'); doc.text(31,96,this.eval_aedp.pg114);
                    doc.text(34,96,'|'); doc.text(36,96,this.eval_aedp.pg115);
                    doc.text(40,96,'|'); doc.text(42,96,this.eval_aedp.pg116);
                    doc.text(46,96,'|'); doc.text(48,96,this.eval_aedp.pg117);
                    doc.text(52,96,'|'); doc.text(54,96,this.eval_aedp.pg118);
                    doc.text(58,96,'|'); doc.text(60,96,this.eval_aedp.pg119);
                    doc.text(64,96,'|'); doc.text(66,96,this.eval_aedp.pg120);
                    doc.text(70,96,'|'); doc.text(72,96,this.eval_aedp.pg121);
                    doc.text(76,96,'|');
                    doc.line(5, 98, 209, 98);
                    //? ESCALA 11
                    doc.text(5,101,'|'); doc.text(8,101, '11');
                    doc.text(17,101,'|'); doc.text(19,101,this.eval_aedp.pg122);
                    doc.text(23,101,'|'); doc.text(25,101,this.eval_aedp.pg123);
                    doc.text(29,101,'|'); doc.text(31,101,this.eval_aedp.pg124);
                    doc.text(34,101,'|'); doc.text(36,101,this.eval_aedp.pg125);
                    doc.text(40,101,'|'); doc.text(42,101,this.eval_aedp.pg126);
                    doc.text(46,101,'|'); doc.text(48,101,this.eval_aedp.pg127);
                    doc.text(52,101,'|'); doc.text(54,101,this.eval_aedp.pg128);
                    doc.text(58,101,'|'); doc.text(60,101,this.eval_aedp.pg129);
                    doc.text(64,101,'|'); doc.text(66,101,this.eval_aedp.pg130);
                    doc.text(70,101,'|'); doc.text(72,101,this.eval_aedp.pg131);
                    doc.text(76,101,'|'); doc.text(78,101,this.eval_aedp.pg132);
                    doc.text(82,101,'|'); doc.text(84,101,this.eval_aedp.pg133);
                    doc.text(88,101,'|'); doc.text(90,101,this.eval_aedp.pg134);
                    doc.text(94,101,'|');
                    doc.line(5, 103, 209, 103);
                    //? ESCALA 12
                    doc.text(5,106,'|'); doc.text(8,106, '12');
                    doc.text(17,106,'|'); doc.text(19,106,this.eval_aedp.pg135);
                    doc.text(23,106,'|'); doc.text(25,106,this.eval_aedp.pg136);
                    doc.text(29,106,'|'); doc.text(31,106,this.eval_aedp.pg137);
                    doc.text(34,106,'|'); doc.text(36,106,this.eval_aedp.pg138);
                    doc.text(40,106,'|'); doc.text(42,106,this.eval_aedp.pg139);
                    doc.text(46,106,'|'); doc.text(48,106,this.eval_aedp.pg140);
                    doc.text(52,106,'|'); doc.text(54,106,this.eval_aedp.pg141);
                    doc.text(58,106,'|'); doc.text(60,106,this.eval_aedp.pg142);
                    doc.text(64,106,'|'); doc.text(66,106,this.eval_aedp.pg143);
                    doc.text(70,106,'|'); doc.text(72,106,this.eval_aedp.pg144);
                    doc.text(76,106,'|'); doc.text(78,106,this.eval_aedp.pg145);
                    doc.text(82,106,'|'); doc.text(84,106,this.eval_aedp.pg146);
                    doc.text(88,106,'|');
                    doc.line(5, 108, 209, 108);
                    //? ESCALA 13
                    doc.text(5,111,'|'); doc.text(8,111, '13');
                    doc.text(17,111,'|'); doc.text(19,111,this.eval_aedp.pg147);
                    doc.text(23,111,'|'); doc.text(25,111,this.eval_aedp.pg148);
                    doc.text(29,111,'|'); doc.text(31,111,this.eval_aedp.pg149);
                    doc.text(34,111,'|'); doc.text(36,111,this.eval_aedp.pg150);
                    doc.text(40,111,'|'); doc.text(42,111,this.eval_aedp.pg151);
                    doc.text(46,111,'|'); doc.text(48,111,this.eval_aedp.pg152);
                    doc.text(52,111,'|'); doc.text(54,111,this.eval_aedp.pg153);
                    doc.text(58,111,'|'); doc.text(60,111,this.eval_aedp.pg154);
                    doc.text(64,111,'|');
                    doc.line(5, 113, 209, 113);
                    //? ESCALA 14
                    doc.text(5,116,'|'); doc.text(8,116, '14');
                    doc.text(17,116,'|'); doc.text(19,116,this.eval_aedp.pg155);
                    doc.text(23,116,'|'); doc.text(25,116,this.eval_aedp.pg156);
                    doc.text(29,116,'|'); doc.text(31,116,this.eval_aedp.pg157);
                    doc.text(34,116,'|'); doc.text(36,116,this.eval_aedp.pg158);
                    doc.text(40,116,'|'); doc.text(42,116,this.eval_aedp.pg159);
                    doc.text(46,116,'|'); doc.text(48,116,this.eval_aedp.pg160);
                    doc.text(52,116,'|'); doc.text(54,116,this.eval_aedp.pg161);
                    doc.text(58,116,'|'); doc.text(60,116,this.eval_aedp.pg162);
                    doc.text(64,116,'|'); doc.text(66,116,this.eval_aedp.pg163);
                    doc.text(70,116,'|'); doc.text(72,116,this.eval_aedp.pg164);
                    doc.text(76,116,'|'); doc.text(78,116,this.eval_aedp.pg165);
                    doc.text(82,116,'|');
                    doc.line(5, 118, 209, 118);
                    //? ESCALA 15
                    doc.text(5,121,'|'); doc.text(8,121, '15');
                    doc.text(17,121,'|'); doc.text(19,121,this.eval_aedp.pg166);
                    doc.text(23,121,'|'); doc.text(25,121,this.eval_aedp.pg167);
                    doc.text(29,121,'|'); doc.text(31,121,this.eval_aedp.pg168);
                    doc.text(34,121,'|'); doc.text(36,121,this.eval_aedp.pg169);
                    doc.text(40,121,'|'); doc.text(42,121,this.eval_aedp.pg170);
                    doc.text(46,121,'|'); doc.text(48,121,this.eval_aedp.pg171);
                    doc.text(52,121,'|'); doc.text(54,121,this.eval_aedp.pg172);
                    doc.text(58,121,'|'); doc.text(60,121,this.eval_aedp.pg173);
                    doc.text(64,121,'|'); doc.text(66,121,this.eval_aedp.pg174);
                    doc.text(70,121,'|'); doc.text(72,121,this.eval_aedp.pg175);
                    doc.text(76,121,'|');
                    doc.line(5, 123, 209, 123);
                    //? ESCALA 16
                    doc.text(5,126,'|'); doc.text(8,126, '16');
                    doc.text(17,126,'|'); doc.text(19,126,this.eval_aedp.pg176);
                    doc.text(23,126,'|'); doc.text(25,126,this.eval_aedp.pg177);
                    doc.text(29,126,'|'); doc.text(31,126,this.eval_aedp.pg178);
                    doc.text(34,126,'|'); doc.text(36,126,this.eval_aedp.pg179);
                    doc.text(40,126,'|'); doc.text(42,126,this.eval_aedp.pg180);
                    doc.text(46,126,'|'); doc.text(48,126,this.eval_aedp.pg181);
                    doc.text(52,126,'|'); doc.text(54,126,this.eval_aedp.pg182);
                    doc.text(58,126,'|'); doc.text(60,126,this.eval_aedp.pg183);
                    doc.text(64,126,'|'); doc.text(66,126,this.eval_aedp.pg184);
                    doc.text(70,126,'|'); doc.text(72,126,this.eval_aedp.pg185);
                    doc.text(76,126,'|'); doc.text(78,126,this.eval_aedp.pg186);
                    doc.text(82,126,'|'); doc.text(84,126,this.eval_aedp.pg187);
                    doc.text(88,126,'|'); doc.text(90,126,this.eval_aedp.pg188);
                    doc.text(94,126,'|');
                    doc.line(5, 128, 209, 128);
                    //? ESCALA 17
                    doc.text(5,131,'|'); doc.text(8,131, '17');
                    doc.text(17,131,'|'); doc.text(19,131,this.eval_aedp.pg189);
                    doc.text(23,131,'|'); doc.text(25,131,this.eval_aedp.pg190);
                    doc.text(29,131,'|'); doc.text(31,131,this.eval_aedp.pg191);
                    doc.text(34,131,'|'); doc.text(36,131,this.eval_aedp.pg192);
                    doc.text(40,131,'|'); doc.text(42,131,this.eval_aedp.pg193);
                    doc.text(46,131,'|'); doc.text(48,131,this.eval_aedp.pg194);
                    doc.text(52,131,'|'); doc.text(54,131,this.eval_aedp.pg195);
                    doc.text(58,131,'|'); doc.text(60,131,this.eval_aedp.pg196);
                    doc.text(64,131,'|'); doc.text(66,131,this.eval_aedp.pg197);
                    doc.text(70,131,'|');
                    doc.line(5, 133, 209, 133);
                    //? ESCALA 18
                    doc.text(5,136,'|'); doc.text(8,136, '18');
                    doc.text(17,136,'|'); doc.text(19,136,this.eval_aedp.pg198);
                    doc.text(23,136,'|'); doc.text(25,136,this.eval_aedp.pg199);
                    doc.text(29,136,'|'); doc.text(31,136,this.eval_aedp.pg200);
                    doc.text(34,136,'|'); doc.text(36,136,this.eval_aedp.pg201);
                    doc.text(40,136,'|'); doc.text(42,136,this.eval_aedp.pg202);
                    doc.text(46,136,'|'); doc.text(48,136,this.eval_aedp.pg203);
                    doc.text(52,136,'|'); doc.text(54,136,this.eval_aedp.pg204);
                    doc.text(58,136,'|'); doc.text(60,136,this.eval_aedp.pg205);
                    doc.text(64,136,'|'); doc.text(66,136,this.eval_aedp.pg206);
                    doc.text(70,136,'|'); doc.text(72,136,this.eval_aedp.pg207);
                    doc.text(76,136,'|'); doc.text(78,136,this.eval_aedp.pg208);
                    doc.text(82,136,'|'); doc.text(84,136,this.eval_aedp.pg209);
                    doc.text(88,136,'|'); doc.text(90,136,this.eval_aedp.pg210);
                    doc.text(94,136,'|'); doc.text(96,136,this.eval_aedp.pg211);
                    doc.text(100,136,'|'); doc.text(102,136,this.eval_aedp.pg212);
                    doc.text(106,136,'|'); doc.text(108,136,this.eval_aedp.pg213);
                    doc.text(112,136,'|'); doc.text(114,136,this.eval_aedp.pg214);
                    doc.text(118,136,'|'); doc.text(120,136,this.eval_aedp.pg215);
                    doc.text(124,136,'|'); doc.text(126,136,this.eval_aedp.pg216);
                    doc.text(130,136,'|'); doc.text(132,136,this.eval_aedp.pg217);
                    doc.text(136,136,'|'); doc.text(138,136,this.eval_aedp.pg218);
                    doc.text(142,136,'|'); doc.text(144,136,this.eval_aedp.pg219); //*22
                    doc.text(148,136,'|'); doc.text(150,136,this.eval_aedp.pg220);
                    doc.text(154,136,'|'); doc.text(156,136,this.eval_aedp.pg221);
                    doc.text(160,136,'|'); doc.text(162,136,this.eval_aedp.pg222);
                    doc.text(166,136,'|'); doc.text(168,136,this.eval_aedp.pg223);
                    doc.text(172,136,'|'); doc.text(174,136,this.eval_aedp.pg224);
                    doc.text(178,136,'|'); doc.text(180,136,this.eval_aedp.pg225);
                    doc.text(184,136,'|'); doc.text(186,136,this.eval_aedp.pg226);
                    doc.text(190,136,'|'); doc.text(192,136,this.eval_aedp.pg227);
                    doc.text(196,136,'|'); doc.text(198,136,this.eval_aedp.pg228);
                    doc.text(202,136,'|'); doc.text(204,136,this.eval_aedp.pg229);
                    doc.text(208,136,'|');
                    doc.line(5, 138, 209, 138);
                    //? ESCALA 19
                    doc.text(5,141,'|'); doc.text(8,141, '19');
                    doc.text(17,141,'|'); doc.text(19,141,this.eval_aedp.pg230);
                    doc.text(23,141,'|'); doc.text(25,141,this.eval_aedp.pg231);
                    doc.text(29,141,'|'); doc.text(31,141,this.eval_aedp.pg232);
                    doc.text(34,141,'|'); doc.text(36,141,this.eval_aedp.pg233);
                    doc.text(40,141,'|'); doc.text(42,141,this.eval_aedp.pg234);
                    doc.text(46,141,'|'); doc.text(48,141,this.eval_aedp.pg235);
                    doc.text(52,141,'|'); doc.text(54,141,this.eval_aedp.pg236);
                    doc.text(58,141,'|'); doc.text(60,141,this.eval_aedp.pg237);
                    doc.text(64,141,'|'); doc.text(66,141,this.eval_aedp.pg238);
                    doc.text(70,141,'|'); doc.text(72,141,this.eval_aedp.pg239);
                    doc.text(76,141,'|'); doc.text(78,141,this.eval_aedp.pg240);
                    doc.text(82,141,'|');
                    doc.line(5, 143, 209, 143);
                    //? ESCALA 20
                    doc.text(5,146,'|'); doc.text(8,146, '20');
                    doc.text(17,146,'|'); doc.text(19,146,this.eval_aedp.pg241);
                    doc.text(23,146,'|'); doc.text(25,146,this.eval_aedp.pg242);
                    doc.text(29,146,'|'); doc.text(31,146,this.eval_aedp.pg243);
                    doc.text(34,146,'|'); doc.text(36,146,this.eval_aedp.pg244);
                    doc.text(40,146,'|'); doc.text(42,146,this.eval_aedp.pg245);
                    doc.text(46,146,'|'); doc.text(48,146,this.eval_aedp.pg246);
                    doc.text(52,146,'|'); doc.text(54,146,this.eval_aedp.pg247);
                    doc.text(58,146,'|');
                    doc.line(5, 148, 209, 148);
                    //? ESCALA 21
                    doc.text(5,151,'|'); doc.text(8,151, '21');
                    doc.text(17,151,'|'); doc.text(19,151,this.eval_aedp.pg248);
                    doc.text(23,151,'|'); doc.text(25,151,this.eval_aedp.pg249);
                    doc.text(29,151,'|'); doc.text(31,151,this.eval_aedp.pg250);
                    doc.text(34,151,'|'); doc.text(36,151,this.eval_aedp.pg251);
                    doc.text(40,151,'|'); doc.text(42,151,this.eval_aedp.pg252);
                    doc.text(46,151,'|'); doc.text(48,151,this.eval_aedp.pg253);
                    doc.text(52,151,'|'); doc.text(54,151,this.eval_aedp.pg254);
                    doc.text(58,151,'|');
                    doc.line(5, 153, 209, 153);

               },
               resultados_aedp(doc){
                    doc.text(5, 160, "SECCION DE RESULTADOS ")
                    doc.line(5, 161, 209, 161);
                    doc.text(5, 164,'| Dimensión Conocimiento | ÓPTIMO | DIESTRO | VULNERABLE | CAUTELA | Puntaje  | Zona    de     |  Categorías    Total       |');
                    doc.text(5, 167,'| Emocional');
                    doc.text(43,167, '|');
                    doc.text(56,167,'Puntaje Máximo y Puntaje Mínimo');
                    doc.text(116,167,'|');
                    doc.text(117,167,'Obtenido');
                    doc.text(130,167,'|');
                    doc.text(132,167,'Rendimiento');
                    doc.text(150,167,'|');
                    doc.text(152,167,'Inteligencia Emocional');
                    doc.text(185,167,'|');
                    doc.line(5, 169, 209, 169);

                    //? .....................................................................................................................................
                    this.json_data= [];
                    let registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };
                    //? .....................................................................................................................................
                    //? ESCALA 1: SUCESOS DE LA VIDA
                    doc.text(5, 172, '|');
                    doc.text(7, 172, 'Sucesos de');
                    doc.text(43,172, '|');
                    doc.text(48,172, '0');
                    doc.text(59,172, '|');
                    doc.text(63,172, '3');
                    doc.text(75,172, '|');
                    doc.text(80,172, '8');
                    doc.text(98,172, '|');
                    doc.text(103,172, '16');
                    doc.text(116,172,'|');
                    let sumaE1= 0;
                    let pg001=parseInt(this.eval_aedp.pg001); let pg002=parseInt(this.eval_aedp.pg002); let pg003=parseInt(this.eval_aedp.pg003);
                    let pg004=parseInt(this.eval_aedp.pg004); let pg005=parseInt(this.eval_aedp.pg005); let pg006=parseInt(this.eval_aedp.pg006);
                    let pg007=parseInt(this.eval_aedp.pg007); let pg008=parseInt(this.eval_aedp.pg008); let pg009=parseInt(this.eval_aedp.pg009);
                    let pg010=parseInt(this.eval_aedp.pg010); let pg011=parseInt(this.eval_aedp.pg011); let pg012=parseInt(this.eval_aedp.pg012);
                    let pg013=parseInt(this.eval_aedp.pg013); let pg014=parseInt(this.eval_aedp.pg014); let pg015=parseInt(this.eval_aedp.pg015);
                    let pg016=parseInt(this.eval_aedp.pg016); let pg017=parseInt(this.eval_aedp.pg017); let pg018=parseInt(this.eval_aedp.pg018);
                    sumaE1=pg001 + pg002 + pg003 + pg004 + pg005 + pg006 + pg007 + pg008 + pg009 + pg010 + pg011 + pg012 + pg013 + pg014 + 
                              pg015 + pg016 + pg017 + pg018; 
                    let st_sumaE1=sumaE1.toString();
                    doc.text(119,172,st_sumaE1);
                    doc.text(130,172,'|');
                    let desc_E1='';
                    if (sumaE1<=2){
                         desc_E1='Óptimo'
                         registro.optimo=sumaE1;
                    } else {
                         if (sumaE1>=3 &&sumaE1<=7){
                              desc_E1='Diestro';
                              registro.diestro=sumaE1;
                         } else{
                              if (sumaE1>=8 &&sumaE1<=15){
                                   desc_E1='Vulnerable';
                                   registro.vulnerable=sumaE1;
                              } else {
                                   desc_E1='Cautela';
                                   registro.cautela=sumaE1;
                              }      
                         }
                    };
                    registro.variable='Sucesos de la Vida';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    console.log('que hay en json_data ahora ? ');
                    console.log(this.json_data);

                    doc.text(133,172,desc_E1);
                    doc.text(150,172,'|');
                    doc.text(185,172,'|');
                    doc.line(43, 173, 117, 173);

                    doc.text(5, 176, '|');
                    doc.text(7, 176, 'la vida');
                    doc.text(43,176, '|');
                    doc.text(48,176, '2');
                    doc.text(59,176, '|');
                    doc.text(63,176, '7');
                    doc.text(75,176, '|');
                    doc.text(80,176, '15');
                    doc.text(98,176, '|');
                    doc.text(103,176, '54');
                    doc.text(116,176,'|');
                    doc.text(130,176,'|');
                    doc.text(150,176,'|');
                    doc.text(185,176,'|');
                    doc.line(5, 177, 151, 177);
                    //? .....................................................................................................................................
                    //? ESCALA 2: PRESIONES DEL TRABAJO
                    doc.text(5, 180, '|');
                    doc.text(7, 180, 'Presiones del');
                    doc.text(43,180, '|');
                    doc.text(48,180, '0');
                    doc.text(59,180, '|');
                    doc.text(63,180, '7');
                    doc.text(75,180, '|');
                    doc.text(80,180, '14');
                    doc.text(98,180, '|');
                    doc.text(103,180, '21');
                    doc.text(116,180,'|');

                    let sumaE2= 0;
                    let pg019=parseInt(this.eval_aedp.pg019); let pg020=parseInt(this.eval_aedp.pg020); let pg021=parseInt(this.eval_aedp.pg021);
                    let pg022=parseInt(this.eval_aedp.pg022); let pg023=parseInt(this.eval_aedp.pg023); let pg024=parseInt(this.eval_aedp.pg024);
                    let pg025=parseInt(this.eval_aedp.pg025); let pg026=parseInt(this.eval_aedp.pg026); let pg027=parseInt(this.eval_aedp.pg027);
                    let pg028=parseInt(this.eval_aedp.pg028); let pg029=parseInt(this.eval_aedp.pg029); let pg030=parseInt(this.eval_aedp.pg030);
                    let pg031=parseInt(this.eval_aedp.pg031); let pg032=parseInt(this.eval_aedp.pg032); let pg033=parseInt(this.eval_aedp.pg033);
                    let pg034=parseInt(this.eval_aedp.pg034); let pg035=parseInt(this.eval_aedp.pg035); 
                    sumaE2=pg019 + pg020 + pg021 + pg022 + pg023 + pg024 + pg025 + pg026 + pg027 + pg028 + 
                              pg029 + pg030 + pg031 + pg032 + pg033 + pg034 + pg035; 
                    let st_sumaE2=sumaE2.toString();
                    doc.text(119,180,st_sumaE2);
                    doc.text(130,180,'|');
                    let desc_E2='';
                    if (sumaE2<=6){
                         desc_E2='Óptimo';
                         registro.optimo=sumaE2;
                    } else {
                         if (sumaE2>=7 &&sumaE2<=13){
                              desc_E2='Diestro';
                              registro.diestro=sumaE2;                              
                         } else{
                              if (sumaE2>=14 &&sumaE2<=20){
                                   desc_E2='Vulnerable';
                                   registro.vulnerable=sumaE2;                                   
                              } else {
                                   desc_E2='Cautela';
                                   registro.cautela=sumaE2;                                   
                              }      
                         }
                    };
                    registro.variable='Presiones del trabajo';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,180,desc_E2);
                    doc.text(150,180,'|');
                    doc.text(185,180,'|');
                    doc.line(43, 181, 117, 181);

                    doc.text(5, 184, '|');
                    doc.text(7, 184, 'trabajo');
                    doc.text(43,184, '|');
                    doc.text(48,184, '6');
                    doc.text(59,184, '|');
                    doc.text(63,184, '13');
                    doc.text(75,184, '|');
                    doc.text(80,184, '20');
                    doc.text(98,184, '|');
                    doc.text(103,184, '51');
                    doc.text(116,184,'|');
                    doc.text(130,184,'|');
                    doc.text(150,184,'|');
                    doc.text(185,184,'|');
                    doc.line(5, 185, 151, 185);
                    //? .....................................................................................................................................
                    //? ESCALA 3: PRESIONES PERSONALES
                    doc.text(5, 188, '|');
                    doc.text(7, 188, 'Presiones');
                    doc.text(43,188, '|');
                    doc.text(48,188, '0');
                    doc.text(59,188, '|');
                    doc.text(63,188, '3');
                    doc.text(75,188, '|');
                    doc.text(80,188, '8');
                    doc.text(98,188, '|');
                    doc.text(103,188, '15');
                    doc.text(116,188,'|');

                    let sumaE3= 0;
                    let pg036=parseInt(this.eval_aedp.pg036); let pg037=parseInt(this.eval_aedp.pg037); let pg038=parseInt(this.eval_aedp.pg038);
                    let pg039=parseInt(this.eval_aedp.pg039); let pg040=parseInt(this.eval_aedp.pg040); let pg041=parseInt(this.eval_aedp.pg041);
                    let pg042=parseInt(this.eval_aedp.pg042); let pg043=parseInt(this.eval_aedp.pg043); let pg044=parseInt(this.eval_aedp.pg044);
                    let pg045=parseInt(this.eval_aedp.pg045); let pg046=parseInt(this.eval_aedp.pg046); let pg047=parseInt(this.eval_aedp.pg047);
                    let pg048=parseInt(this.eval_aedp.pg048); let pg049=parseInt(this.eval_aedp.pg049); 
                    sumaE3=pg036 + pg037 + pg038 + pg039 + pg040 + pg041 + pg042 + pg043 + pg044 + pg045 + 
                              pg046 + pg047 + pg048 + pg049; 
                    let st_sumaE3=sumaE3.toString();
                    doc.text(119,188,st_sumaE3);
                    doc.text(130,188,'|');
                    let desc_E3='';
                    if (sumaE3<=2){
                         desc_E3='Óptimo';
                         registro.optimo=sumaE3;
                    } else {
                         if (sumaE3>=3 &&sumaE3<=7){
                              desc_E3='Diestro'
                              registro.diestro=sumaE3;
                         } else{
                              if (sumaE3>=8 &&sumaE3<=14){
                                   desc_E3='Vulnerable';
                                   registro.vulnerable=sumaE3;
                              } else {
                                   desc_E3='Cautela';
                                   registro.cautela=sumaE3;
                              }      
                         }
                    };
                    registro.variable='Presiones personales';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,188,desc_E3);
                    doc.text(150,188,'|');
                    doc.text(185,188,'|');
                    doc.line(43, 189, 117, 189);

                    doc.text(5, 192, '|');
                    doc.text(7, 192, 'personales');
                    doc.text(43,192, '|');
                    doc.text(48,192, '2');
                    doc.text(59,192, '|');
                    doc.text(63,192, '7');
                    doc.text(75,192, '|');
                    doc.text(80,192, '14');
                    doc.text(98,192, '|');
                    doc.text(103,192, '42');
                    doc.text(116,192,'|');
                    doc.text(130,192,'|');
                    doc.text(150,192,'|');
                    doc.text(185,192,'|');
                    doc.line(5, 193, 209, 193);
                    //? .....................................................................................................................................
                    //? ESCALA 4: CONOCIMIENTO DE SÍ MISMO
                    doc.text(5, 196, '|');
                    doc.text(7, 196, 'Conocimiento');
                    doc.text(43,196, '|');
                    doc.text(48,196, '33');
                    doc.text(59,196, '|');
                    doc.text(63,196, '28');
                    doc.text(75,196, '|');
                    doc.text(80,196, '23');
                    doc.text(98,196, '|');
                    doc.text(103,196, '18');
                    doc.text(116,196,'|');

                    let sumaE4= 0;
                    let pg050=parseInt(this.eval_aedp.pg050); let pg051=parseInt(this.eval_aedp.pg051); let pg052=parseInt(this.eval_aedp.pg052);
                    let pg053=parseInt(this.eval_aedp.pg053); let pg054=parseInt(this.eval_aedp.pg054); let pg055=parseInt(this.eval_aedp.pg055);
                    let pg056=parseInt(this.eval_aedp.pg056); let pg057=parseInt(this.eval_aedp.pg057); let pg058=parseInt(this.eval_aedp.pg058);
                    let pg059=parseInt(this.eval_aedp.pg059); let pg060=parseInt(this.eval_aedp.pg060); 
                    // console.log('Escala 4: ',pg050,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE4=pg050 + pg051 + pg052 + pg053 + pg054 + pg055 + pg056 + pg057 + pg058 + pg059 + pg060;
                    let st_sumaE4=sumaE4.toString();
                    doc.text(119,196,st_sumaE4);
                    doc.text(130,196,'|');
                    let desc_E4='';
                    if (sumaE4>=29 &&sumaE4<=33){
                         desc_E4='Óptimo';
                         registro.optimo=sumaE4;
                    } else {
                         if (sumaE4>=24 &&sumaE4<=28){
                              desc_E4='Diestro';
                              registro.diestro=sumaE4;                              
                         } else{
                              if (sumaE4>=19 &&sumaE4<=23){
                                   desc_E4='Vulnerable';
                                   registro.vulnerable=sumaE4;                                   
                              } else {
                                   desc_E4='Cautela';
                                   registro.cautela=sumaE4;                                   
                              }      
                         }
                    };
                    registro.variable='Conocimiento de sí mismo';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };
                    
                    doc.text(133,196,desc_E4);
                    doc.text(150,196,'|');
                    doc.text(185,196,'|');
                    doc.line(43, 197, 117, 197);

                    doc.text(5, 200, '|');
                    doc.text(7, 200, 'de sí mismo');
                    doc.text(43,200, '|');
                    doc.text(48,200, '29');
                    doc.text(59,200, '|');
                    doc.text(63,200, '24');
                    doc.text(75,200, '|');
                    doc.text(80,200, '19');
                    doc.text(98,200, '|');
                    doc.text(103,200, '0');
                    doc.text(116,200,'|');
                    doc.text(130,200,'|');
                    doc.text(150,200,'|');
                    doc.text(185,200,'|');
                    doc.line(5, 201, 151, 201);
                    //? .....................................................................................................................................
                    //? ESCALA 5: EXPRESIÓN EMOCIONAL
                    doc.text(5, 204, '|');
                    doc.text(7, 204, 'Expresión');
                    doc.text(43,204, '|');
                    doc.text(48,204, '27');
                    doc.text(59,204, '|');
                    doc.text(63,204, '19');
                    doc.text(75,204, '|');
                    doc.text(80,204, '16');
                    doc.text(98,204, '|');
                    doc.text(103,204, '12');
                    doc.text(116,204,'|');

                    let sumaE5= 0;
                    let pg061=parseInt(this.eval_aedp.pg061); let pg062=parseInt(this.eval_aedp.pg062); let pg063=parseInt(this.eval_aedp.pg063);
                    let pg064=parseInt(this.eval_aedp.pg064); let pg065=parseInt(this.eval_aedp.pg065); let pg066=parseInt(this.eval_aedp.pg066);
                    let pg067=parseInt(this.eval_aedp.pg067); let pg068=parseInt(this.eval_aedp.pg068); let pg069=parseInt(this.eval_aedp.pg069);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE5=pg061 + pg062 + pg063 + pg064 + pg065 + pg066 + pg067 + pg068 + pg069;
                    let st_sumaE5=sumaE5.toString();
                    doc.text(119,204,st_sumaE5);
                    doc.text(130,204,'|');
                    let desc_E5='';
                    if (sumaE5>=20 &&sumaE5<=27){
                         desc_E5='Óptimo';
                         registro.optimo=sumaE5;
                    } else {
                         if (sumaE5>=17 &&sumaE5<=19){
                              desc_E5='Diestro'
                              registro.diestro=sumaE5;
                         } else{
                              if (sumaE5>=13 &&sumaE5<=16){
                                   desc_E5='Vulnerable';
                                   registro.vulnerable=sumaE5;
                              } else {
                                   desc_E5='Cautela';
                                   registro.cautela=sumaE5;
                              }      
                         }
                    }
                    registro.variable='Expresión emocional';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };
                    
                    doc.text(133,204,desc_E5);
                    doc.text(150,204,'|');
                    doc.text(185,204,'|');
                    doc.line(43, 205, 117, 205);

                    doc.text(5, 208, '|');
                    doc.text(7, 208, 'emocional');
                    doc.text(43,208, '|');
                    doc.text(48,208, '20');
                    doc.text(59,208, '|');
                    doc.text(63,208, '17');
                    doc.text(75,208, '|');
                    doc.text(80,208, '13');
                    doc.text(98,208, '|');
                    doc.text(103,208, '0');
                    doc.text(116,208,'|');
                    doc.text(130,208,'|');
                    doc.text(150,208,'|');
                    doc.text(185,208,'|');
                    doc.line(5, 209, 151, 209);
                    //? .....................................................................................................................................
                    //? ESCALA 6: CONCIENCIA EMOCIONAL DE OTROS
                    doc.text(5, 212, '|');
                    doc.text(7, 212, 'Conciencia emocional');
                    doc.text(43,212, '|');
                    doc.text(48,212, '39');
                    doc.text(59,212, '|');
                    doc.text(63,212, '27');
                    doc.text(75,212, '|');
                    doc.text(80,212, '21');
                    doc.text(98,212, '|');
                    doc.text(103,212, '14');
                    doc.text(116,212,'|');

                    let sumaE6= 0;
                    let pg070=parseInt(this.eval_aedp.pg070); let pg071=parseInt(this.eval_aedp.pg071); let pg072=parseInt(this.eval_aedp.pg072);
                    let pg073=parseInt(this.eval_aedp.pg073); let pg074=parseInt(this.eval_aedp.pg074);
                    let pg074b=parseInt(this.eval_aedp.pg074b); let pg074c=parseInt(this.eval_aedp.pg074c); let pg074d=parseInt(this.eval_aedp.pg074d); 
                    let pg074e=parseInt(this.eval_aedp.pg074e); let pg074f=parseInt(this.eval_aedp.pg074f); let pg074g=parseInt(this.eval_aedp.pg074g);
                    let pg074h=parseInt(this.eval_aedp.pg074h); let pg074i=parseInt(this.eval_aedp.pg074i);  

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE6=pg070 + pg071 + pg072 + pg073 + pg074 + 
                              pg074b + pg074c + pg074d + pg074e + pg074f + pg074g + pg074h + pg074i;
                    let st_sumaE6=sumaE6.toString();
                    doc.text(119,212,st_sumaE6);
                    doc.text(130,212,'|');
                    let desc_E6='';
                    if (sumaE6>=28 &&sumaE6<=39){
                         desc_E6='Óptimo';
                         registro.optimo=sumaE6;
                    } else {
                         if (sumaE6>=22 &&sumaE6<=27){
                              desc_E6='Diestro';
                              registro.diestro=sumaE6;
                         } else{
                              if (sumaE6>=15 &&sumaE6<=21){
                                   desc_E6='Vulnerable';
                                   registro.vulnerable=sumaE6;
                              } else {
                                   desc_E6='Cautela';
                                   registro.cautela=sumaE6;
                              }      
                         }
                    };
                    registro.variable='Conciencia emocional';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,212,desc_E6);
                    doc.text(150,212,'|');
                    doc.text(185,212,'|');
                    doc.line(43, 213, 117, 213);

                    doc.text(5, 216, '|');
                    doc.text(7, 216, 'de otros');
                    doc.text(43,216, '|');
                    doc.text(48,216, '28');
                    doc.text(59,216, '|');
                    doc.text(63,216, '22');
                    doc.text(75,216, '|');
                    doc.text(80,216, '15');
                    doc.text(98,216, '|');
                    doc.text(103,216, '0');
                    doc.text(116,216,'|');
                    doc.text(130,216,'|');
                    doc.text(150,216,'|');
                    doc.text(185,216,'|');
                    doc.line(5, 217, 209, 217);
                    //? .....................................................................................................................................
                    //? ESCALA 7: INTENCIÓN
                    doc.text(5, 220, '|');
                    doc.text(7, 220, 'Intención');
                    doc.text(43,220, '|');
                    doc.text(48,220, '42');
                    doc.text(59,220, '|');
                    doc.text(63,220, '32');
                    doc.text(75,220, '|');
                    doc.text(80,220, '26');
                    doc.text(98,220, '|');
                    doc.text(103,220, '20');
                    doc.text(116,220,'|');

                    let sumaE7= 0;
                    let pg075=parseInt(this.eval_aedp.pg075); let pg076=parseInt(this.eval_aedp.pg076); let pg077=parseInt(this.eval_aedp.pg077);
                    let pg078=parseInt(this.eval_aedp.pg078);
                    let pg079=parseInt(this.eval_aedp.pg079); let pg080=parseInt(this.eval_aedp.pg080); let pg081=parseInt(this.eval_aedp.pg081);
                    let pg082=parseInt(this.eval_aedp.pg082); let pg083=parseInt(this.eval_aedp.pg083); let pg084=parseInt(this.eval_aedp.pg084);
                    let pg085=parseInt(this.eval_aedp.pg085); let pg086=parseInt(this.eval_aedp.pg086); let pg087=parseInt(this.eval_aedp.pg087);
                    let pg088=parseInt(this.eval_aedp.pg088); 

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE7=pg075 + pg076 + pg077 + pg078 + pg079 + pg080 + pg081 + pg082 + pg083 + pg084 + pg085 + pg086 + pg087 + pg088;
                    let st_sumaE7=sumaE7.toString();
                    doc.text(119,220,st_sumaE7);
                    doc.text(130,220,'|');
                    let desc_E7='';
                    if (sumaE7>=33 &&sumaE7<=42){
                         desc_E7='Óptimo';
                         registro.optimo=sumaE7;
                    } else {
                         if (sumaE7>=27 &&sumaE7<=32){
                              desc_E7='Diestro';
                              registro.diestro=sumaE7;
                         } else{
                              if (sumaE7>=21 &&sumaE7<=26){
                                   desc_E7='Vulnerable';
                                   registro.vulnerable=sumaE7;
                              } else {
                                   desc_E7='Cautela';
                                   registro.cautela=sumaE7;
                              }      
                         }
                    };
                    registro.variable='Intención';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,220,desc_E7);
                    doc.text(150,220,'|');
                    doc.text(185,220,'|');
                    doc.line(43, 221, 117, 221);

                    doc.text(5, 224, '|');
                    doc.text(7, 224, ' ');
                    doc.text(43,224, '|');
                    doc.text(48,224, '33');
                    doc.text(59,224, '|');
                    doc.text(63,224, '27');
                    doc.text(75,224, '|');
                    doc.text(80,224, '21');
                    doc.text(98,224, '|');
                    doc.text(103,224, '0');
                    doc.text(116,224,'|');
                    doc.text(130,224,'|');
                    doc.text(150,224,'|');
                    doc.text(185,224,'|');
                    doc.line(5, 225, 151, 225);
                    //? .....................................................................................................................................
                    //? ESCALA 8: CREATIVIDAD
                    doc.text(5, 228, '|');
                    doc.text(7, 228, 'Creatividad');
                    doc.text(43,228, '|');
                    doc.text(48,228, '30');
                    doc.text(59,228, '|');
                    doc.text(63,228, '23');
                    doc.text(75,228, '|');
                    doc.text(80,228, '18');
                    doc.text(98,228, '|');
                    doc.text(103,228, '14');
                    doc.text(116,228,'|');

                    let sumaE8= 0;
                    let pg089=parseInt(this.eval_aedp.pg089); let pg090=parseInt(this.eval_aedp.pg090); let pg091=parseInt(this.eval_aedp.pg091);
                    let pg092=parseInt(this.eval_aedp.pg092); let pg093=parseInt(this.eval_aedp.pg093); let pg094=parseInt(this.eval_aedp.pg094); 
                    let pg095=parseInt(this.eval_aedp.pg095); let pg096=parseInt(this.eval_aedp.pg096); let pg097=parseInt(this.eval_aedp.pg097); 
                    let pg098=parseInt(this.eval_aedp.pg098);

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE8=pg089 + pg090 + pg091 + pg092 + pg093 + pg094 + pg095 + pg096 + pg097 + pg098;
                    let st_sumaE8=sumaE8.toString();
                    doc.text(119,228,st_sumaE8);
                    doc.text(130,228,'|');
                    let desc_E8='';
                    if (sumaE8>=24 &&sumaE8<=30){
                         desc_E8='Óptimo';
                         registro.optimo=sumaE8;
                    } else {
                         if (sumaE8>=19 &&sumaE8<=23){
                              desc_E8='Diestro';
                              registro.diestro=sumaE8;
                         } else{
                              if (sumaE8>=13 &&sumaE8<=18){
                                   desc_E8='Vulnerable';
                                   registro.vulnerable=sumaE8;
                              } else {
                                   desc_E8='Cautela';
                                   registro.cautela=sumaE8;
                              }      
                         }
                    };
                    registro.variable='Creatividad';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,228,desc_E8);
                    doc.text(150,228,'|');
                    doc.text(185,228,'|');
                    doc.line(43, 229, 117, 229);

                    doc.text(5, 232, '|');
                    doc.text(7, 232, ' ');
                    doc.text(43,232, '|');
                    doc.text(48,232, '24');
                    doc.text(59,232, '|');
                    doc.text(63,232, '19');
                    doc.text(75,232, '|');
                    doc.text(80,232, '13');
                    doc.text(98,232, '|');
                    doc.text(103,232, '0');
                    doc.text(116,232,'|');
                    doc.text(130,232,'|');
                    doc.text(150,232,'|');
                    doc.text(185,232,'|');
                    doc.line(5, 233, 151, 233);

                    //? .....................................................................................................................................
                    //? ESCALA 9: FLEXIBILIDAD
                    doc.text(5, 236, '|');
                    doc.text(7, 236, 'Flexibilidad');
                    doc.text(43,236, '|');
                    doc.text(48,236, '39');
                    doc.text(59,228, '|');
                    doc.text(63,236, '33');
                    doc.text(75,236, '|');
                    doc.text(80,236, '27');
                    doc.text(98,236, '|');
                    doc.text(103,236, '20');
                    doc.text(116,236,'|');

                    let sumaE9= 0;
                    let pg099=parseInt(this.eval_aedp.pg099); let pg100=parseInt(this.eval_aedp.pg100); let pg101=parseInt(this.eval_aedp.pg101);
                    let pg102=parseInt(this.eval_aedp.pg092); let pg103=parseInt(this.eval_aedp.pg103); let pg104=parseInt(this.eval_aedp.pg104); 
                    let pg105=parseInt(this.eval_aedp.pg105); let pg106=parseInt(this.eval_aedp.pg106); let pg107=parseInt(this.eval_aedp.pg107); 
                    let pg108=parseInt(this.eval_aedp.pg108); let pg109=parseInt(this.eval_aedp.pg109); let pg110=parseInt(this.eval_aedp.pg110);
                    let pg111=parseInt(this.eval_aedp.pg111);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE9=pg099 + pg100 + pg101 + pg102 + pg103 + pg104 + pg105 + pg106 + pg107 + pg108 + pg109 + pg110 + pg111;
                    let st_sumaE9=sumaE9.toString();
                    doc.text(119,236,st_sumaE9);
                    doc.text(130,236,'|');
                    let desc_E9='';
                    if (sumaE9>=34 &&sumaE9<=39){
                         desc_E9='Óptimo';
                         registro.optimo=sumaE9;
                    } else {
                         if (sumaE9>=28 &&sumaE9<=33){
                              desc_E9='Diestro';
                              registro.diestro=sumaE9;
                         } else{
                              if (sumaE9>=21 &&sumaE9<=27){
                                   desc_E9='Vulnerable';
                                   registro.vulnerable=sumaE9;
                              } else {
                                   desc_E9='Cautela';
                                   registro.cautela=sumaE9;
                              }      
                         }
                    };
                    registro.variable='Flexibilidad';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,236,desc_E9);
                    doc.text(150,236,'|');
                    doc.text(185,236,'|');
                    doc.line(43, 237, 117, 237);

                    doc.text(5, 240, '|');
                    doc.text(7, 240, ' ');
                    doc.text(43,240, '|');
                    doc.text(48,240, '34');
                    doc.text(59,240, '|');
                    doc.text(63,240, '28');
                    doc.text(75,240, '|');
                    doc.text(80,240, '21');
                    doc.text(98,240, '|');
                    doc.text(103,240, '0');
                    doc.text(116,240,'|');
                    doc.text(130,240,'|');
                    doc.text(150,240,'|');
                    doc.text(185,240,'|');
                    doc.line(5, 241, 151, 241);
                    //? .....................................................................................................................................
                    //? ESCALA 10: CONEXIONES INTERPERSONALES
                    doc.text(5, 244, '|');
                    doc.text(7, 244, 'Conexiones');
                    doc.text(43,244, '|');
                    doc.text(48,244, '30');
                    doc.text(59,244, '|');
                    doc.text(63,244, '27');
                    doc.text(75,244, '|');
                    doc.text(80,244, '22');
                    doc.text(98,244, '|');
                    doc.text(103,244, '17');
                    doc.text(116,244,'|');

                    let sumaE10= 0;
                    let pg112=parseInt(this.eval_aedp.pg112); let pg113=parseInt(this.eval_aedp.pg113); let pg114=parseInt(this.eval_aedp.pg114); 
                    let pg115=parseInt(this.eval_aedp.pg115); let pg116=parseInt(this.eval_aedp.pg116); let pg117=parseInt(this.eval_aedp.pg117); 
                    let pg118=parseInt(this.eval_aedp.pg118); let pg119=parseInt(this.eval_aedp.pg119); let pg120=parseInt(this.eval_aedp.pg120);
                    let pg121=parseInt(this.eval_aedp.pg121);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE10=pg112 + pg113 + pg114 + pg115 + pg116 + pg117 + pg118 + pg119 + pg120 + pg121;
                    let st_sumaE10=sumaE10.toString();
                    doc.text(119,244,st_sumaE10);
                    doc.text(130,244,'|');
                    let desc_E10='';
                    if (sumaE10>=28 &&sumaE10<=30){
                         desc_E10='Óptimo';
                         registro.optimo=sumaE10;                         
                    } else {
                         if (sumaE10>=23 &&sumaE10<=27){
                              desc_E10='Diestro';
                              registro.diestro=sumaE10;
                         } else{
                              if (sumaE10>=18 &&sumaE10<=22){
                                   desc_E10='Vulnerable';
                                   registro.vulnerable=sumaE10;
                              } else {
                                   desc_E10='Cautela';
                                   registro.cautela=sumaE10;
                              }      
                         }
                    };
                    registro.variable='Conexiones interpersonales';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,244,desc_E10);
                    doc.text(150,244,'|');
                    doc.text(185,244,'|');
                    doc.line(43, 245, 117, 245);

                    doc.text(5, 248, '|');
                    doc.text(7, 248, 'interpersonales');
                    doc.text(43,248, '|');
                    doc.text(48,248, '28');
                    doc.text(59,248, '|');
                    doc.text(63,248, '23');
                    doc.text(75,248, '|');
                    doc.text(80,248, '18');
                    doc.text(98,248, '|');
                    doc.text(103,248, '0');
                    doc.text(116,248,'|');
                    doc.text(130,248,'|');
                    doc.text(150,248,'|');
                    doc.text(185,248,'|');
                    doc.line(5, 249, 151, 249);
                    //? .....................................................................................................................................
                    //? ESCALA 11: DESCONTENTO DESTRUCTIVO
                    doc.text(5, 252, '|');
                    doc.text(7, 252, 'Descontento');
                    doc.text(43,252, '|');
                    doc.text(48,252, '39');
                    doc.text(59,252, '|');
                    doc.text(63,252, '33');
                    doc.text(75,252, '|');
                    doc.text(80,252, '26');
                    doc.text(98,252, '|');
                    doc.text(103,252, '19');
                    doc.text(116,252,'|');

                    let sumaE11= 0;
                    let pg122=parseInt(this.eval_aedp.pg122); let pg123=parseInt(this.eval_aedp.pg123); let pg124=parseInt(this.eval_aedp.pg124); 
                    let pg125=parseInt(this.eval_aedp.pg125); let pg126=parseInt(this.eval_aedp.pg126); let pg127=parseInt(this.eval_aedp.pg127); 
                    let pg128=parseInt(this.eval_aedp.pg128); let pg129=parseInt(this.eval_aedp.pg129); let pg130=parseInt(this.eval_aedp.pg130);
                    let pg131=parseInt(this.eval_aedp.pg131); let pg132=parseInt(this.eval_aedp.pg132); let pg133=parseInt(this.eval_aedp.pg133); 
                    let pg134=parseInt(this.eval_aedp.pg134);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE11= pg122 + pg123 + pg124 + pg125 + pg126 + pg127 + pg128 + pg129 + pg130 + pg131 + pg132 + pg133  + pg134;
                    let st_sumaE11=sumaE11.toString();
                    doc.text(119,252,st_sumaE11);
                    doc.text(130,252,'|');
                    let desc_E11='';
                    if (sumaE11>=34 &&sumaE11<=39){
                         desc_E11='Óptimo';
                         registro.optimo=sumaE11;
                    } else {
                         if (sumaE11>=27 &&sumaE11<=33){
                              desc_E11='Diestro';
                              registro.diestro=sumaE11;
                         } else{
                              if (sumaE11>=20 &&sumaE11<=26){
                                   desc_E11='Vulnerable';
                                   registro.vulnerable=sumaE11;
                              } else {
                                   desc_E11='Cautela';
                                   registro.cautela=sumaE11;
                              }
                         }
                    };
                    registro.variable='Descontento destructivo';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,252,desc_E11);
                    doc.text(150,252,'|');
                    doc.text(185,252,'|');
                    doc.line(43, 253, 117, 253);

                    doc.text(5, 256, '|');
                    doc.text(7, 256, 'destructivo');
                    doc.text(43,256, '|');
                    doc.text(48,256, '34');
                    doc.text(59,256, '|');
                    doc.text(63,256, '27');
                    doc.text(75,256, '|');
                    doc.text(80,256, '20');
                    doc.text(98,256, '|');
                    doc.text(103,256, '0');
                    doc.text(116,256,'|');
                    doc.text(130,256,'|');
                    doc.text(150,256,'|');
                    doc.text(185,256,'|');
                    doc.line(5, 257, 151, 257);
                    //? .....................................................................................................................................
                    //? ESCALA 12: COMPASIÓN
                    doc.text(5, 260, '|');
                    doc.text(7, 260, 'Compasión');
                    doc.text(43,260, '|');
                    doc.text(48,260, '36');
                    doc.text(59,260, '|');
                    doc.text(63,260, '32');
                    doc.text(75,260, '|');
                    doc.text(80,260, '28');
                    doc.text(98,260, '|');
                    doc.text(103,260, '20');
                    doc.text(116,260,'|');

                    let sumaE12= 0;
                    let pg135=parseInt(this.eval_aedp.pg135); let pg136=parseInt(this.eval_aedp.pg136); let pg137=parseInt(this.eval_aedp.pg137); 
                    let pg138=parseInt(this.eval_aedp.pg138); let pg139=parseInt(this.eval_aedp.pg139); let pg140=parseInt(this.eval_aedp.pg140);
                    let pg141=parseInt(this.eval_aedp.pg141); let pg142=parseInt(this.eval_aedp.pg142); let pg143=parseInt(this.eval_aedp.pg143); 
                    let pg144=parseInt(this.eval_aedp.pg144); let pg145=parseInt(this.eval_aedp.pg145); let pg146=parseInt(this.eval_aedp.pg146);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE12= pg135 + pg136 + pg137 + pg138 + pg139 + pg140 + pg141 + pg142 + pg143 + pg144  + pg145 + pg146;
                    let st_sumaE12=sumaE12.toString();
                    doc.text(119,260,st_sumaE12);
                    doc.text(130,260,'|');
                    let desc_E12='';
                    if (sumaE12>=33 &&sumaE12<=36){
                         desc_E12='Óptimo';
                         registro.optimo=sumaE12;
                    } else {
                         if (sumaE12>=29 &&sumaE12<=32){
                              desc_E12='Diestro'
                              registro.diestro=sumaE12;
                         } else{
                              if (sumaE12>=21 &&sumaE12<=28){
                                   desc_E12='Vulnerable';
                                   registro.vulnerable=sumaE12;
                              } else {
                                   desc_E12='Cautela';
                                   registro.cautela=sumaE12;
                              }      
                         }
                    };
                    registro.variable='Compasión';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,260,desc_E12);
                    doc.text(150,260,'|');
                    doc.text(185,260,'|');
                    doc.line(43, 261, 117, 261);

                    doc.text(5, 264, '|');
                    doc.text(7, 264, '');
                    doc.text(43,264, '|');
                    doc.text(48,264, '33');
                    doc.text(59,264, '|');
                    doc.text(63,264, '29');
                    doc.text(75,264, '|');
                    doc.text(80,264, '21');
                    doc.text(98,264, '|');
                    doc.text(103,264, '0');
                    doc.text(116,264,'|');
                    doc.text(130,264,'|');
                    doc.text(150,264,'|');
                    doc.text(185,264,'|');
                    doc.line(5, 265, 206, 265);
                    //? .....................................................................................................................................
                    //? ESCALA 13: PERSPECTIVA
                    doc.text(5, 268, '|');
                    doc.text(7, 268, 'Perspectiva');
                    doc.text(43,268, '|');
                    doc.text(48,268, '24');
                    doc.text(59,268, '|');
                    doc.text(63,268, '22');
                    doc.text(75,268, '|');
                    doc.text(80,268, '18');
                    doc.text(98,268, '|');
                    doc.text(103,268, '12');
                    doc.text(116,268,'|');

                    let sumaE13= 0;
                    let pg147=parseInt(this.eval_aedp.pg147); 
                    let pg148=parseInt(this.eval_aedp.pg148); let pg149=parseInt(this.eval_aedp.pg149); let pg150=parseInt(this.eval_aedp.pg150);
                    let pg151=parseInt(this.eval_aedp.pg151); let pg152=parseInt(this.eval_aedp.pg152); let pg153=parseInt(this.eval_aedp.pg153); 
                    let pg154=parseInt(this.eval_aedp.pg154);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE13= pg147 + pg148 + pg149 + pg150 + pg151 + pg152 + pg153 + pg154;
                    let st_sumaE13=sumaE13.toString();
                    doc.text(119,268,st_sumaE13);
                    doc.text(130,268,'|');
                    let desc_E13='';
                    if (sumaE13>=23 &&sumaE13<=24){
                         desc_E13='Óptimo';
                         registro.optimo=sumaE13;
                    } else {
                         if (sumaE13>=19 &&sumaE13<=22){
                              desc_E13='Diestro';
                              registro.diestro=sumaE13;
                         } else{
                              if (sumaE13>=13 &&sumaE13<=18){
                                   desc_E13='Vulnerable';
                                   registro.vulnerable=sumaE13;
                              } else {
                                   desc_E13='Cautela';
                                   registro.cautela=sumaE13;
                              }      
                         }
                    };
                    registro.variable='Perspectiva';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };
                    doc.text(133,268,desc_E13);
                    doc.text(150,268,'|');
                    doc.text(185,268,'|');
                    doc.line(43, 269, 117, 269);

                    doc.text(5, 272, '|');
                    doc.text(7, 272, '');
                    doc.text(43,272, '|');
                    doc.text(48,272, '23');
                    doc.text(59,272, '|');
                    doc.text(63,272, '19');
                    doc.text(75,272, '|');
                    doc.text(80,272, '13');
                    doc.text(98,272, '|');
                    doc.text(103,272, '0');
                    doc.text(116,272,'|');
                    doc.text(130,272,'|');
                    doc.text(150,272,'|');
                    doc.text(185,272,'|');
                    doc.line(5, 273, 151, 273);
                    //? .....................................................................................................................................
                    //? ESCALA 14: INTUICIÓN
                    doc.text(5, 276, '|');
                    doc.text(7, 276, 'Intuición');
                    doc.text(43,276, '|');
                    doc.text(48,276, '33');
                    doc.text(59,276, '|');
                    doc.text(63,276, '28');
                    doc.text(75,276, '|');
                    doc.text(80,276, '22');
                    doc.text(98,276, '|');
                    doc.text(103,276, '17');
                    doc.text(116,276,'|');

                    let sumaE14= 0;
                    let pg155=parseInt(this.eval_aedp.pg155); let pg156=parseInt(this.eval_aedp.pg156); let pg157=parseInt(this.eval_aedp.pg157); 
                    let pg158=parseInt(this.eval_aedp.pg158); let pg159=parseInt(this.eval_aedp.pg159); let pg160=parseInt(this.eval_aedp.pg160);
                    let pg161=parseInt(this.eval_aedp.pg161); let pg162=parseInt(this.eval_aedp.pg162); let pg163=parseInt(this.eval_aedp.pg163); 
                    let pg164=parseInt(this.eval_aedp.pg164); let pg165=parseInt(this.eval_aedp.pg165);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE14= pg155 + pg156 + pg157 + pg158 + pg159 + pg160 + pg161 + pg162 + pg163 + pg164 + pg165;
                    let st_sumaE14=sumaE14.toString();
                    doc.text(119,276,st_sumaE14);
                    doc.text(130,276,'|');
                    let desc_E14='';
                    if (sumaE14>=29 &&sumaE14<=33){
                         desc_E14='Óptimo';
                         registro.optimo=sumaE14;
                    } else {
                         if (sumaE14>=23 &&sumaE14<=28){
                              desc_E14='Diestro';
                              registro.diestro=sumaE14;
                         } else{
                              if (sumaE14>=18 &&sumaE14<=22){
                                   desc_E14='Vulnerable';
                                   registro.vulnerable=sumaE14;
                              } else {
                                   desc_E14='Cautela';
                                   registro.cautela=sumaE14;
                              }      
                         }
                    };
                    registro.variable='Intuición';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,276,desc_E14);
                    doc.text(150,276,'|');
                    doc.text(185,276,'|');
                    doc.line(43, 277, 117, 277);

                    doc.text(5, 280, '|');
                    doc.text(7, 280, '');
                    doc.text(43,280, '|');
                    doc.text(48,280, '29');
                    doc.text(59,280, '|');
                    doc.text(63,280, '23');
                    doc.text(75,280, '|');
                    doc.text(80,280, '18');
                    doc.text(98,280, '|');
                    doc.text(103,280, '0');
                    doc.text(116,280,'|');
                    doc.text(130,280,'|');
                    doc.text(150,280,'|');
                    doc.text(185,280,'|');
                    doc.line(5, 281, 151, 281);
                    //? .....................................................................................................................................
                    //? ESCALA 15: CONFIANZA EN OTROS
                    doc.addPage("", "l")
                    doc.line(5, 12, 151, 12);
                    doc.text(5, 15, '|');
                    doc.text(7, 15, 'Confianza');
                    doc.text(43,15, '|');
                    doc.text(48,15, '30');
                    doc.text(59,15, '|');
                    doc.text(63,15, '25');
                    doc.text(75,15, '|');
                    doc.text(80,15, '20');
                    doc.text(98,15, '|');
                    doc.text(103,15, '15');
                    doc.text(116,15,'|');

                    let sumaE15= 0;
                    let pg166=parseInt(this.eval_aedp.pg166); let pg167=parseInt(this.eval_aedp.pg167); 
                    let pg168=parseInt(this.eval_aedp.pg168); let pg169=parseInt(this.eval_aedp.pg169); let pg170=parseInt(this.eval_aedp.pg170);
                    let pg171=parseInt(this.eval_aedp.pg171); let pg172=parseInt(this.eval_aedp.pg172); let pg173=parseInt(this.eval_aedp.pg173); 
                    let pg174=parseInt(this.eval_aedp.pg174); let pg175=parseInt(this.eval_aedp.pg175);
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE15= pg166 + pg167 + pg168 + pg169 + pg170 + pg171 + pg172 + pg173 + pg174 + pg175;
                    let st_sumaE15=sumaE15.toString();
                    doc.text(119,15,st_sumaE15);
                    doc.text(130,15,'|');
                    let desc_E15='';
                    if (sumaE15>=29 &&sumaE15<=33){
                         desc_E15='Óptimo';
                         registro.optimo=sumaE15;
                    } else {
                         if (sumaE15>=23 &&sumaE15<=28){
                              desc_E15='Diestro';
                              registro.diestro=sumaE15;
                         } else{
                              if (sumaE15>=18 &&sumaE15<=22){
                                   desc_E15='Vulnerable';
                                   registro.vulnerable=sumaE15;
                              } else {
                                   desc_E15='Cautela';
                                   registro.cautela=sumaE15;
                              }      
                         }
                    };
                    registro.variable='Confianza';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,15,desc_E15);
                    doc.text(150,15,'|');
                    doc.text(185,15,'|');
                    doc.line(43, 16, 117, 16);

                    doc.text(5, 19, '|');
                    doc.text(7, 19, 'en otros');
                    doc.text(43,19, '|');
                    doc.text(48,19, '26');
                    doc.text(59,19, '|');
                    doc.text(63,19, '21');
                    doc.text(75,19, '|');
                    doc.text(80,19, '16');
                    doc.text(98,19, '|');
                    doc.text(103,19, '0');
                    doc.text(116,19,'|');
                    doc.text(130,19,'|');
                    doc.text(150,19,'|');
                    doc.text(185,19,'|');
                    doc.line(5, 20, 151, 20);
                    //? .....................................................................................................................................
                    //? ESCALA 16: PODER PERSONAL
                    doc.text(5, 23, '|');
                    doc.text(7, 23, 'Poder');
                    doc.text(43,23, '|');
                    doc.text(48,23, '39');
                    doc.text(59,23, '|');
                    doc.text(63,23, '33');
                    doc.text(75,23, '|');
                    doc.text(80,23, '28');
                    doc.text(98,23, '|');
                    doc.text(103,23, '23');
                    doc.text(116,23,'|');

                    let sumaE16= 0;
                    let pg176=parseInt(this.eval_aedp.pg176); let pg177=parseInt(this.eval_aedp.pg177); 
                    let pg178=parseInt(this.eval_aedp.pg178); let pg179=parseInt(this.eval_aedp.pg179); let pg180=parseInt(this.eval_aedp.pg180);
                    let pg181=parseInt(this.eval_aedp.pg181); let pg182=parseInt(this.eval_aedp.pg182); let pg183=parseInt(this.eval_aedp.pg183); 
                    let pg184=parseInt(this.eval_aedp.pg184); let pg185=parseInt(this.eval_aedp.pg185); 
                    let pg186=parseInt(this.eval_aedp.pg186); let pg187=parseInt(this.eval_aedp.pg187); let pg188=parseInt(this.eval_aedp.pg188);

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE16= pg176 + pg177 + pg178 + pg179 + pg180 + pg181 + pg182 + pg183 + pg184 + pg185  + pg186 + pg187  + pg188;
                    let st_sumaE16=sumaE16.toString();
                    doc.text(119,23,st_sumaE16);
                    doc.text(130,23,'|');
                    let desc_E16='';
                    if (sumaE16>=34 &&sumaE16<=39){
                         desc_E16='Óptimo';
                         registro.optimo=sumaE16;
                    } else {
                         if (sumaE16>=29 &&sumaE16<=33){
                              desc_E16='Diestro';
                              registro.diestro=sumaE16;
                         } else{
                              if (sumaE16>=24 &&sumaE16<=28){
                                   desc_E16='Vulnerable';
                                   registro.vulnerable=sumaE16;
                              } else {
                                   desc_E16='Cautela';
                                   registro.cautela=sumaE16;
                              }      
                         }
                    };
                    registro.variable='Poder personal';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,23,desc_E16);
                    doc.text(150,23,'|');
                    doc.text(185,23,'|');
                    doc.line(43, 24, 117, 24);

                    doc.text(5, 27, '|');
                    doc.text(7, 27, 'personal');
                    doc.text(43,27, '|');
                    doc.text(48,27, '34');
                    doc.text(59,27, '|');
                    doc.text(63,27, '29');
                    doc.text(75,27, '|');
                    doc.text(80,27, '24');
                    doc.text(98,27, '|');
                    doc.text(103,27, '0');
                    doc.text(116,27,'|');
                    doc.text(130,27,'|');
                    doc.text(150,27,'|');
                    doc.text(185,27,'|');
                    doc.line(5, 28, 151, 28);
                    //? .....................................................................................................................................
                    //? ESCALA 17: INTEGRIDAD
                    doc.text(5, 31, '|');
                    doc.text(7, 31, 'Integridad');
                    doc.text(43,31, '|');
                    doc.text(48,31, '27');
                    doc.text(59,31, '|');
                    doc.text(63,31, '19');
                    doc.text(75,31, '|');
                    doc.text(80,31, '16');
                    doc.text(98,31, '|');
                    doc.text(103,31,'12');
                    doc.text(116,31,'|');

                    let sumaE17= 0;
                    let pg189=parseInt(this.eval_aedp.pg189); let pg190=parseInt(this.eval_aedp.pg190);
                    let pg191=parseInt(this.eval_aedp.pg191); let pg192=parseInt(this.eval_aedp.pg192); 
                    let pg193=parseInt(this.eval_aedp.pg193); 
                    let pg194=parseInt(this.eval_aedp.pg194); let pg195=parseInt(this.eval_aedp.pg195); 
                    let pg196=parseInt(this.eval_aedp.pg196); let pg197=parseInt(this.eval_aedp.pg197); 

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE17= pg189 + pg190 + pg191 + pg192 + pg193 + pg194 + pg195  + pg196 + pg197;
                    let st_sumaE17=sumaE17.toString();
                    doc.text(119,31,st_sumaE17);
                    doc.text(130,31,'|');
                    let desc_E17='';
                    if (sumaE17>=20 &&sumaE17<=27){
                         desc_E17='Óptimo';
                         registro.optimo=sumaE17;
                    } else {
                         if (sumaE17>=17 &&sumaE17<=19){
                              desc_E17='Diestro';
                              registro.diestro=sumaE17;
                         } else{
                              if (sumaE17>=13 &&sumaE17<=16){
                                   desc_E17='Vulnerable';
                                   registro.vulnerable=sumaE17;
                              } else {
                                   desc_E17='Cautela';
                                   registro.cautela=sumaE17;
                              }      
                         }
                    };
                    registro.variable='Integridad';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,31,desc_E17);
                    doc.text(150,31,'|');
                    doc.text(185,31,'|');
                    doc.line(43, 32, 117, 32);

                    doc.text(5, 35, '|');
                    doc.text(7, 35, '');
                    doc.text(43,35, '|');
                    doc.text(48,35, '20');
                    doc.text(59,35, '|');
                    doc.text(63,35, '17');
                    doc.text(75,35, '|');
                    doc.text(80,35, '13');
                    doc.text(98,35, '|');
                    doc.text(103,35, '0');
                    doc.text(116,35,'|');
                    doc.text(130,35,'|');
                    doc.text(150,35,'|');
                    doc.text(185,35,'|');
                    doc.line(5, 36, 209, 36);
                    //? .....................................................................................................................................
                    //? ESCALA 18: SALUD GENERAL
                    doc.text(5, 39, '|');
                    doc.text(7, 39, 'Salud general');
                    doc.text(43,39, '|');
                    doc.text(48,39, '0');
                    doc.text(59,39, '|');
                    doc.text(63,39, '9');
                    doc.text(75,39, '|');
                    doc.text(80,39, '19');
                    doc.text(98,39, '|');
                    doc.text(103,39,'32');
                    doc.text(116,39,'|');

                    let sumaE18= 0;
                    let pg198=parseInt(this.eval_aedp.pg198); let pg199=parseInt(this.eval_aedp.pg199); let pg200=parseInt(this.eval_aedp.pg200);
                    let pg201=parseInt(this.eval_aedp.pg201); let pg202=parseInt(this.eval_aedp.pg202); let pg203=parseInt(this.eval_aedp.pg203);                    
                    let pg204=parseInt(this.eval_aedp.pg204); let pg205=parseInt(this.eval_aedp.pg205); let pg206=parseInt(this.eval_aedp.pg206);                    
                    let pg207=parseInt(this.eval_aedp.pg207); let pg208=parseInt(this.eval_aedp.pg208); let pg209=parseInt(this.eval_aedp.pg209);                    
                    let pg210=parseInt(this.eval_aedp.pg210); let pg211=parseInt(this.eval_aedp.pg211); let pg212=parseInt(this.eval_aedp.pg212);                    
                    let pg213=parseInt(this.eval_aedp.pg213); let pg214=parseInt(this.eval_aedp.pg214); let pg215=parseInt(this.eval_aedp.pg215);                    
                    let pg216=parseInt(this.eval_aedp.pg216); let pg217=parseInt(this.eval_aedp.pg217); let pg218=parseInt(this.eval_aedp.pg218);                    
                    let pg219=parseInt(this.eval_aedp.pg219); let pg220=parseInt(this.eval_aedp.pg220); let pg221=parseInt(this.eval_aedp.pg221);                    
                    let pg222=parseInt(this.eval_aedp.pg222); let pg223=parseInt(this.eval_aedp.pg223); let pg224=parseInt(this.eval_aedp.pg224);                    
                    let pg225=parseInt(this.eval_aedp.pg225); let pg226=parseInt(this.eval_aedp.pg226); let pg227=parseInt(this.eval_aedp.pg227);                    
                    let pg228=parseInt(this.eval_aedp.pg228); let pg229=parseInt(this.eval_aedp.pg229); 

                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE18= pg198 + pg199 + pg200 + pg201 + pg202 + pg203 + pg204 + pg205  + pg206 + pg207 + pg208 + pg209 + pg210  + 
                              pg211 + pg212 + pg213 + pg214 + pg215 + pg216 + pg217 + pg218 + pg219 + pg220 + pg221 + pg222 + pg223  + 
                              pg224 + pg225 + pg226 + pg227 + pg228 + pg229;
                    let st_sumaE18=sumaE18.toString();
                    doc.text(119,39,st_sumaE18);
                    doc.text(130,39,'|');
                    let desc_E18='';
                    if (sumaE18>=0 &&sumaE18<=8){
                         desc_E18='Óptimo'
                         registro.optimo=sumaE18;
                    } else {
                         if (sumaE18>=9 &&sumaE18<=18){
                              desc_E18='Diestro';
                              registro.diestro=sumaE18;
                         } else{
                              if (sumaE18>=19 &&sumaE18<=31){
                                   desc_E18='Vulnerable';
                                   registro.vulnerable=sumaE18;
                              } else {
                                   desc_E18='Cautela';
                                   registro.cautela=sumaE18;
                              }      
                         }
                    };
                    registro.variable='Salud general';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,39,desc_E18);
                    doc.text(150,39,'|');
                    doc.text(185,39,'|');
                    doc.line(43, 40, 117, 40);

                    doc.text(5, 43, '|');
                    doc.text(7, 43, '');
                    doc.text(43,43, '|');
                    doc.text(48,43, '8');
                    doc.text(59,43, '|');
                    doc.text(63,43, '18');
                    doc.text(75,43, '|');
                    doc.text(80,43, '31');
                    doc.text(98,43, '|');
                    doc.text(103,43, '96');
                    doc.text(116,43,'|');
                    doc.text(130,43,'|');
                    doc.text(150,43,'|');
                    doc.text(185,43,'|');
                    doc.line(5, 44, 151, 44);
                    //? .....................................................................................................................................
                    //? ESCALA 19: CALIDAD DE VIDA
                    doc.text(5, 47, '|');
                    doc.text(7, 47, 'Calidad de Vida');
                    doc.text(43,47, '|');
                    doc.text(48,47, '33');
                    doc.text(59,47, '|');
                    doc.text(63,47, '26');
                    doc.text(75,47, '|');
                    doc.text(80,47, '21');
                    doc.text(98,47, '|');
                    doc.text(103,47,'16');
                    doc.text(116,47,'|');

                    let sumaE19= 0;
                    let pg230=parseInt(this.eval_aedp.pg230); let pg231=parseInt(this.eval_aedp.pg231); let pg232=parseInt(this.eval_aedp.pg232);                    
                    let pg233=parseInt(this.eval_aedp.pg233); let pg234=parseInt(this.eval_aedp.pg234); let pg235=parseInt(this.eval_aedp.pg235);                    
                    let pg236=parseInt(this.eval_aedp.pg236); let pg237=parseInt(this.eval_aedp.pg237); let pg238=parseInt(this.eval_aedp.pg238);                    
                    let pg239=parseInt(this.eval_aedp.pg239); let pg240=parseInt(this.eval_aedp.pg240); 
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE19= pg230  + pg231 + pg232 + pg233 + pg234 + pg235 + pg236 + pg237 + pg238 + pg239 + pg240;
                    let st_sumaE19=sumaE19.toString();
                    doc.text(119,47,st_sumaE19);
                    doc.text(130,47,'|');
                    let desc_E19='';
                    if (sumaE19>=27 &&sumaE19<=33){
                         desc_E19='Óptimo';
                         registro.optimo=sumaE19;
                    } else {
                         if (sumaE19>=22 &&sumaE19<=26){
                              desc_E19='Diestro';
                              registro.diestro=sumaE19;
                         } else{
                              if (sumaE19>=17 &&sumaE19<=21){
                                   desc_E19='Vulnerable';
                                   registro.vulnerable=sumaE19;
                              } else {
                                   desc_E19='Cautela';
                                   registro.cautela=sumaE19;
                              }      
                         }
                    };
                    registro.variable='Calidad de vida';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,47,desc_E19);
                    doc.text(150,47,'|');
                    doc.text(185,47,'|');
                    doc.line(43, 48, 117, 48);

                    doc.text(5, 51, '|');
                    doc.text(7, 51, '');
                    doc.text(43,51, '|');
                    doc.text(48,51, '27');
                    doc.text(59,51, '|');
                    doc.text(63,51, '22');
                    doc.text(75,51, '|');
                    doc.text(80,51, '17');
                    doc.text(98,51, '|');
                    doc.text(103,51, '0');
                    doc.text(116,51,'|');
                    doc.text(130,51,'|');
                    doc.text(150,51,'|');
                    doc.text(185,51,'|');
                    doc.line(5, 52, 151, 52);
                    //? .....................................................................................................................................
                    //? ESCALA 20: COCIENTE DE RELACIONES
                    doc.text(5, 55, '|');
                    doc.text(7, 55, 'Cociente de');
                    doc.text(43,55, '|');
                    doc.text(48,55, '21');
                    doc.text(59,55, '|');
                    doc.text(63,55, '19');
                    doc.text(75,55, '|');
                    doc.text(80,55, '16');
                    doc.text(98,55, '|');
                    doc.text(103,55,'13');
                    doc.text(116,55,'|');

                    let sumaE20= 0;
                    let pg241=parseInt(this.eval_aedp.pg241); let pg242=parseInt(this.eval_aedp.pg242); let pg243=parseInt(this.eval_aedp.pg243); 
                    let pg244=parseInt(this.eval_aedp.pg244); let pg245=parseInt(this.eval_aedp.pg245); let pg246=parseInt(this.eval_aedp.pg246); 
                    let pg247=parseInt(this.eval_aedp.pg247);                   
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE20= pg241 + pg242 + pg243 + pg244 + pg245 + pg246 + pg247;
                    let st_sumaE20=sumaE20.toString();
                    doc.text(119,55,st_sumaE20);
                    doc.text(130,55,'|');
                    let desc_E20='';
                    if (sumaE20>=20 &&sumaE20<=21){
                         desc_E20='Óptimo';
                         registro.optimo=sumaE20;
                    } else {
                         if (sumaE20>=17 &&sumaE20<=19){
                              desc_E20='Diestro';
                              registro.diestro=sumaE20;
                         } else{
                              if (sumaE20>=14 &&sumaE20<=16){
                                   desc_E20='Vulnerable';
                                   registro.vulnerable=sumaE20;
                              } else {
                                   desc_E20='Cautela';
                                   registro.cautela=sumaE20;
                              }      
                         }
                    };
                    registro.variable='Cociente de relaciones';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,55,desc_E20);
                    doc.text(150,55,'|');
                    doc.text(185,55,'|');
                    doc.line(43, 56, 117, 56);

                    doc.text(5, 59, '|');
                    doc.text(7, 59, 'relaciones');
                    doc.text(43,59, '|');
                    doc.text(48,59, '20');
                    doc.text(59,59, '|');
                    doc.text(63,59, '17');
                    doc.text(75,59, '|');
                    doc.text(80,59, '14');
                    doc.text(98,59, '|');
                    doc.text(103,59, '0');
                    doc.text(116,59,'|');
                    doc.text(130,59,'|');
                    doc.text(150,59,'|');
                    doc.text(185,59,'|');
                    doc.line(5, 60, 151, 60);
                    //? .....................................................................................................................................
                    //? ESCALA 21: OPTIMO RENDIMIENTO
                    doc.text(5, 63, '|');
                    doc.text(7, 63, 'Óptimo');
                    doc.text(43,63, '|');
                    doc.text(48,63, '21');
                    doc.text(59,63, '|');
                    doc.text(63,63, '19');
                    doc.text(75,63, '|');
                    doc.text(80,63, '16');
                    doc.text(98,63, '|');
                    doc.text(103,63,'12');
                    doc.text(116,63,'|');

                    let sumaE21= 0;
                    let pg248=parseInt(this.eval_aedp.pg248); let pg249=parseInt(this.eval_aedp.pg249); let pg250=parseInt(this.eval_aedp.pg250); 
                    let pg251=parseInt(this.eval_aedp.pg251); let pg252=parseInt(this.eval_aedp.pg252); let pg253=parseInt(this.eval_aedp.pg253); 
                    let pg254=parseInt(this.eval_aedp.pg254); ;                    
                    // console.log('Escala 5: ',pg061,pg051,pg052,pg053,pg054,pg055,pg056,pg057,pg058,pg059,pg060);
                    sumaE21= pg248 + pg249 + pg250 + pg251 + pg252 + pg253 + pg254;
                    let st_sumaE21=sumaE21.toString();
                    doc.text(119,63,st_sumaE21);
                    doc.text(130,63,'|');
                    let desc_E21='';
                    if (sumaE21>=20 &&sumaE21<=21){
                         desc_E21='Óptimo';
                         registro.optimo=sumaE21;
                    } else {
                         if (sumaE21>=17 &&sumaE21<=19){
                              desc_E21='Diestro';
                              registro.diestro=sumaE21;
                         } else{
                              if (sumaE21>=13 &&sumaE21<=16){
                                   desc_E21='Vulnerable';
                                   registro.vulnerable=sumaE21;
                              } else {
                                   desc_E21='Cautela';
                                   registro.cautela=sumaE21;
                              }      
                         }
                    };
                    registro.variable='Optimo rendimiento';
                    this.json_data.push(registro);
                    registro= { variable: '', cautela: "", vulnerable: "", diestro: "",optimo: "", };

                    doc.text(133,63,desc_E21);
                    doc.text(150,63,'|');
                    doc.text(185,63,'|');
                    doc.line(43, 64, 117, 64);

                    doc.text(5, 67, '|');
                    doc.text(7, 67, 'rendimiento');
                    doc.text(43,67, '|');
                    doc.text(48,67, '20');
                    doc.text(59,67, '|');
                    doc.text(63,67, '17');
                    doc.text(75,67, '|');
                    doc.text(80,67, '13');
                    doc.text(98,67, '|');
                    doc.text(103,67, '0');
                    doc.text(116,67,'|');
                    doc.text(130,67,'|');
                    doc.text(150,67,'|');
                    doc.text(185,67,'|');
                    doc.line(5, 68, 207, 68);

               },
          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_Tipolo() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_tipolo.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "TipoPer_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación TIPO DE PERSONALIDAD para " + this.eval_tipolo.nombre + " de " + this.eval_tipolo.empresa);

               this.respuestasTipolo(doc);
               this.losresultadosTipolo(doc);
               this.latipologia(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },

          latipologia(doc) {

               this.res.par1iguales = false; this.res.par2iguales = false; this.res.par3iguales = false; this.res.par4iguales = false;
               this.res.topologiaEI1 = ""; this.res.topologiaSN1 = ""; this.res.topologiaTF1 = ""; this.res.topologiaJP1 = "";

               console.log("** resultados");
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               /* E > I, I > E, I = E */
               if (this.res.E > this.res.I) { this.res.topologiaEI1 = "E -" }
               else
                    if (this.res.I > this.res.E) { this.res.topologiaEI1 = "I -" }
                    else {
                         this.res.par1iguales = true;
                         this.res.topologiaEI1 = "E -";
                    }
               console.log("E ? ", this.res.E, "; I ? ", this.res.I, "; par1iguales ? ", this.res.par1iguales, "; topologiaEI ? ", this.res.topologiaEI1);
               console.log("-------------------------------------------------------");

               /* S > N, N > S, S = N */
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               if (this.res.S > this.res.N) { this.res.topologiaSN1 = "S -" }
               else
                    if (this.res.N > this.res.S) { this.res.topologiaSN1 = "N -" }
                    else {
                         this.res.par2iguales = true;
                         this.res.topologiaSN1 = "S -";
                    }
               console.log("S ? ", this.res.S, "; N ? ", this.res.N, "; par2iguales ? ", this.res.par2iguales, "; topologiaSN ? ", this.res.topologiaSN1);
               console.log("-------------------------------------------------------");

               /* T > F, F > T, T = F */
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               if (this.res.T > this.res.F) { this.res.topologiaTF1 = "T -" }
               else
                    if (this.res.F > this.res.T) { this.res.topologiaTF1 = "F -" }
                    else {
                         this.res.par3iguales = true;
                         this.res.topologiaTF1 = "T -";
                    }
               console.log("T ? ", this.res.T, "; F ? ", this.res.F, "; par3iguales ? ", this.res.par3iguales, "; topologiaTF ? ", this.res.topologiaTF1);
               console.log("-------------------------------------------------------");


               /* J > P, P > J, J = P */
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               if (this.res.J > this.res.P) { this.res.topologiaJP1 = "J -" }
               else
                    if (this.res.P > this.res.J) { this.res.topologiaJP1 = "P -" }
                    else {
                         this.res.par4iguales = true;
                         this.res.topologiaJP1 = "J -";
                    }
               console.log("J ? ", this.res.J, "; P ? ", this.res.P, "; par4iguales ? ", this.res.par4iguales, "; topologiaJP ? ", this.res.topologiaJP1);
               console.log("-------------------------------------------------------");

               this.res.topologia1 = ""; this.res.topologia2 = ""; this.res.topologia3 = ""; this.res.topologia4 = ""; this.res.topologia5 = "";
               this.res.topologia6 = ""; this.res.topologia7 = ""; this.res.topologia8 = ""; this.res.topologia9 = ""; this.res.topologia10 = "";
               this.res.topologia11 = ""; this.res.topologia12 = ""; this.res.topologia13 = ""; this.res.topologia14 = ""; this.res.topologia15 = "";
               this.res.topologia16 = "";

               /* Evalua cómo están los pares */
               /* Caso 1: Todos los pares diferentes */
               if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                    this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;

                    this.res.topologia = "CASO ESPERADO: todos los pares tienen valores diferentes.";
               } else {
                    /* Acá tengo los 15 casos restantes */
                    /* ================================ */

                    /* Caso 2: que el primer par (E,I) sea igual */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 3: que el primero y segundo par (E,I) & (S,N) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 4: que el primero y tercer par (E,I) && (T,F) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {

                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 5: que el primero y cuarto par (E,I) && (J,P) sean iguales */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 6: que solo el SEGUNDO (S,N) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + this.res.topologiaJP1;
                    }
                    /* Caso 7: que el segundo (S,N) y el tercero (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 8: que el SEGUNDO (S,N) y el cuarto (J,P) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 9: que solo el TERCER (T,F) sean iguales */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + this.res.topologiaJP1;
                    }
                    /* Caso 10: primero (E,I) y tercero (T,F) sean iguales  */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         /*  ESTE DEBE SER */
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + this.res.topologiaSN1 + 'F -' + 'P';
                    }
                    /* Caso 11: solo el ultimo (J,P) es iguale */
                    if (this.res.par1iguales === false && this.res.par2iguales === false && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + this.res.topologiaSN1 + this.res.topologiaTF1 + 'P';
                    }
                    /* Caso 12: solo el cuarto es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === false) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia2 = 'I -' + 'S -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia4 = 'I -' + 'S -' + 'F -' + this.res.topologiaJP1;

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + this.res.topologiaJP1;
                         this.res.topologia6 = 'I -' + 'N -' + 'T -' + this.res.topologiaJP1;

                         this.res.topologia7 = 'E -' + 'N -' + 'F -' + this.res.topologiaJP1;
                         this.res.topologia8 = 'I -' + 'N -' + 'F -' + this.res.topologiaJP1;
                    }

                    /* Caso 13: solo el tercero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === false && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia2 = 'I -' + 'S -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia3 = 'E -' + 'S -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia4 = 'I -' + 'S -' + this.res.topologiaTF1 + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + this.res.topologiaTF1 + 'J';
                         this.res.topologia6 = 'I -' + 'N -' + this.res.topologiaTF1 + 'J';

                         this.res.topologia7 = 'E -' + 'N -' + this.res.topologiaTF1 + 'P';
                         this.res.topologia8 = 'I -' + 'N -' + this.res.topologiaTF1 + 'P';
                    }

                    /* Caso 14: solo el segundo es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + this.res.topologiaSN1 + 'T -' + 'J';
                         this.res.topologia2 = 'I -' + this.res.topologiaSN1 + 'T -' + 'J';

                         this.res.topologia3 = 'E -' + this.res.topologiaSN1 + 'T -' + 'P';
                         this.res.topologia4 = 'I -' + this.res.topologiaSN1 + 'T -' + 'P';

                         this.res.topologia5 = 'E -' + this.res.topologiaSN1 + 'F -' + 'J';
                         this.res.topologia6 = 'I -' + this.res.topologiaSN1 + 'F -' + 'J';

                         this.res.topologia7 = 'E -' + this.res.topologiaSN1 + 'F -' + 'P';
                         this.res.topologia8 = 'I -' + this.res.topologiaSN1 + 'F -' + 'P';
                    }

                    /* Caso 15: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === false && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = this.res.topologiaEI1 + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = this.res.topologiaEI1 + 'N -' + 'T -' + 'J';

                         this.res.topologia3 = this.res.topologiaEI1 + 'S -' + 'T -' + 'P';
                         this.res.topologia4 = this.res.topologiaEI1 + 'N -' + 'T -' + 'P';

                         this.res.topologia5 = this.res.topologiaEI1 + 'S -' + 'F -' + 'J';
                         this.res.topologia6 = this.res.topologiaEI1 + 'N -' + 'F -' + 'J';

                         this.res.topologia7 = this.res.topologiaEI1 + 'S -' + 'F -' + 'P';
                         this.res.topologia8 = this.res.topologiaEI1 + 'N -' + 'F -' + 'P';
                    }

                    /* Caso 16: solo el primero es DIFERENTE  */
                    if (this.res.par1iguales === true && this.res.par2iguales === true && this.res.par3iguales === true && this.res.par4iguales === true) {
                         this.res.topologia1 = 'E -' + 'S -' + 'T -' + 'J';
                         this.res.topologia2 = 'E -' + 'S -' + 'T -' + 'P';
                         this.res.topologia3 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia4 = 'E -' + 'S -' + 'F -' + 'P';

                         this.res.topologia5 = 'E -' + 'N -' + 'T -' + 'J';
                         this.res.topologia6 = 'E -' + 'N -' + 'T -' + 'P';

                         this.res.topologia7 = 'E -' + 'S -' + 'F -' + 'J';
                         this.res.topologia8 = 'E -' + 'N -' + 'F -' + 'J';

                         this.res.topologia9 = 'I -' + 'S -' + 'T -' + 'J';
                         this.res.topologia10 = 'I -' + 'S -' + 'T -' + 'P';
                         this.res.topologia11 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia12 = 'I -' + 'S -' + 'F -' + 'P';

                         this.res.topologia13 = 'I -' + 'N -' + 'T -' + 'J';
                         this.res.topologia14 = 'I -' + 'N -' + 'T -' + 'P';

                         this.res.topologia15 = 'I -' + 'S -' + 'F -' + 'J';
                         this.res.topologia16 = 'I -' + 'N -' + 'F -' + 'J';
                    }

               }
               this.res.topologia = "CASO ESPECIAL: Por lo menos un par tiene valores diferentes.";

               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 136, "SECCION DE TOPOLOGIA " + this.res.topologia);
               doc.line(10, 138, 206, 138);
               doc.text(10, 142, " ( " + this.res.par1iguales + " , " + this.res.par2iguales + " , " + this.res.par3iguales + " , " + this.res.par4iguales + " ) ");
               doc.text(10, 146, "* " + this.res.topologia1);
               doc.text(10, 150, "* " + this.res.topologia2);
               doc.text(10, 154, "* " + this.res.topologia3);
               doc.text(10, 158, "* " + this.res.topologia4);
               doc.text(10, 162, "* " + this.res.topologia5);
               doc.text(10, 166, "* " + this.res.topologia6);
               doc.text(10, 170, "* " + this.res.topologia7);
               doc.text(10, 174, "* " + this.res.topologia8);
               doc.text(10, 178, "* " + this.res.topologia9);
               doc.text(10, 182, "* " + this.res.topologia10);
               doc.text(10, 186, "* " + this.res.topologia11);
               doc.text(10, 190, "* " + this.res.topologia12);
               doc.text(10, 194, "* " + this.res.topologia13);
               doc.text(10, 198, "* " + this.res.topologia14);
               doc.text(10, 202, "* " + this.res.topologia15);
               doc.text(10, 206, "* " + this.res.topologia16);

          },
          losresultadosTipolo(doc) {

               /* Columnas E & I */
               this.res.E = 0; this.res.I = 0;
               if (this.eval_tipolo.pg001 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg008 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg015 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg022 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg029 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg036 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg043 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg050 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg057 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }
               if (this.eval_tipolo.pg064 === "1") { this.res.E = this.res.E + 1 } else { this.res.I = this.res.I + 1 }

               /* Columnas intermedias entre (E - I) y (*S - N) 
                    ( a1= ncol11, b2= ncol12 ) */
               this.res.a1 = 0; this.res.b2 = 0; // 10 preguntas 
               if (this.eval_tipolo.pg002 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg009 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg016 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg023 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg030 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg037 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg044 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg051 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg058 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }
               if (this.eval_tipolo.pg065 === "1") { this.res.a1 = this.res.a1 + 1 } else { this.res.b2 = this.res.b2 + 1 }

               /* Columnas T & F 
                   a3= ncol3, b4= ncol4  */
               this.res.a3 = 0; this.res.b4 = 0; // 10 preguntas
               if (this.eval_tipolo.pg003 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg010 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg017 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg024 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg031 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg038 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg045 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg052 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg059 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }
               if (this.eval_tipolo.pg066 === "1") { this.res.a3 = this.res.a3 + 1 } else { this.res.b4 = this.res.b4 + 1 }

               /* Columnas intermedias entre (S - N) y (*T - F) 
                    a5= ncol5, b6= ncol6 */
               this.res.a5 = 0; this.res.b6 = 0; // 10 preguntas
               if (this.eval_tipolo.pg004 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg011 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg018 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg025 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg032 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg039 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg046 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg053 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg060 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }
               if (this.eval_tipolo.pg067 === "1") { this.res.a5 = this.res.a5 + 1 } else { this.res.b6 = this.res.b6 + 1 }

               /* Columnas T & F 
                    a7= ncol7, b8= ncol8 */
               this.res.a7 = 0; this.res.b8 = 0; // 10 preguntas
               if (this.eval_tipolo.pg005 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg012 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg019 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg026 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg033 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg040 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg047 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg054 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg061 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }
               if (this.eval_tipolo.pg068 === "1") { this.res.a7 = this.res.a7 + 1 } else { this.res.b8 = this.res.b8 + 1 }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a9= ncol9, b10= ncol10 */
               this.res.a9 = 0; this.res.b10 = 0; // 10 preguntas !
               if (this.eval_tipolo.pg006 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg013 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg020 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg027 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg034 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg041 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg048 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg055 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg062 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }
               if (this.eval_tipolo.pg069 === "1") { this.res.a9 = this.res.a9 + 1 } else { this.res.b10 = this.res.b10 + 1 }

               /* Columnas intermedias entre (T - F) y (*J - P) 
                    a11= ncol11, b12= ncol12 */
               this.res.a11 = 0; this.res.b12 = 0; // 10 preguntas
               if (this.eval_tipolo.pg007 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg014 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg021 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg028 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg035 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg042 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg049 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg056 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg063 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }
               if (this.eval_tipolo.pg070 === "1") { this.res.a11 = this.res.a11 + 1 } else { this.res.b12 = this.res.b12 + 1 }


               // $scope.ncolS = $scope.ncol1 + $scope.ncol3;
               // $scope.ncolN = $scope.ncol2 + $scope.ncol4;
               // let S = 0; let N = 0; 
               this.res.S = 0; this.res.N = 0; // 10 preguntas
               this.res.S = this.res.a1 + this.res.a3;
               this.res.N = this.res.b2 + this.res.b4;

               // $scope.ncolT = $scope.ncol5 + $scope.ncol7;
               // $scope.ncolF = $scope.ncol6 + $scope.ncol8;
               // let T = 0; let F = 0; 
               this.res.T = 0; this.res.F = 0; // 10 preguntas
               this.res.T = this.res.a5 + this.res.a7;
               this.res.F = this.res.b6 + this.res.b8;

               // $scope.ncolJ = $scope.ncol9 + $scope.ncol11;
               // $scope.ncolP = $scope.ncol10 + $scope.ncol12;
               // let J = 0; let P = 0; 
               this.res.J = 0; this.res.P = 0; // 10 preguntas
               this.res.J = this.res.a9 + this.res.a11;
               this.res.P = this.res.b10 + this.res.b12;


               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ")
               doc.line(10, 72, 206, 72);
               doc.text(10, 76, "a1 ( " + this.res.a1 + " , " + this.res.b2 + " ) b2");
               doc.text(10, 81, "a5 ( " + this.res.a5 + " , " + this.res.b6 + " ) b6");
               doc.text(10, 86, "a9 ( " + this.res.a9 + " , " + this.res.b10 + " ) b10");
               doc.text(10, 90, "");
               doc.text(10, 94, "a3 ( " + this.res.a3 + " , " + this.res.b4 + " ) b4");
               doc.text(10, 99, "a7 ( " + this.res.a7 + " , " + this.res.b8 + " ) b8");
               doc.text(10, 104, "a11 ( " + this.res.a11 + " , " + this.res.b12 + " ) b12");
               doc.text(10, 108, "");
               doc.text(10, 113, "E  ( " + this.res.E + " , " + this.res.I + " ) I");
               doc.text(10, 118, "S  ( " + this.res.S + " , " + this.res.N + " ) N");
               doc.text(10, 123, "T  ( " + this.res.T + " , " + this.res.F + " ) F");
               doc.text(10, 128, "J  ( " + this.res.J + " , " + this.res.P + " ) P");
          },
          respuestasTipolo(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_tipolo.pg001 === "1" ? "| 01= (a)" : "| 01= (b)");
               doc.text(23, 45, this.eval_tipolo.pg002 === "1" ? "| 02= (a)" : "| 02= (b)");
               doc.text(36, 45, this.eval_tipolo.pg003 === "1" ? "| 03= (a)" : "| 03= (b)");
               doc.text(49, 45, this.eval_tipolo.pg004 === "1" ? "| 04= (a)" : "| 04= (b)");
               doc.text(62, 45, this.eval_tipolo.pg005 === "1" ? "| 05= (a)" : "| 05= (b)");
               doc.text(75, 45, this.eval_tipolo.pg006 === "1" ? "| 06= (a)" : "| 06= (b)");
               doc.text(88, 45, this.eval_tipolo.pg007 === "1" ? "| 07= (a)" : "| 07= (b)");
               doc.text(101, 45, this.eval_tipolo.pg008 === "1" ? "| 08= (a)" : "| 08= (b)");
               doc.text(114, 45, this.eval_tipolo.pg009 === "1" ? "| 09= (a)" : "| 09= (b)");
               doc.text(127, 45, this.eval_tipolo.pg010 === "1" ? "| 10= (a)" : "| 10= (b)");
               doc.text(140, 45, this.eval_tipolo.pg011 === "1" ? "| 11= (a)" : "| 11= (b)");
               doc.text(153, 45, this.eval_tipolo.pg012 === "1" ? "| 12= (a)" : "| 12= (b)");
               doc.text(166, 45, this.eval_tipolo.pg013 === "1" ? "| 13= (a)" : "| 13= (b)");
               doc.text(179, 45, this.eval_tipolo.pg014 === "1" ? "| 14= (a)" : "| 14= (b)");
               doc.text(192, 45, this.eval_tipolo.pg015 === "1" ? "| 15= (a)" : "| 15= (b) |");
               doc.line(10, 46, 206, 46);
               doc.text(10, 49, this.eval_tipolo.pg016 === "1" ? "| 16= (a)" : "| 16= (b)");
               doc.text(23, 49, this.eval_tipolo.pg017 === "1" ? "| 17= (a)" : "| 17= (b)");
               doc.text(36, 49, this.eval_tipolo.pg018 === "1" ? "| 18= (a)" : "| 18= (b)");
               doc.text(49, 49, this.eval_tipolo.pg019 === "1" ? "| 19= (a)" : "| 19= (b)");
               doc.text(62, 49, this.eval_tipolo.pg020 === "1" ? "| 20= (a)" : "| 20= (b)");
               doc.text(75, 49, this.eval_tipolo.pg021 === "1" ? "| 21= (a)" : "| 21= (b)");
               doc.text(88, 49, this.eval_tipolo.pg022 === "1" ? "| 22= (a)" : "| 22= (b)");
               doc.text(101, 49, this.eval_tipolo.pg023 === "1" ? "| 23= (a)" : "| 23= (b)");
               doc.text(114, 49, this.eval_tipolo.pg024 === "1" ? "| 24= (a)" : "| 24= (b)");
               doc.text(127, 49, this.eval_tipolo.pg025 === "1" ? "| 25= (a)" : "| 25= (b)");
               doc.text(140, 49, this.eval_tipolo.pg026 === "1" ? "| 26= (a)" : "| 26= (b)");
               doc.text(153, 49, this.eval_tipolo.pg027 === "1" ? "| 27= (a)" : "| 27= (b)");
               doc.text(166, 49, this.eval_tipolo.pg028 === "1" ? "| 28= (a)" : "| 28= (b)");
               doc.text(179, 49, this.eval_tipolo.pg029 === "1" ? "| 29= (a)" : "| 29= (b)");
               doc.text(192, 49, this.eval_tipolo.pg030 === "1" ? "| 30= (a)" : "| 30= (b) |");
               doc.line(10, 50, 206, 50);
               doc.text(10, 53, this.eval_tipolo.pg031 === "1" ? "| 31= (a)" : "| 31= (b)");
               doc.text(23, 53, this.eval_tipolo.pg032 === "1" ? "| 32= (a)" : "| 32= (b)");
               doc.text(36, 53, this.eval_tipolo.pg033 === "1" ? "| 33= (a)" : "| 33= (b)");
               doc.text(49, 53, this.eval_tipolo.pg034 === "1" ? "| 34= (a)" : "| 34= (b)");
               doc.text(62, 53, this.eval_tipolo.pg035 === "1" ? "| 35= (a)" : "| 35= (b)");
               doc.text(75, 53, this.eval_tipolo.pg036 === "1" ? "| 36= (a)" : "| 36= (b)");
               doc.text(88, 53, this.eval_tipolo.pg037 === "1" ? "| 37= (a)" : "| 37= (b)");
               doc.text(101, 53, this.eval_tipolo.pg038 === "1" ? "| 38= (a)" : "| 38= (b)");
               doc.text(114, 53, this.eval_tipolo.pg039 === "1" ? "| 39= (a)" : "| 39= (b)");
               doc.text(127, 53, this.eval_tipolo.pg040 === "1" ? "| 40= (a)" : "| 40= (b)");
               doc.text(140, 53, this.eval_tipolo.pg041 === "1" ? "| 41= (a)" : "| 41= (b)");
               doc.text(153, 53, this.eval_tipolo.pg042 === "1" ? "| 42= (a)" : "| 42= (b)");
               doc.text(166, 53, this.eval_tipolo.pg043 === "1" ? "| 43= (a)" : "| 43= (b)");
               doc.text(179, 53, this.eval_tipolo.pg044 === "1" ? "| 44= (a)" : "| 44= (b)");
               doc.text(192, 53, this.eval_tipolo.pg045 === "1" ? "| 45= (a)" : "| 45= (b) |");
               doc.line(10, 54, 206, 54);
               doc.text(10, 57, this.eval_tipolo.pg046 === "1" ? "| 46= (a)" : "| 46= (b)");
               doc.text(23, 57, this.eval_tipolo.pg047 === "1" ? "| 47= (a)" : "| 47= (b)");
               doc.text(36, 57, this.eval_tipolo.pg048 === "1" ? "| 48= (a)" : "| 48= (b)");
               doc.text(49, 57, this.eval_tipolo.pg049 === "1" ? "| 49= (a)" : "| 49= (b)");
               doc.text(62, 57, this.eval_tipolo.pg050 === "1" ? "| 50= (a)" : "| 50= (b)");
               doc.text(75, 57, this.eval_tipolo.pg051 === "1" ? "| 51= (a)" : "| 51= (b)");
               doc.text(88, 57, this.eval_tipolo.pg052 === "1" ? "| 52= (a)" : "| 52= (b)");
               doc.text(101, 57, this.eval_tipolo.pg053 === "1" ? "| 53= (a)" : "| 53= (b)");
               doc.text(114, 57, this.eval_tipolo.pg054 === "1" ? "| 54= (a)" : "| 54= (b)");
               doc.text(127, 57, this.eval_tipolo.pg055 === "1" ? "| 55= (a)" : "| 55= (b)");
               doc.text(140, 57, this.eval_tipolo.pg056 === "1" ? "| 56= (a)" : "| 56= (b)");
               doc.text(153, 57, this.eval_tipolo.pg057 === "1" ? "| 57= (a)" : "| 57= (b)");
               doc.text(166, 57, this.eval_tipolo.pg058 === "1" ? "| 58= (a)" : "| 58= (b)");
               doc.text(179, 57, this.eval_tipolo.pg059 === "1" ? "| 59= (a)" : "| 59= (b)");
               doc.text(192, 57, this.eval_tipolo.pg060 === "1" ? "| 60= (a)" : "| 60= (b) |");
               doc.line(10, 58, 206, 58);
               doc.text(10, 61, this.eval_tipolo.pg061 === "1" ? "| 61= (a)" : "| 61= (b)");
               doc.text(23, 61, this.eval_tipolo.pg062 === "1" ? "| 62= (a)" : "| 62= (b)");
               doc.text(36, 61, this.eval_tipolo.pg063 === "1" ? "| 63= (a)" : "| 63= (b)");
               doc.text(49, 61, this.eval_tipolo.pg064 === "1" ? "| 64= (a)" : "| 64= (b)");
               doc.text(62, 61, this.eval_tipolo.pg065 === "1" ? "| 65= (a)" : "| 65= (b)");
               doc.text(75, 61, this.eval_tipolo.pg066 === "1" ? "| 66= (a)" : "| 66= (b)");
               doc.text(88, 61, this.eval_tipolo.pg067 === "1" ? "| 67= (a)" : "| 67= (b)");
               doc.text(101, 61, this.eval_tipolo.pg068 === "1" ? "| 68= (a)" : "| 68= (b)");
               doc.text(114, 61, this.eval_tipolo.pg069 === "1" ? "| 69= (a)" : "| 69= (b)");
               doc.text(127, 61, this.eval_tipolo.pg070 === "1" ? "| 70= (a)" : "| 70= (b) |");
               doc.line(10, 62, 141, 62);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_16pf() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_16pf.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "16pf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación FACTORES DE PERSONALIDAD para " + this.eval_16pf.nombre + " de " + this.eval_16pf.empresa);

               this.respuestas16pf(doc);
               this.resultados16pf(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          resultados16pf(doc) {

               // this.res_16pf.resP = resultadosJ();   
               // console.log("resultadosJ ? ", this.res_16pf.resP);
               this.res_16pf.resA = -1;
               this.res_16pf.resP = this.resultadosH(this.eval_16pf.pg001, this.eval_16pf.pg018, this.eval_16pf.pg035, this.eval_16pf.pg052, this.eval_16pf.pg069, this.eval_16pf.pg086, 'P');
               this.res_16pf.resA = this.resultadosH(this.eval_16pf.pg002, this.eval_16pf.pg019, this.eval_16pf.pg036, this.eval_16pf.pg053, this.eval_16pf.pg070, this.eval_16pf.pg087, 'A');
               this.res_16pf.resB = this.resultadosH(this.eval_16pf.pg003, this.eval_16pf.pg020, this.eval_16pf.pg037, this.eval_16pf.pg054, this.eval_16pf.pg071, this.eval_16pf.pg088, 'B');
               this.res_16pf.resC = this.resultadosH(this.eval_16pf.pg004, this.eval_16pf.pg021, this.eval_16pf.pg038, this.eval_16pf.pg055, this.eval_16pf.pg072, this.eval_16pf.pg089, 'C');
               this.res_16pf.resE = this.resultadosH(this.eval_16pf.pg005, this.eval_16pf.pg022, this.eval_16pf.pg039, this.eval_16pf.pg056, this.eval_16pf.pg073, this.eval_16pf.pg090, 'E');
               this.res_16pf.resF = this.resultadosH(this.eval_16pf.pg006, this.eval_16pf.pg023, this.eval_16pf.pg040, this.eval_16pf.pg057, this.eval_16pf.pg074, this.eval_16pf.pg091, 'F');
               this.res_16pf.resG = this.resultadosH(this.eval_16pf.pg007, this.eval_16pf.pg024, this.eval_16pf.pg041, this.eval_16pf.pg058, this.eval_16pf.pg075, this.eval_16pf.pg092, 'G');
               this.res_16pf.resH = this.resultadosH(this.eval_16pf.pg008, this.eval_16pf.pg025, this.eval_16pf.pg042, this.eval_16pf.pg059, this.eval_16pf.pg076, this.eval_16pf.pg093, 'H');
               this.res_16pf.resI = this.resultadosH(this.eval_16pf.pg009, this.eval_16pf.pg026, this.eval_16pf.pg043, this.eval_16pf.pg060, this.eval_16pf.pg077, this.eval_16pf.pg094, 'I');
               this.res_16pf.resL = this.resultadosH(this.eval_16pf.pg010, this.eval_16pf.pg027, this.eval_16pf.pg044, this.eval_16pf.pg061, this.eval_16pf.pg078, this.eval_16pf.pg095, 'L');
               this.res_16pf.resM = this.resultadosH(this.eval_16pf.pg011, this.eval_16pf.pg028, this.eval_16pf.pg045, this.eval_16pf.pg062, this.eval_16pf.pg079, this.eval_16pf.pg096, 'M');
               this.res_16pf.resN = this.resultadosH(this.eval_16pf.pg012, this.eval_16pf.pg029, this.eval_16pf.pg046, this.eval_16pf.pg063, this.eval_16pf.pg080, this.eval_16pf.pg097, 'N');
               this.res_16pf.resO = this.resultadosH(this.eval_16pf.pg013, this.eval_16pf.pg030, this.eval_16pf.pg047, this.eval_16pf.pg064, this.eval_16pf.pg081, this.eval_16pf.pg098, 'O');
               this.res_16pf.resQ1 = this.resultadosH(this.eval_16pf.pg014, this.eval_16pf.pg031, this.eval_16pf.pg048, this.eval_16pf.pg065, this.eval_16pf.pg082, this.eval_16pf.pg099, 'Q1');
               this.res_16pf.resQ2 = this.resultadosH(this.eval_16pf.pg015, this.eval_16pf.pg032, this.eval_16pf.pg049, this.eval_16pf.pg066, this.eval_16pf.pg083, this.eval_16pf.pg100, 'Q2');
               this.res_16pf.resQ3 = this.resultadosH(this.eval_16pf.pg016, this.eval_16pf.pg033, this.eval_16pf.pg050, this.eval_16pf.pg067, this.eval_16pf.pg084, this.eval_16pf.pg101, 'Q3');
               this.res_16pf.resQ4 = this.resultadosH(this.eval_16pf.pg017, this.eval_16pf.pg034, this.eval_16pf.pg051, this.eval_16pf.pg068, this.eval_16pf.pg085, this.eval_16pf.pg102, 'Q4');

               console.log("P ? ", this.res_16pf.resP, ", ", "A ? ", this.res_16pf.resA, ", ", "B ? ", this.res_16pf.resB, ", ", "C ? ", this.res_16pf.resC, ", ", "E ? ", this.res_16pf.resE, ", ",
                    "F ? ", this.res_16pf.resF, ", ", "G ? ", this.res_16pf.resG, ", ", "H ? ", this.res_16pf.resH, ", ", "I ? ", this.res_16pf.resI, ", ", "L ? ", this.res_16pf.resL, ", ",
                    "M ? ", this.res_16pf.resM, ", ", "N ? ", this.res_16pf.resN, ", ", "O ? ", this.res_16pf.resO, ", ", "Q1 ? ", this.res_16pf.resQ1, ", ", "Q2 ? ", this.res_16pf.resQ2, ", ",
                    "Q3 ? ", this.res_16pf.resQ3, ", ", "Q4 ? ", this.res_16pf.resQ4);
               if (this.res_16pf.resP >= 10) {

                    this.res_16pf.resA = this.res_16pf.resA - 1;
                    this.res_16pf.resB = this.res_16pf.resB - 1;
                    this.res_16pf.resC = this.res_16pf.resC - 1;
                    this.res_16pf.resE = this.res_16pf.resE - 1;
                    this.res_16pf.resF = this.res_16pf.resF - 1;
                    this.res_16pf.resG = this.res_16pf.resG - 1;
                    this.res_16pf.resH = this.res_16pf.resH - 1;
                    this.res_16pf.resI = this.res_16pf.resI - 1;
                    this.res_16pf.resL = this.res_16pf.resL - 1;
                    this.res_16pf.resM = this.res_16pf.resM - 1;
                    this.res_16pf.resN = this.res_16pf.resN - 1;
                    this.res_16pf.resO = this.res_16pf.resO - 1;
                    this.res_16pf.resQ1 = this.res_16pf.resQ1 - 1;
                    this.res_16pf.resQ2 = this.res_16pf.resQ2 - 1;
                    this.res_16pf.resQ3 = this.res_16pf.resQ3 - 1;
                    this.res_16pf.resQ4 = this.res_16pf.resQ4 - 1;
               } // if   

               console.log("Q4 ?", this.res_16pf.resQ4);
               this.res_16pf.rangoP = this.res_16pf.resP;
               this.res_16pf.rangoA = this.rangosH(this.res_16pf.resA, 'A');
               this.res_16pf.rangoB = this.rangosH(this.res_16pf.resB, 'B');
               this.res_16pf.rangoC = this.rangosH(this.res_16pf.resC, 'C');
               this.res_16pf.rangoE = this.rangosH(this.res_16pf.resE, 'E');
               this.res_16pf.rangoF = this.rangosH(this.res_16pf.resF, 'F');
               this.res_16pf.rangoG = this.rangosH(this.res_16pf.resG, 'G');
               this.res_16pf.rangoH = this.rangosH(this.res_16pf.resH, 'H');
               this.res_16pf.rangoI = this.rangosH(this.res_16pf.resI, 'I');
               this.res_16pf.rangoL = this.rangosH(this.res_16pf.resL, 'L');
               this.res_16pf.rangoM = this.rangosH(this.res_16pf.resM, 'M');
               this.res_16pf.rangoN = this.rangosH(this.res_16pf.resN, 'N');
               this.res_16pf.rangoO = this.rangosH(this.res_16pf.resO, 'O');
               this.res_16pf.rangoQ1 = this.rangosH(this.res_16pf.resQ1, 'Q1');
               this.res_16pf.rangoQ2 = this.rangosH(this.res_16pf.resQ2, 'Q2');
               this.res_16pf.rangoQ3 = this.rangosH(this.res_16pf.resQ3, 'Q3');
               this.res_16pf.rangoQ4 = this.rangosH(this.res_16pf.resQ4, 'Q4');

               doc.setLineWidth(0.25);

               doc.text(10, 85, "SECCION DE RESULTADOS ")
               doc.line(10, 86, 206, 86);

               // doc.text(21, 81, "F");   doc.text(61, 81, "P");
               // doc.text(20, 85, "---"); doc.text(60, 85, "---");
               // doc.text(10, 89, "D"); doc.text(20, 89, this.res_16pf.rangoP.toString()); doc.text(60, 89, this.res_16pf.resP.toString());
               // doc.text(10, 93, "A"); doc.text(20, 93, this.res_16pf.rangoA.toString()); doc.text(60, 93, this.res_16pf.resA.toString());

               doc.text(26, 91, "F"); doc.text(36, 91, "P");
               doc.text(25, 95, "---"); doc.text(35, 95, "---");
               doc.text(15, 99, "D"); doc.text(25, 99, this.res_16pf.rangoP.toString()); doc.text(35, 99, this.res_16pf.resP.toString());
               doc.text(15, 103, "A"); doc.text(25, 103, this.res_16pf.rangoA.toString()); doc.text(35, 103, this.res_16pf.resA.toString());
               doc.text(15, 107, "B"); doc.text(25, 107, this.res_16pf.rangoB.toString()); doc.text(35, 107, this.res_16pf.resB.toString());
               doc.text(15, 111, "C"); doc.text(25, 111, this.res_16pf.rangoC.toString()); doc.text(35, 111, this.res_16pf.resC.toString());
               doc.text(15, 115, "E"); doc.text(25, 115, this.res_16pf.rangoE.toString()); doc.text(35, 115, this.res_16pf.resE.toString());
               doc.text(15, 119, "F"); doc.text(25, 119, this.res_16pf.rangoF.toString()); doc.text(35, 119, this.res_16pf.resF.toString());
               doc.text(15, 123, "G"); doc.text(25, 123, this.res_16pf.rangoG.toString()); doc.text(35, 123, this.res_16pf.resG.toString());
               doc.text(15, 127, "H"); doc.text(25, 127, this.res_16pf.rangoH.toString()); doc.text(35, 127, this.res_16pf.resH.toString());
               doc.text(15, 131, "I"); doc.text(25, 131, this.res_16pf.rangoI.toString()); doc.text(35, 131, this.res_16pf.resI.toString());
               doc.text(15, 135, "L"); doc.text(25, 135, this.res_16pf.rangoL.toString()); doc.text(35, 135, this.res_16pf.resL.toString());
               doc.text(15, 139, "M"); doc.text(25, 139, this.res_16pf.rangoM.toString()); doc.text(35, 139, this.res_16pf.resM.toString());
               doc.text(15, 143, "N"); doc.text(25, 143, this.res_16pf.rangoN.toString()); doc.text(35, 143, this.res_16pf.resN.toString());
               doc.text(15, 147, "O"); doc.text(25, 147, this.res_16pf.rangoO.toString()); doc.text(35, 147, this.res_16pf.resO.toString());
               doc.text(15, 151, "Q1"); doc.text(25, 151, this.res_16pf.rangoQ1.toString()); doc.text(35, 151, this.res_16pf.resQ1.toString());
               doc.text(15, 155, "Q2"); doc.text(25, 155, this.res_16pf.rangoQ2.toString()); doc.text(35, 155, this.res_16pf.resQ2.toString());
               doc.text(15, 159, "Q3"); doc.text(25, 159, this.res_16pf.rangoQ3.toString()); doc.text(35, 159, this.res_16pf.resQ3.toString());
               doc.text(15, 163, "Q4"); doc.text(25, 163, this.res_16pf.rangoQ4.toString()); doc.text(35, 163, this.res_16pf.resQ4.toString());

          },
          rangosH: function (res, caso) {

               var rango = '*';
               switch (caso) {
                    case 'A': {
                         let comp1 = (res >= 0 && res <= 3); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 4 && res <= 5); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 6 && res <= 6); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 8 && res <= 8); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 9 && res <= 9); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 10 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 12 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'B': {
                         let comp1 = (res >= 0 && res <= 1); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 2 && res <= 2); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 3 && res <= 3); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 4 && res <= 4); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 5 && res <= 5); if (comp5 === true) { rango = '7'; }
                         let comp6 = (res >= 6 && res <= 6); if (comp6 === true) { rango = '9'; }
                         break;
                    }
                    case 'C': {
                         let comp1 = (res >= 0 && res <= 3); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 4 && res <= 5); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 6 && res <= 6); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 8 && res <= 8); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 9 && res <= 9); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 10 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 12 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'E': {
                         let comp1 = (res >= 0 && res <= 0); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 1 && res <= 1); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 2 && res <= 2); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 3 && res <= 3); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 4 && res <= 4); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 5 && res <= 6); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 7 && res <= 7); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 8 && res <= 9); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 10 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'F': {
                         let comp1 = (res >= 0 && res <= 2); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 3 && res <= 4); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 5 && res <= 5); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 6 && res <= 6); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 7 && res <= 7); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 8 && res <= 8); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 9 && res <= 9); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 10 && res <= 10); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 11 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'G': {
                         let comp1 = (res >= 1 && res <= 2); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 2 && res <= 4); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 4 && res <= 5); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 6 && res <= 6); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 7 && res <= 7); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 8 && res <= 8); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 9 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 12 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'H': {
                         let comp1 = (res >= 0 && res <= 3); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 4 && res <= 5); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 6 && res <= 6); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 8 && res <= 8); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 9 && res <= 9); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 10 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 11 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'I': {
                         let comp1 = (res >= 11 && res <= 12); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 10 && res <= 10); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 8 && res <= 9); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 5 && res <= 6); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 4 && res <= 4); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 2 && res <= 3); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 1 && res <= 1); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 0 && res <= 0); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'L': {
                         let comp1 = (res >= 11 && res <= 12); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 10 && res <= 10); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 9 && res <= 9); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 8 && res <= 8); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 6 && res <= 7); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 5 && res <= 5); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 4 && res <= 4); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 2 && res <= 2); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 0 && res <= 1); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'M': {
                         let comp1 = (res >= 11 && res <= 12); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 9 && res <= 10); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 8 && res <= 8); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 6 && res <= 6); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 5 && res <= 5); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 3 && res <= 4); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 2 && res <= 2); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 0 && res <= 1); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'N': {
                         let comp1 = (res >= 0 && res <= 1); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 2 && res <= 2); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 3 && res <= 3); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 4 && res <= 4); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 5 && res <= 5); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 6 && res <= 6); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 7 && res <= 7); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 8 && res <= 9); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 10 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'O': {
                         let comp1 = (res >= 9 && res <= 12); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 7 && res <= 8); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 6 && res <= 6); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 5 && res <= 5); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 4 && res <= 4); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 3 && res <= 3); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 2 && res <= 2); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 1 && res <= 1); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 0 && res <= 0); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'Q1': {
                         let comp1 = (res >= 0 && res <= 0); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 1 && res <= 1); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 2 && res <= 3); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 4 && res <= 4); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 5 && res <= 5); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 6 && res <= 7); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 8 && res <= 8); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 9 && res <= 10); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 11 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'Q2': {
                         let comp1 = (res >= 0 && res <= 3); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 4 && res <= 5); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 6 && res <= 6); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 7 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 8 && res <= 8); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 9 && res <= 9); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 10 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 12 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'Q3': {
                         let comp1 = (res >= 0 && res <= 2); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 3 && res <= 4); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 5 && res <= 5); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 6 && res <= 6); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 7 && res <= 8); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 9 && res <= 9); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 10 && res <= 10); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 11 && res <= 11); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 12 && res <= 12); if (comp9 === true) { rango = '9'; }
                         break;
                    }
                    case 'Q4': {
                         let comp1 = (res >= 11 && res <= 12); if (comp1 === true) { rango = '1'; }
                         let comp2 = (res >= 9 && res <= 10); if (comp2 === true) { rango = '2'; }
                         let comp3 = (res >= 8 && res <= 8); if (comp3 === true) { rango = '3'; }
                         let comp4 = (res >= 6 && res <= 7); if (comp4 === true) { rango = '4'; }
                         let comp5 = (res >= 5 && res <= 5); if (comp5 === true) { rango = '5'; }
                         let comp6 = (res >= 4 && res <= 4); if (comp6 === true) { rango = '6'; }
                         let comp7 = (res >= 3 && res <= 3); if (comp7 === true) { rango = '7'; }
                         let comp8 = (res >= 2 && res <= 2); if (comp8 === true) { rango = '8'; }
                         let comp9 = (res >= 0 && res <= 1); if (comp9 === true) { rango = '9'; }
                         break;
                    }
               } // switch
               return rango;
          },
          resultadosH: function (pg1, pg2, pg3, pg4, pg5, pg6, caso) {

               var conteo = 0;
               var cadena = '**';
               switch (caso) {
                    case 'P': {
                         if (pg1 === 'a') { conteo = conteo + 2; cadena = cadena + "pg01-a; "; } else { if (pg1 === 'b') { conteo = conteo + 1; cadena = cadena + "pg01-b; "; } }
                         if (pg2 === 'b') { conteo = conteo + 1; cadena = cadena + "pg18-b; "; } else { if (pg2 === 'c') { conteo = conteo + 2; cadena = cadena + "pg18-c; "; } }
                         if (pg3 === 'b') { conteo = conteo + 1; cadena = cadena + "pg35-b; "; } else { if (pg3 === 'c') { conteo = conteo + 2; cadena = cadena + "pg35-c; "; } }
                         if (pg4 === 'a') { conteo = conteo + 2; cadena = cadena + "pg52-a; "; } else { if (pg4 === 'b') { conteo = conteo + 1; cadena = cadena + "pg52-b; "; } }
                         if (pg5 === 'b') { conteo = conteo + 1; cadena = cadena + "pg69-b; "; } else { if (pg5 === 'c') { conteo = conteo + 2; cadena = cadena + "pg69-c; "; } }
                         if (pg6 === 'b') { conteo = conteo + 1; cadena = cadena + "pg86-b; "; } else { if (pg6 === 'c') { conteo = conteo + 2; cadena = cadena + "pg86-c; "; } }
                         break;
                    }
                    case 'A': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'B': {
                         if (pg1 === 'b') { conteo = conteo + 1 }
                         if (pg2 === 'c') { conteo = conteo + 1 }
                         if (pg3 === 'b') { conteo = conteo + 1 }
                         if (pg4 === 'c') { conteo = conteo + 1 }
                         if (pg5 === 'b') { conteo = conteo + 1 }
                         if (pg6 === 'c') { conteo = conteo + 1 }
                         break;
                    }
                    case 'C': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'E': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'a') { conteo = conteo + 2 } else { if (pg6 === 'b') { conteo = conteo + 1 } }
                         break;
                    }
                    case 'F': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'G': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'b') { conteo = conteo + 1 } else { if (pg4 === 'c') { conteo = conteo + 2 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'H': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'I': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'L': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } } // 1
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'b') { conteo = conteo + 1 } else { if (pg4 === 'c') { conteo = conteo + 2 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'a') { conteo = conteo + 2 } else { if (pg6 === 'b') { conteo = conteo + 1 } }
                         break;
                    }
                    case 'M': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'a') { conteo = conteo + 2 } else { if (pg5 === 'b') { conteo = conteo + 1 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'N': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'O': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'a') { conteo = conteo + 2 } else { if (pg6 === 'b') { conteo = conteo + 1 } }
                         break;
                    }
                    case 'Q1': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'b') { conteo = conteo + 1 } else { if (pg4 === 'c') { conteo = conteo + 2 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'a') { conteo = conteo + 2 } else { if (pg6 === 'b') { conteo = conteo + 1 } }
                         break;
                    }
                    case 'Q2': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'b') { conteo = conteo + 1 } else { if (pg2 === 'c') { conteo = conteo + 2 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'Q3': {
                         if (pg1 === 'a') { conteo = conteo + 2 } else { if (pg1 === 'b') { conteo = conteo + 1 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'a') { conteo = conteo + 2 } else { if (pg3 === 'b') { conteo = conteo + 1 } }
                         if (pg4 === 'b') { conteo = conteo + 1 } else { if (pg4 === 'c') { conteo = conteo + 2 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'b') { conteo = conteo + 1 } else { if (pg6 === 'c') { conteo = conteo + 2 } }
                         break;
                    }
                    case 'Q4': {
                         if (pg1 === 'b') { conteo = conteo + 1 } else { if (pg1 === 'c') { conteo = conteo + 2 } }
                         if (pg2 === 'a') { conteo = conteo + 2 } else { if (pg2 === 'b') { conteo = conteo + 1 } }
                         if (pg3 === 'b') { conteo = conteo + 1 } else { if (pg3 === 'c') { conteo = conteo + 2 } }
                         if (pg4 === 'a') { conteo = conteo + 2 } else { if (pg4 === 'b') { conteo = conteo + 1 } }
                         if (pg5 === 'b') { conteo = conteo + 1 } else { if (pg5 === 'c') { conteo = conteo + 2 } }
                         if (pg6 === 'a') { conteo = conteo + 2 } else { if (pg6 === 'b') { conteo = conteo + 1 } }
                         break;
                    }
               } // switch

               console.log("[ resultadosH ] ( ", pg1, pg2, pg3, pg4, pg5, pg6, caso, " ) ( ", conteo, cadena, " )");
               return conteo;
          }, // resultadosH()
          respuestas16pf(doc) {

               console.log("Respuestas ");
               console.log(this.eval_16pf);
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);



               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               // doc.text(10, 45, this.eval_16pf.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
               doc.text(10, 45, this.eval_16pf.pg001 === "a" ? "| 01= (a)" : this.eval_16pf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_16pf.pg002 === "a" ? "| 02= (a)" : this.eval_16pf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_16pf.pg003 === "a" ? "| 03= (a)" : this.eval_16pf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_16pf.pg004 === "a" ? "| 04= (a)" : this.eval_16pf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_16pf.pg005 === "a" ? "| 05= (a)" : this.eval_16pf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_16pf.pg006 === "a" ? "| 06= (a)" : this.eval_16pf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_16pf.pg007 === "a" ? "| 07= (a)" : this.eval_16pf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_16pf.pg008 === "a" ? "| 08= (a)" : this.eval_16pf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_16pf.pg009 === "a" ? "| 09= (a)" : this.eval_16pf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_16pf.pg010 === "a" ? "| 10= (a)" : this.eval_16pf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_16pf.pg011 === "a" ? "| 11= (a)" : this.eval_16pf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_16pf.pg012 === "a" ? "| 12= (a)" : this.eval_16pf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_16pf.pg013 === "a" ? "| 13= (a)" : this.eval_16pf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_16pf.pg014 === "a" ? "| 14= (a)" : this.eval_16pf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_16pf.pg015 === "a" ? "| 15= (a) |" : this.eval_16pf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_16pf.pg016 === "a" ? "| 16= (a)" : this.eval_16pf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_16pf.pg017 === "a" ? "| 17= (a)" : this.eval_16pf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_16pf.pg018 === "a" ? "| 18= (a)" : this.eval_16pf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_16pf.pg019 === "a" ? "| 19= (a)" : this.eval_16pf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_16pf.pg020 === "a" ? "| 20= (a)" : this.eval_16pf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_16pf.pg021 === "a" ? "| 21= (a)" : this.eval_16pf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_16pf.pg022 === "a" ? "| 22= (a)" : this.eval_16pf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_16pf.pg023 === "a" ? "| 23= (a)" : this.eval_16pf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_16pf.pg024 === "a" ? "| 24= (a)" : this.eval_16pf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_16pf.pg025 === "a" ? "| 25= (a)" : this.eval_16pf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_16pf.pg026 === "a" ? "| 26= (a)" : this.eval_16pf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_16pf.pg027 === "a" ? "| 27= (a)" : this.eval_16pf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_16pf.pg028 === "a" ? "| 28= (a)" : this.eval_16pf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_16pf.pg029 === "a" ? "| 29= (a)" : this.eval_16pf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_16pf.pg030 === "a" ? "| 30= (a) |" : this.eval_16pf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_16pf.pg031 === "a" ? "| 31= (a)" : this.eval_16pf.pg031 === "b" ? "| 39= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_16pf.pg032 === "a" ? "| 32= (a)" : this.eval_16pf.pg032 === "b" ? "| 39= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_16pf.pg033 === "a" ? "| 33= (a)" : this.eval_16pf.pg033 === "b" ? "| 39= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_16pf.pg034 === "a" ? "| 34= (a)" : this.eval_16pf.pg034 === "b" ? "| 39= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_16pf.pg035 === "a" ? "| 35= (a)" : this.eval_16pf.pg035 === "b" ? "| 39= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_16pf.pg036 === "a" ? "| 36= (a)" : this.eval_16pf.pg036 === "b" ? "| 39= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_16pf.pg037 === "a" ? "| 37= (a)" : this.eval_16pf.pg037 === "b" ? "| 39= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_16pf.pg038 === "a" ? "| 38= (a)" : this.eval_16pf.pg038 === "b" ? "| 39= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_16pf.pg039 === "a" ? "| 39= (a)" : this.eval_16pf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_16pf.pg040 === "a" ? "| 40= (a)" : this.eval_16pf.pg040 === "b" ? "| 39= (b)" : "| 40= (c)");
               doc.text(140, 53, this.eval_16pf.pg041 === "a" ? "| 41= (a)" : this.eval_16pf.pg041 === "b" ? "| 39= (b)" : "| 41= (c)");
               doc.text(153, 53, this.eval_16pf.pg042 === "a" ? "| 42= (a)" : this.eval_16pf.pg042 === "b" ? "| 39= (b)" : "| 42= (c)");
               doc.text(166, 53, this.eval_16pf.pg043 === "a" ? "| 43= (a)" : this.eval_16pf.pg043 === "b" ? "| 39= (b)" : "| 43= (c)");
               doc.text(179, 53, this.eval_16pf.pg044 === "a" ? "| 44= (a)" : this.eval_16pf.pg044 === "b" ? "| 39= (b)" : "| 44= (c)");
               doc.text(192, 53, this.eval_16pf.pg045 === "a" ? "| 45= (a) |" : this.eval_16pf.pg045 === "b" ? "| 39= (b) |" : "| 45= (c) |");
               doc.line(10, 54, 206, 54);

               doc.text(10, 57, this.eval_16pf.pg046 === "a" ? "| 46= (a)" : this.eval_16pf.pg046 === "b" ? "| 46= (b)" : "| 46= (c)");
               doc.text(23, 57, this.eval_16pf.pg047 === "a" ? "| 47= (a)" : this.eval_16pf.pg047 === "b" ? "| 47= (b)" : "| 47= (c)");
               doc.text(36, 57, this.eval_16pf.pg048 === "a" ? "| 48= (a)" : this.eval_16pf.pg048 === "b" ? "| 48= (b)" : "| 48= (c)");
               doc.text(49, 57, this.eval_16pf.pg049 === "a" ? "| 49= (a)" : this.eval_16pf.pg049 === "b" ? "| 49= (b)" : "| 49= (c)");
               doc.text(62, 57, this.eval_16pf.pg050 === "a" ? "| 50= (a)" : this.eval_16pf.pg050 === "b" ? "| 50= (b)" : "| 50= (c)");
               doc.text(75, 57, this.eval_16pf.pg051 === "a" ? "| 51= (a)" : this.eval_16pf.pg051 === "b" ? "| 51= (b)" : "| 51= (c)");
               doc.text(88, 57, this.eval_16pf.pg052 === "a" ? "| 52= (a)" : this.eval_16pf.pg052 === "b" ? "| 52= (b)" : "| 52= (c)");
               doc.text(101, 57, this.eval_16pf.pg053 === "a" ? "| 53= (a)" : this.eval_16pf.pg053 === "b" ? "| 53= (b)" : "| 53= (c)");
               doc.text(114, 57, this.eval_16pf.pg054 === "a" ? "| 54= (a)" : this.eval_16pf.pg054 === "b" ? "| 54= (b)" : "| 54= (c)");
               doc.text(127, 57, this.eval_16pf.pg055 === "a" ? "| 55= (a)" : this.eval_16pf.pg055 === "b" ? "| 55= (b)" : "| 55= (c)");
               doc.text(140, 57, this.eval_16pf.pg056 === "a" ? "| 56= (a)" : this.eval_16pf.pg056 === "b" ? "| 56= (b)" : "| 56= (c)");
               doc.text(153, 57, this.eval_16pf.pg057 === "a" ? "| 57= (a)" : this.eval_16pf.pg057 === "b" ? "| 57= (b)" : "| 57= (c)");
               doc.text(166, 57, this.eval_16pf.pg058 === "a" ? "| 58= (a)" : this.eval_16pf.pg058 === "b" ? "| 58= (b)" : "| 58= (c)");
               doc.text(179, 57, this.eval_16pf.pg059 === "a" ? "| 59= (a)" : this.eval_16pf.pg059 === "b" ? "| 59= (b)" : "| 59= (c)");
               doc.text(192, 57, this.eval_16pf.pg060 === "a" ? "| 60= (a) |" : this.eval_16pf.pg060 === "b" ? "| 60= (b) |" : "| 60= (c) |");
               doc.line(10, 58, 206, 58);

               doc.text(10, 61, this.eval_16pf.pg061 === "a" ? "| 61= (a)" : this.eval_16pf.pg061 === "b" ? "| 61= (b)" : "| 61= (c)");
               doc.text(23, 61, this.eval_16pf.pg062 === "a" ? "| 62= (a)" : this.eval_16pf.pg062 === "b" ? "| 62= (b)" : "| 62= (c)");
               doc.text(36, 61, this.eval_16pf.pg063 === "a" ? "| 63= (a)" : this.eval_16pf.pg063 === "b" ? "| 63= (b)" : "| 63= (c)");
               doc.text(49, 61, this.eval_16pf.pg064 === "a" ? "| 64= (a)" : this.eval_16pf.pg064 === "b" ? "| 64= (b)" : "| 64= (c)");
               doc.text(62, 61, this.eval_16pf.pg065 === "a" ? "| 65= (a)" : this.eval_16pf.pg065 === "b" ? "| 65= (b)" : "| 65= (c)");
               doc.text(75, 61, this.eval_16pf.pg066 === "a" ? "| 66= (a)" : this.eval_16pf.pg066 === "b" ? "| 66= (b)" : "| 66= (c)");
               doc.text(88, 61, this.eval_16pf.pg067 === "a" ? "| 67= (a)" : this.eval_16pf.pg067 === "b" ? "| 67= (b)" : "| 67= (c)");
               doc.text(101, 61, this.eval_16pf.pg068 === "a" ? "| 68= (a)" : this.eval_16pf.pg068 === "b" ? "| 68= (b)" : "| 68= (c)");
               doc.text(114, 61, this.eval_16pf.pg069 === "a" ? "| 69= (a)" : this.eval_16pf.pg069 === "b" ? "| 69= (b)" : "| 69= (c)");
               doc.text(127, 61, this.eval_16pf.pg070 === "a" ? "| 70= (a)" : this.eval_16pf.pg070 === "b" ? "| 70= (b)" : "| 70= (c)");
               doc.text(140, 61, this.eval_16pf.pg071 === "a" ? "| 71= (a)" : this.eval_16pf.pg071 === "b" ? "| 71= (b)" : "| 71= (c)");
               doc.text(153, 61, this.eval_16pf.pg072 === "a" ? "| 72= (a)" : this.eval_16pf.pg072 === "b" ? "| 72= (b)" : "| 72= (c)");
               doc.text(166, 61, this.eval_16pf.pg073 === "a" ? "| 73= (a)" : this.eval_16pf.pg073 === "b" ? "| 73= (b)" : "| 73= (c)");
               doc.text(179, 61, this.eval_16pf.pg074 === "a" ? "| 74= (a)" : this.eval_16pf.pg074 === "b" ? "| 74= (b)" : "| 74= (c)");
               doc.text(192, 61, this.eval_16pf.pg075 === "a" ? "| 75= (a) |" : this.eval_16pf.pg075 === "b" ? "| 75= (b) |" : "| 75= (c) |");
               doc.line(10, 62, 206, 62);

               doc.text(10, 65, this.eval_16pf.pg076 === "a" ? "| 76= (a)" : this.eval_16pf.pg076 === "b" ? "| 76= (b)" : "| 76= (c)");
               doc.text(23, 65, this.eval_16pf.pg077 === "a" ? "| 77= (a)" : this.eval_16pf.pg077 === "b" ? "| 77= (b)" : "| 77= (c)");
               doc.text(36, 65, this.eval_16pf.pg078 === "a" ? "| 78= (a)" : this.eval_16pf.pg078 === "b" ? "| 78= (b)" : "| 78= (c)");
               doc.text(49, 65, this.eval_16pf.pg079 === "a" ? "| 79= (a)" : this.eval_16pf.pg079 === "b" ? "| 79= (b)" : "| 79= (c)");
               doc.text(62, 65, this.eval_16pf.pg080 === "a" ? "| 80= (a)" : this.eval_16pf.pg080 === "b" ? "| 80= (b)" : "| 80= (c)");
               doc.text(75, 65, this.eval_16pf.pg081 === "a" ? "| 81= (a)" : this.eval_16pf.pg081 === "b" ? "| 81= (b)" : "| 81= (c)");
               doc.text(88, 65, this.eval_16pf.pg082 === "a" ? "| 82= (a)" : this.eval_16pf.pg082 === "b" ? "| 82= (b)" : "| 82= (c)");
               doc.text(101, 65, this.eval_16pf.pg083 === "a" ? "| 83= (a)" : this.eval_16pf.pg083 === "b" ? "| 83= (b)" : "| 83= (c)");
               doc.text(114, 65, this.eval_16pf.pg084 === "a" ? "| 84= (a)" : this.eval_16pf.pg084 === "b" ? "| 84= (b)" : "| 84= (c)");
               doc.text(127, 65, this.eval_16pf.pg085 === "a" ? "| 85= (a)" : this.eval_16pf.pg085 === "b" ? "| 85= (b)" : "| 85= (c)");
               doc.text(140, 65, this.eval_16pf.pg086 === "a" ? "| 86= (a)" : this.eval_16pf.pg086 === "b" ? "| 86= (b)" : "| 86= (c)");
               doc.text(153, 65, this.eval_16pf.pg087 === "a" ? "| 87= (a)" : this.eval_16pf.pg087 === "b" ? "| 87= (b)" : "| 87= (c)");
               doc.text(166, 65, this.eval_16pf.pg088 === "a" ? "| 88= (a)" : this.eval_16pf.pg088 === "b" ? "| 88= (b)" : "| 88= (c)");
               doc.text(179, 65, this.eval_16pf.pg089 === "a" ? "| 89= (a)" : this.eval_16pf.pg089 === "b" ? "| 89= (b)" : "| 89= (c)");
               doc.text(192, 65, this.eval_16pf.pg090 === "a" ? "| 90= (a) |" : this.eval_16pf.pg090 === "b" ? "| 90= (b) |" : "| 90= (c) |");
               doc.line(10, 66, 206, 66);

               doc.text(10, 69, this.eval_16pf.pg091 === "a" ? "| 91= (a)" : this.eval_16pf.pg091 === "b" ? "| 91= (b)" : "| 91= (c)");
               doc.text(23, 69, this.eval_16pf.pg092 === "a" ? "| 92= (a)" : this.eval_16pf.pg092 === "b" ? "| 92= (b)" : "| 92= (c)");
               doc.text(36, 69, this.eval_16pf.pg093 === "a" ? "| 93= (a)" : this.eval_16pf.pg093 === "b" ? "| 93= (b)" : "| 93= (c)");
               doc.text(49, 69, this.eval_16pf.pg094 === "a" ? "| 94= (a)" : this.eval_16pf.pg094 === "b" ? "| 94= (b)" : "| 94= (c)");
               doc.text(62, 69, this.eval_16pf.pg095 === "a" ? "| 95= (a)" : this.eval_16pf.pg095 === "b" ? "| 95= (b)" : "| 95= (c)");
               doc.text(75, 69, this.eval_16pf.pg096 === "a" ? "| 96= (a)" : this.eval_16pf.pg096 === "b" ? "| 96= (b)" : "| 96= (c)");
               doc.text(88, 69, this.eval_16pf.pg097 === "a" ? "| 97= (a)" : this.eval_16pf.pg097 === "b" ? "| 97= (b)" : "| 97= (c)");
               doc.text(101, 69, this.eval_16pf.pg098 === "a" ? "| 98= (a)" : this.eval_16pf.pg098 === "b" ? "| 98= (b)" : "| 98= (c)");
               doc.text(114, 69, this.eval_16pf.pg099 === "a" ? "| 99= (a)" : this.eval_16pf.pg099 === "b" ? "| 99= (b)" : "| 99= (c)");
               doc.text(127, 69, this.eval_16pf.pg100 === "a" ? "| 100= (a)" : this.eval_16pf.pg100 === "b" ? "| 100= (b)" : "| 100= (c)");
               doc.text(140, 69, this.eval_16pf.pg101 === "a" ? "| 101= (a)" : this.eval_16pf.pg101 === "b" ? "| 101= (b)" : "| 101= (c)");
               doc.text(153, 69, this.eval_16pf.pg102 === "a" ? "| 102= (a) |" : this.eval_16pf.pg102 === "b" ? "| 102= (b) |" : "| 102= (c) |");
               doc.line(10, 70, 168, 70);
          },
          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_npf() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_npf.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "npf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de ESTABILIDAD para " + this.eval_npf.nombre + " de " + this.eval_npf.empresa);

               this.respuestasnpf(doc);
               this.resultadosnpf(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosnpf() {

               this.res_npf = {
                    Uno: 0, Dos: 0, Cero: 0, Uno2: 0, Dos2: 0, Cero2: 0,
                    cpreviaIzq: 0, cpreviaDer: 0,
                    rangos: 0,
               },
                    /* Resuelve para la pregunta 1 */
                    console.log("================================");
               console.log("En rangosnpf");
               switch (this.eval_npf.pg001) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2; console.log("Es a)");
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1; console.log("Es b)");
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1; console.log("Es c)");
                         break;
               }
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);


               /* Resuelve para la pregunta 2 */
               switch (this.eval_npf.pg002) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_npf.pg003) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg004) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_npf.pg005) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_npf.pg006) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 3 */
               switch (this.eval_npf.pg007) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg008) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 9 */
               /* ======================================================== */
               switch (this.eval_npf.pg009) {
                    case 'a': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg010) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg011) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg012) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_npf.pg013) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 14 */
               /* ======================================================== */
               switch (this.eval_npf.pg014) {
                    case 'a': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg015) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 16 */
               switch (this.eval_npf.pg016) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_npf.pg017) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg018) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 19 */
               /* ======================================================== */
               console.log("a evaluar 19")
               switch (this.eval_npf.pg019) {
                    case 'a': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1; console.log("19 es b !!")
                         break;
                    case 'c': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg020) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 17 */
               switch (this.eval_npf.pg021) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg022) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 23 */
               /* ======================================================== */
               switch (this.eval_npf.pg023) {
                    case 'a': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               switch (this.eval_npf.pg024) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg025) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg026) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg027) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 28 */
               /* ======================================================== */
               switch (this.eval_npf.pg028) {
                    case 'a': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
               }
               switch (this.eval_npf.pg029) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg030) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg031) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg032) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg033) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg034) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg035) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg036) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 37 */
               /* ======================================================== */
               switch (this.eval_npf.pg037) {
                    case 'a': this.res_npf.Cero2 = this.res_npf.Cero2 + 1;
                         break;
                    case 'b': this.res_npf.Uno2 = this.res_npf.Uno2 + 1;
                         break;
                    case 'c': this.res_npf.Dos2 = this.res_npf.Dos2 + 2;
                         break;
               }
               switch (this.eval_npf.pg038) {
                    case 'a': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
               }
               switch (this.eval_npf.pg039) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               switch (this.eval_npf.pg040) {
                    case 'a': this.res_npf.Dos = this.res_npf.Dos + 2;
                         break;
                    case 'b': this.res_npf.Uno = this.res_npf.Uno + 1;
                         break;
                    case 'c': this.res_npf.Cero = this.res_npf.Cero + 1;
                         break;
               }
               console.log(">>> PRIMERAS 15 PREGUNTAS");
               console.log("pg1 ? ", this.eval_npf.pg001, "pg2 ? ", this.eval_npf.pg002, "pg3 ? ", this.eval_npf.pg003, "pg4 ? ", this.eval_npf.pg004, "pg5 ? ", this.eval_npf.pg005,
                    "pg6 ? ", this.eval_npf.pg006, "pg7 ? ", this.eval_npf.pg007, "pg8 ? ", this.eval_npf.pg008, "pg9 ? ", this.eval_npf.pg009, "pg10 ? ", this.eval_npf.pg010,
                    "pg11 ? ", this.eval_npf.pg011, "pg12 ? ", this.eval_npf.pg012, "pg13 ? ", this.eval_npf.pg013, "pg14 ? ", this.eval_npf.pg014, "pg15 ? ", this.eval_npf.pg015,
                    "pg16 ? ", this.eval_npf.pg016, "pg17 ? ", this.eval_npf.pg017, "pg18 ? ", this.eval_npf.pg018, "pg19 ? ", this.eval_npf.pg019, "pg20 ? ", this.eval_npf.pg020,
                    "pg21 ? ", this.eval_npf.pg021, "pg22 ? ", this.eval_npf.pg022, "pg23 ? ", this.eval_npf.pg023, "pg24 ? ", this.eval_npf.pg024, "pg25 ? ", this.eval_npf.pg025,
                    "pg26 ? ", this.eval_npf.pg026, "pg27 ? ", this.eval_npf.pg027, "pg28 ? ", this.eval_npf.pg028, "pg29 ? ", this.eval_npf.pg029, "pg30 ? ", this.eval_npf.pg030,
                    "pg31 ? ", this.eval_npf.pg031, "pg32 ? ", this.eval_npf.pg032, "pg33 ? ", this.eval_npf.pg033, "pg34 ? ", this.eval_npf.pg034, "pg35 ? ", this.eval_npf.pg035,
                    "pg36 ? ", this.eval_npf.pg036, "pg37 ? ", this.eval_npf.pg037, "pg38 ? ", this.eval_npf.pg038, "pg39 ? ", this.eval_npf.pg039, "pg40 ? ", this.eval_npf.pg040);
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);
               console.log("uno2 ? ", this.res_npf.Uno2, "; dos2 ? ", this.res_npf.Dos2, "; Cero2 ? ", this.res_npf.Cero2);

               console.log("**");
               console.log("uno ? ", this.res_npf.Uno, "; dos ? ", this.res_npf.Dos, "; Cero ? ", this.res_npf.Cero);
               console.log("uno2 ? ", this.res_npf.Uno2, "; dos2 ? ", this.res_npf.Dos2, "; Cero2 ? ", this.res_npf.Cero2);

               this.res_npf.cprevia = this.res_npf.Uno + this.res_npf.Dos;
               this.res_npf.cpreviaIzq = 0;
               this.res_npf.cpreviaDer = this.res_npf.Uno2 + this.res_npf.Dos2;
               if (this.res_npf.cpreviaDer >= 1000000) {
                    this.res_npf.cpreviaIzq = this.res_npf.cprevia - this.res_npf.cpreviaDer;
               } else {
                    this.res_npf.cpreviaIzq = this.res_npf.cprevia;
               }

               /* ================================================================================================= */
               /*  COMPARADOR DE RANGOS */
               let comp1 = (this.res_npf.cpreviaIzq >= 21 && this.res_npf.cpreviaIzq <= 25);
               if (comp1 === true) {
                    this.res_npf.rango = 1;
               }
               let comp2 = (this.res_npf.cpreviaIzq >= 26 && this.res_npf.cpreviaIzq <= 28);
               if (comp2 === true) {
                    this.res_npf.rango = 2;
               }
               let comp3 = (this.res_npf.cpreviaIzq >= 29 && this.res_npf.cpreviaIzq <= 31);
               if (comp3 === true) {
                    this.res_npf.rango = 3;
               }
               let comp4 = (this.res_npf.cpreviaIzq >= 32 && this.res_npf.cpreviaIzq <= 34);
               if (comp4 === true) {
                    this.res_npf.rango = 4;
               }
               let comp5 = (this.res_npf.cpreviaIzq >= 35 && this.res_npf.cpreviaIzq <= 37);
               if (comp5 === true) {
                    this.res_npf.rango = 5;
               }
               let comp6 = (this.res_npf.cpreviaIzq >= 38 && this.res_npf.cpreviaIzq <= 39);
               if (comp6 === true) {
                    this.res_npf.rango = 6;
               }
               let comp7 = (this.res_npf.cpreviaIzq >= 40 && this.res_npf.cpreviaIzq <= 44);
               if (comp7 === true) {
                    this.res_npf.rango = 7;
               }
               let comp8 = (this.res_npf.cpreviaIzq >= 45 && this.res_npf.cpreviaIzq <= 51);
               if (comp8 === true) {
                    this.res_npf.rango = 8;
               }
               let comp9 = (this.res_npf.cpreviaIzq >= 52 && this.res_npf.cpreviaIzq <= 68);
               if (comp9 === true) {
                    this.res_npf.rango = 9;
               }
               if (this.res_npf.cpreviaDer >= 10) {
                    this.res_npf.rango = this.res_npf.rango - 1;
               }

               this.res_npf.rangos = this.res_npf.rango;
               console.log("El rango es ? ", this.res_npf.rangos);

          },
          resultadosnpf(doc) {

               this.rangosnpf();

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ")
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_npf.Uno.toString());
               doc.text(38, 74, ", 1= ")
               doc.text(45, 74, this.res_npf.Dos.toString());
               doc.text(49, 74, ", 2= ")
               doc.text(56, 74, this.res_npf.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_npf.Uno2.toString());
               doc.text(81, 74, ", 1= ")
               doc.text(88, 74, this.res_npf.Dos2.toString());
               doc.text(91, 74, ", 2= ")
               doc.text(98, 74, this.res_npf.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_npf.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_npf.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_npf.rangos.toString());
               // doc.text(28, 85, this.res_npf.rangos.toString());

          },
          respuestasnpf(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_npf.pg001 === "a" ? "| 01= (a)" : this.eval_npf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_npf.pg002 === "a" ? "| 02= (a)" : this.eval_npf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_npf.pg003 === "a" ? "| 03= (a)" : this.eval_npf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_npf.pg004 === "a" ? "| 04= (a)" : this.eval_npf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_npf.pg005 === "a" ? "| 05= (a)" : this.eval_npf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_npf.pg006 === "a" ? "| 06= (a)" : this.eval_npf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_npf.pg007 === "a" ? "| 07= (a)" : this.eval_npf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_npf.pg008 === "a" ? "| 08= (a)" : this.eval_npf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_npf.pg009 === "a" ? "| 09= (a)" : this.eval_npf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_npf.pg010 === "a" ? "| 10= (a)" : this.eval_npf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_npf.pg011 === "a" ? "| 11= (a)" : this.eval_npf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_npf.pg012 === "a" ? "| 12= (a)" : this.eval_npf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_npf.pg013 === "a" ? "| 13= (a)" : this.eval_npf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_npf.pg014 === "a" ? "| 14= (a)" : this.eval_npf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_npf.pg015 === "a" ? "| 15= (a) |" : this.eval_npf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_npf.pg016 === "a" ? "| 16= (a)" : this.eval_npf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_npf.pg017 === "a" ? "| 17= (a)" : this.eval_npf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_npf.pg018 === "a" ? "| 18= (a)" : this.eval_npf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_npf.pg019 === "a" ? "| 19= (a)" : this.eval_npf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_npf.pg020 === "a" ? "| 20= (a)" : this.eval_npf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_npf.pg021 === "a" ? "| 21= (a)" : this.eval_npf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_npf.pg022 === "a" ? "| 22= (a)" : this.eval_npf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_npf.pg023 === "a" ? "| 23= (a)" : this.eval_npf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_npf.pg024 === "a" ? "| 24= (a)" : this.eval_npf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_npf.pg025 === "a" ? "| 25= (a)" : this.eval_npf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_npf.pg026 === "a" ? "| 26= (a)" : this.eval_npf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_npf.pg027 === "a" ? "| 27= (a)" : this.eval_npf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_npf.pg028 === "a" ? "| 28= (a)" : this.eval_npf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_npf.pg029 === "a" ? "| 29= (a)" : this.eval_npf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_npf.pg030 === "a" ? "| 30= (a) |" : this.eval_npf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_npf.pg031 === "a" ? "| 31= (a)" : this.eval_npf.pg031 === "b" ? "| 31= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_npf.pg032 === "a" ? "| 32= (a)" : this.eval_npf.pg032 === "b" ? "| 32= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_npf.pg033 === "a" ? "| 33= (a)" : this.eval_npf.pg033 === "b" ? "| 33= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_npf.pg034 === "a" ? "| 34= (a)" : this.eval_npf.pg034 === "b" ? "| 34= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_npf.pg035 === "a" ? "| 35= (a)" : this.eval_npf.pg035 === "b" ? "| 35= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_npf.pg036 === "a" ? "| 36= (a)" : this.eval_npf.pg036 === "b" ? "| 36= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_npf.pg037 === "a" ? "| 37= (a)" : this.eval_npf.pg037 === "b" ? "| 37= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_npf.pg038 === "a" ? "| 38= (a)" : this.eval_npf.pg038 === "b" ? "| 38= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_npf.pg039 === "a" ? "| 39= (a)" : this.eval_npf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_npf.pg040 === "a" ? "| 40= (a)" : this.eval_npf.pg040 === "b" ? "| 40= (b)" : "| 40= (c)");
               doc.line(10, 54, 141, 54);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_cpf() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_cpf.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "cpf_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SOCIABILIDAD para " + this.eval_cpf.nombre + " de " + this.eval_cpf.empresa);

               //? Calculo de respuestas y resultados
               this.respuestascpf(doc);
               this.resultadoscpf(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangoscpf() {

               switch (this.eval_cpf.pg001) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2; console.log("Es a)");
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1; console.log("Es b)");
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1; console.log("Es c)");
                         break;
               }
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);


               /* Resuelve para la pregunta 2 */
               switch (this.eval_cpf.pg002) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg003) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg004) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_cpf.pg005) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_cpf.pg006) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 3 */
               switch (this.eval_cpf.pg007) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg008) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 9 */
               /* ======================================================== */
               switch (this.eval_cpf.pg009) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg010) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg011) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg012) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_cpf.pg013) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }

               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 14 */
               /* ======================================================== */
               switch (this.eval_cpf.pg014) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg015) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 16 */
               switch (this.eval_cpf.pg016) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg017) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg018) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 19 */
               /* ======================================================== */
               console.log("a evaluar 19")
               switch (this.eval_cpf.pg019) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1; console.log("19 es b !!")
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg020) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }

               /* Resuelve para la pregunta 17 */
               switch (this.eval_cpf.pg021) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg022) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 23 */
               /* ======================================================== */
               switch (this.eval_cpf.pg023) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg024) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg025) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg026) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg027) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 28 */
               /* ======================================================== */
               switch (this.eval_cpf.pg028) {
                    case 'a': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
               }
               switch (this.eval_cpf.pg029) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg030) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg031) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg032) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg033) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg034) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg035) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg036) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               /* ======================================================== */
               /* CASO ESPECIAL */
               /* Resuelve para la pregunta 37 */
               /* ======================================================== */
               switch (this.eval_cpf.pg037) {
                    case 'a': this.res_cpf.Cero2 = this.res_cpf.Cero2 + 1;
                         break;
                    case 'b': this.res_cpf.Uno2 = this.res_cpf.Uno2 + 1;
                         break;
                    case 'c': this.res_cpf.Dos2 = this.res_cpf.Dos2 + 2;
                         break;
               }
               switch (this.eval_cpf.pg038) {
                    case 'a': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
               }
               switch (this.eval_cpf.pg039) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               switch (this.eval_cpf.pg040) {
                    case 'a': this.res_cpf.Dos = this.res_cpf.Dos + 2;
                         break;
                    case 'b': this.res_cpf.Uno = this.res_cpf.Uno + 1;
                         break;
                    case 'c': this.res_cpf.Cero = this.res_cpf.Cero + 1;
                         break;
               }
               console.log(">>> PRIMERAS 15 PREGUNTAS");
               console.log("pg1 ? ", this.eval_cpf.pg001, "pg2 ? ", this.eval_cpf.pg002, "pg3 ? ", this.eval_cpf.pg003, "pg4 ? ", this.eval_cpf.pg004, "pg5 ? ", this.eval_cpf.pg005,
                    "pg6 ? ", this.eval_cpf.pg006, "pg7 ? ", this.eval_cpf.pg007, "pg8 ? ", this.eval_cpf.pg008, "pg9 ? ", this.eval_cpf.pg009, "pg10 ? ", this.eval_cpf.pg010,
                    "pg11 ? ", this.eval_cpf.pg011, "pg12 ? ", this.eval_cpf.pg012, "pg13 ? ", this.eval_cpf.pg013, "pg14 ? ", this.eval_cpf.pg014, "pg15 ? ", this.eval_cpf.pg015,
                    "pg16 ? ", this.eval_cpf.pg016, "pg17 ? ", this.eval_cpf.pg017, "pg18 ? ", this.eval_cpf.pg018, "pg19 ? ", this.eval_cpf.pg019, "pg20 ? ", this.eval_cpf.pg020,
                    "pg21 ? ", this.eval_cpf.pg021, "pg22 ? ", this.eval_cpf.pg022, "pg23 ? ", this.eval_cpf.pg023, "pg24 ? ", this.eval_cpf.pg024, "pg25 ? ", this.eval_cpf.pg025,
                    "pg26 ? ", this.eval_cpf.pg026, "pg27 ? ", this.eval_cpf.pg027, "pg28 ? ", this.eval_cpf.pg028, "pg29 ? ", this.eval_cpf.pg029, "pg30 ? ", this.eval_cpf.pg030,
                    "pg31 ? ", this.eval_cpf.pg031, "pg32 ? ", this.eval_cpf.pg032, "pg33 ? ", this.eval_cpf.pg033, "pg34 ? ", this.eval_cpf.pg034, "pg35 ? ", this.eval_cpf.pg035,
                    "pg36 ? ", this.eval_cpf.pg036, "pg37 ? ", this.eval_cpf.pg037, "pg38 ? ", this.eval_cpf.pg038, "pg39 ? ", this.eval_cpf.pg039, "pg40 ? ", this.eval_cpf.pg040);
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               console.log("**");
               console.log("uno ? ", this.res_cpf.Uno, "; dos ? ", this.res_cpf.Dos, "; Cero ? ", this.res_cpf.Cero);
               console.log("uno2 ? ", this.res_cpf.Uno2, "; dos2 ? ", this.res_cpf.Dos2, "; Cero2 ? ", this.res_cpf.Cero2);

               this.res_cpf.cprevia = this.res_cpf.Uno + this.res_cpf.Dos;
               this.res_cpf.cpreviaIzq = 0;
               this.res_cpf.cpreviaDer = this.res_cpf.Uno2 + this.res_cpf.Dos2;
               if (this.res_cpf.cpreviaDer >= 1000000) {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia - this.res_cpf.cpreviaDer;
               } else {
                    this.res_cpf.cpreviaIzq = this.res_cpf.cprevia;
               }

               /* ================================================================================================= */
               /*  COMPARADOR DE RANGOS */
               let comp1 = (this.res_cpf.cpreviaIzq >= 21 && this.res_cpf.cpreviaIzq <= 25);
               if (comp1 === true) {
                    this.res_cpf.rango = 1;
               }
               let comp2 = (this.res_cpf.cpreviaIzq >= 26 && this.res_cpf.cpreviaIzq <= 28);
               if (comp2 === true) {
                    this.res_cpf.rango = 2;
               }
               let comp3 = (this.res_cpf.cpreviaIzq >= 29 && this.res_cpf.cpreviaIzq <= 31);
               if (comp3 === true) {
                    this.res_cpf.rango = 3;
               }
               let comp4 = (this.res_cpf.cpreviaIzq >= 32 && this.res_cpf.cpreviaIzq <= 34);
               if (comp4 === true) {
                    this.res_cpf.rango = 4;
               }
               let comp5 = (this.res_cpf.cpreviaIzq >= 35 && this.res_cpf.cpreviaIzq <= 37);
               if (comp5 === true) {
                    this.res_cpf.rango = 5;
               }
               let comp6 = (this.res_cpf.cpreviaIzq >= 38 && this.res_cpf.cpreviaIzq <= 39);
               if (comp6 === true) {
                    this.res_cpf.rango = 6;
               }
               let comp7 = (this.res_cpf.cpreviaIzq >= 40 && this.res_cpf.cpreviaIzq <= 44);
               if (comp7 === true) {
                    this.res_cpf.rango = 7;
               }
               let comp8 = (this.res_cpf.cpreviaIzq >= 45 && this.res_cpf.cpreviaIzq <= 51);
               if (comp8 === true) {
                    this.res_cpf.rango = 8;
               }
               let comp9 = (this.res_cpf.cpreviaIzq >= 52 && this.res_cpf.cpreviaIzq <= 68);
               if (comp9 === true) {
                    this.res_cpf.rango = 9;
               }
               if (this.res_cpf.cpreviaDer >= 10) {
                    this.res_cpf.rango = this.res_cpf.rango - 1;
               }

               this.res_cpf.rangos = this.res_cpf.rango;
               console.log("El rango es ? ", this.res_cpf.rangos);
          }, // rangos()

          resultadoscpf(doc) {

               this.rangoscpf();

               doc.setLineWidth(0.25);

               doc.text(10, 70, "SECCION DE RESULTADOS ")
               doc.line(10, 71, 206, 71);

               doc.text(10, 74, "Conteo:       ( 0= ");
               doc.text(35, 74, this.res_cpf.Uno.toString());
               doc.text(38, 74, ", 1= ")
               doc.text(45, 74, this.res_cpf.Dos.toString());
               doc.text(49, 74, ", 2= ")
               doc.text(56, 74, this.res_cpf.Cero.toString());
               doc.text(59, 74, " )");

               doc.text(70, 74, "( 0= ");
               doc.text(78, 74, this.res_cpf.Uno2.toString());
               doc.text(81, 74, ", 1= ")
               doc.text(88, 74, this.res_cpf.Dos2.toString());
               doc.text(91, 74, ", 2= ")
               doc.text(98, 74, this.res_cpf.Cero2.toString());
               doc.text(101, 74, " )");

               doc.text(10, 80, "Resultados: [ ");
               doc.text(30, 80, this.res_cpf.cpreviaIzq.toString());
               doc.text(35, 80, ", ");
               doc.text(40, 80, this.res_cpf.cpreviaDer.toString());
               doc.text(45, 80, " ] ");

               doc.text(10, 85, "Rangos: ");
               doc.text(28, 85, this.res_cpf.rangos.toString());
          },
          respuestascpf(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               doc.text(10, 45, this.eval_cpf.pg001 === "a" ? "| 01= (a)" : this.eval_cpf.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_cpf.pg002 === "a" ? "| 02= (a)" : this.eval_cpf.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_cpf.pg003 === "a" ? "| 03= (a)" : this.eval_cpf.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_cpf.pg004 === "a" ? "| 04= (a)" : this.eval_cpf.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_cpf.pg005 === "a" ? "| 05= (a)" : this.eval_cpf.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_cpf.pg006 === "a" ? "| 06= (a)" : this.eval_cpf.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_cpf.pg007 === "a" ? "| 07= (a)" : this.eval_cpf.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_cpf.pg008 === "a" ? "| 08= (a)" : this.eval_cpf.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_cpf.pg009 === "a" ? "| 09= (a)" : this.eval_cpf.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_cpf.pg010 === "a" ? "| 10= (a)" : this.eval_cpf.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_cpf.pg011 === "a" ? "| 11= (a)" : this.eval_cpf.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_cpf.pg012 === "a" ? "| 12= (a)" : this.eval_cpf.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_cpf.pg013 === "a" ? "| 13= (a)" : this.eval_cpf.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_cpf.pg014 === "a" ? "| 14= (a)" : this.eval_cpf.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_cpf.pg015 === "a" ? "| 15= (a) |" : this.eval_cpf.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_cpf.pg016 === "a" ? "| 16= (a)" : this.eval_cpf.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_cpf.pg017 === "a" ? "| 17= (a)" : this.eval_cpf.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_cpf.pg018 === "a" ? "| 18= (a)" : this.eval_cpf.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_cpf.pg019 === "a" ? "| 19= (a)" : this.eval_cpf.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_cpf.pg020 === "a" ? "| 20= (a)" : this.eval_cpf.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_cpf.pg021 === "a" ? "| 21= (a)" : this.eval_cpf.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_cpf.pg022 === "a" ? "| 22= (a)" : this.eval_cpf.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_cpf.pg023 === "a" ? "| 23= (a)" : this.eval_cpf.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_cpf.pg024 === "a" ? "| 24= (a)" : this.eval_cpf.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_cpf.pg025 === "a" ? "| 25= (a)" : this.eval_cpf.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_cpf.pg026 === "a" ? "| 26= (a)" : this.eval_cpf.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_cpf.pg027 === "a" ? "| 27= (a)" : this.eval_cpf.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_cpf.pg028 === "a" ? "| 28= (a)" : this.eval_cpf.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_cpf.pg029 === "a" ? "| 29= (a)" : this.eval_cpf.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_cpf.pg030 === "a" ? "| 30= (a) |" : this.eval_cpf.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_cpf.pg031 === "a" ? "| 31= (a)" : this.eval_cpf.pg031 === "b" ? "| 31= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_cpf.pg032 === "a" ? "| 32= (a)" : this.eval_cpf.pg032 === "b" ? "| 32= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_cpf.pg033 === "a" ? "| 33= (a)" : this.eval_cpf.pg033 === "b" ? "| 33= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_cpf.pg034 === "a" ? "| 34= (a)" : this.eval_cpf.pg034 === "b" ? "| 34= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_cpf.pg035 === "a" ? "| 35= (a)" : this.eval_cpf.pg035 === "b" ? "| 35= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_cpf.pg036 === "a" ? "| 36= (a)" : this.eval_cpf.pg036 === "b" ? "| 36= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_cpf.pg037 === "a" ? "| 37= (a)" : this.eval_cpf.pg037 === "b" ? "| 37= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_cpf.pg038 === "a" ? "| 38= (a)" : this.eval_cpf.pg038 === "b" ? "| 38= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_cpf.pg039 === "a" ? "| 39= (a)" : this.eval_cpf.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_cpf.pg040 === "a" ? "| 40= (a)" : this.eval_cpf.pg040 === "b" ? "| 40= (b)" : "| 40= (c)");
               doc.line(10, 54, 141, 54);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_fig() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_fig.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "fig_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de PERFIL DE PERSONALIDAD para " + this.eval_fig.nombre + " de " + this.eval_fig.empresa);

               this.respuestasfig(doc);
               this.resultadosfig(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosfig() {

               this.res_fig = {
                    mas_D: 0, menos_D: 0, mas_I: 0, menos_I: 0, mas_S: 0, menos_S: 0,
                    mas_C: 0, menos_C: 0, mas_N: 0, menos_N: 0, mas_W: 0, menos_W: 0,
                    total_mas: 0, total_menos: 0,
               };

               switch (this.eval_fig.pg001) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg002) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 3 */
               switch (this.eval_fig.pg003) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 4 */
               switch (this.eval_fig.pg004) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 5 */
               switch (this.eval_fig.pg005) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 6 */
               switch (this.eval_fig.pg006) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 7 */
               switch (this.eval_fig.pg007) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 8 */
               switch (this.eval_fig.pg008) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 1 */
               switch (this.eval_fig.pg009) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 2 */
               switch (this.eval_fig.pg010) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg011) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg012) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 13 */
               switch (this.eval_fig.pg013) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 14 */
               switch (this.eval_fig.pg014) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 15 */
               switch (this.eval_fig.pg015) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N+': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 16 */
               switch (this.eval_fig.pg016) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 17 */
               switch (this.eval_fig.pg017) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg018) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 19 */
               switch (this.eval_fig.pg019) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 11 */
               switch (this.eval_fig.pg020) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 12 */
               switch (this.eval_fig.pg021) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 18 */
               switch (this.eval_fig.pg022) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 23 */
               switch (this.eval_fig.pg023) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 24 */
               switch (this.eval_fig.pg024) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 25 */
               switch (this.eval_fig.pg025) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 26 */
               switch (this.eval_fig.pg026) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 27 */
               switch (this.eval_fig.pg027) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 28 */
               switch (this.eval_fig.pg028) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 29 */
               switch (this.eval_fig.pg029) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 30 */
               switch (this.eval_fig.pg030) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 31 */
               switch (this.eval_fig.pg031) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 32 */
               switch (this.eval_fig.pg032) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 33 */
               switch (this.eval_fig.pg033) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 34 */
               switch (this.eval_fig.pg034) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 35 */
               switch (this.eval_fig.pg035) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 36 */
               switch (this.eval_fig.pg036) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    case 'N+': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 37 */
               switch (this.eval_fig.pg037) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 38 */
               switch (this.eval_fig.pg038) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 39 */
               switch (this.eval_fig.pg039) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 40 */
               switch (this.eval_fig.pg040) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 41 */
               switch (this.eval_fig.pg041) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 42 */
               switch (this.eval_fig.pg042) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 43 */
               switch (this.eval_fig.pg043) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 44 */
               switch (this.eval_fig.pg044) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 45 */
               switch (this.eval_fig.pg045) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 46 */
               switch (this.eval_fig.pg046) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }
               /* Resuelve para la pregunta 47 */
               switch (this.eval_fig.pg047) {
                    case 'D': this.res_fig.mas_D = this.res_fig.mas_D + 1;
                         break;
                    case 'I': this.res_fig.mas_I = this.res_fig.mas_I + 1;
                         break;
                    case 'S': this.res_fig.mas_S = this.res_fig.mas_S + 1;
                         break;
                    case 'C': this.res_fig.mas_C = this.res_fig.mas_C + 1;
                         break;
                    case 'N': this.res_fig.mas_N = this.res_fig.mas_N + 1;
                         break;
                    default: this.res_fig.mas_W = this.res_fig.mas_W + 1;
               }
               /* Resuelve para la pregunta 48 */
               switch (this.eval_fig.pg048) {
                    case 'D': this.res_fig.menos_D = this.res_fig.menos_D + 1;
                         break;
                    case 'I': this.res_fig.menos_I = this.res_fig.menos_I + 1;
                         break;
                    case 'S': this.res_fig.menos_S = this.res_fig.menos_S + 1;
                         break;
                    case 'C': this.res_fig.menos_C = this.res_fig.menos_C + 1;
                         break;
                    case 'N': this.res_fig.menos_N = this.res_fig.menos_N + 1;
                         break;
                    default: this.res_fig.menos_W = this.res_fig.menos_W + 1;
               }

               this.res_fig.total_mas = this.res_fig.mas_D + this.res_fig.mas_I + this.res_fig.mas_S + this.res_fig.mas_C + this.res_fig.mas_N;
               this.res_fig.total_menos = this.res_fig.menos_D + this.res_fig.menos_I + this.res_fig.menos_S + this.res_fig.menos_C + this.res_fig.menos_N;

          },
          resultadosfig(doc) {

               this.rangosfig();

               console.log("***-*-*-*-****---*******");
               console.log("resultados ? ", this.res_fig);
               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ")
               doc.line(10, 89, 190, 89);

               let menos_D = this.res_fig.menos_D;
               let mas_D = this.res_fig.mas_D;
               let difD = mas_D - menos_D;
               doc.text(20, 94, "MAS"); doc.text(30, 94, "MENOS"); doc.text(50, 94, "DIFERENCIA");
               doc.text(20, 96, "-------"); doc.text(30, 96, "-----------"); doc.text(50, 96, "-------------------");
               doc.text(10, 100, "D");
               doc.text(22, 100, mas_D.toString()); doc.text(35, 100, menos_D.toString()); doc.text(57, 100, difD.toString());

               let menos_I = this.res_fig.menos_I;
               let mas_I = this.res_fig.mas_I;
               let difI = mas_I - menos_I;
               doc.text(10, 105, "I");
               doc.text(22, 105, mas_I.toString()); doc.text(35, 105, menos_I.toString()); doc.text(57, 105, difI.toString());

               let menos_S = this.res_fig.menos_S;
               let mas_S = this.res_fig.mas_S;
               let difS = mas_S - menos_S;
               doc.text(10, 110, "S");
               doc.text(22, 110, mas_S.toString()); doc.text(35, 110, menos_S.toString()); doc.text(57, 110, difS.toString());

               let menos_C = this.res_fig.menos_C;
               let mas_C = this.res_fig.mas_C;
               let difC = mas_C - menos_C;
               doc.text(10, 115, "C");
               doc.text(22, 115, mas_C.toString()); doc.text(35, 115, menos_C.toString()); doc.text(57, 115, difC.toString());

               let menos_N = this.res_fig.menos_N;
               let mas_N = this.res_fig.mas_N;
               let difN = mas_N - menos_N;
               doc.text(10, 120, "N");
               doc.text(22, 120, mas_N.toString()); doc.text(35, 120, menos_N.toString()); doc.text(57, 120, difN.toString());
               doc.text(20, 122, "-------"); doc.text(30, 122, "-----------"); doc.text(50, 122, "-------------------");

               let total_mas = 0; let total_menos = 0;
               total_mas = mas_D + mas_I + mas_S + mas_C + mas_N;
               total_menos = menos_D + menos_I + menos_S + menos_C + menos_N;
               doc.text(22, 125, total_mas.toString()); doc.text(35, 125, total_menos.toString());

          },
          respuestasfig(doc) {


               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= "); doc.text(23, 45, this.eval_fig.pg001); doc.text(30, 45, "03= "); doc.text(43, 45, this.eval_fig.pg003);
               doc.text(50, 45, "05= "); doc.text(63, 45, this.eval_fig.pg005); doc.text(70, 45, "07= "); doc.text(83, 45, this.eval_fig.pg007);
               doc.text(90, 45, "09= "); doc.text(103, 45, this.eval_fig.pg009); doc.text(110, 45, "11= "); doc.text(123, 45, this.eval_fig.pg011);
               doc.text(130, 45, "13= "); doc.text(143, 45, this.eval_fig.pg013); doc.text(150, 45, "15= "); doc.text(163, 45, this.eval_fig.pg015);
               doc.text(170, 45, "17= "); doc.text(183, 45, this.eval_fig.pg017);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "19= "); doc.text(23, 49, this.eval_fig.pg019); doc.text(30, 49, "21= "); doc.text(43, 49, this.eval_fig.pg021);
               doc.text(50, 49, "23= "); doc.text(63, 49, this.eval_fig.pg023); doc.text(70, 49, "25= "); doc.text(83, 49, this.eval_fig.pg025);
               doc.text(90, 49, "27= "); doc.text(103, 49, this.eval_fig.pg027); doc.text(110, 49, "29= "); doc.text(123, 49, this.eval_fig.pg029);
               doc.text(130, 49, "31= "); doc.text(143, 49, this.eval_fig.pg031); doc.text(150, 49, "33= "); doc.text(163, 49, this.eval_fig.pg033);
               doc.text(170, 49, "35= "); doc.text(183, 49, this.eval_fig.pg035);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "37= "); doc.text(23, 53, this.eval_fig.pg037); doc.text(30, 53, "39= "); doc.text(43, 53, this.eval_fig.pg039);
               doc.text(50, 53, "41= "); doc.text(63, 53, this.eval_fig.pg041); doc.text(70, 53, "43= "); doc.text(83, 53, this.eval_fig.pg043);
               doc.text(90, 53, "45= "); doc.text(103, 53, this.eval_fig.pg045); doc.text(110, 53, "47= "); doc.text(123, 53, this.eval_fig.pg047);
               doc.line(10, 54, 130, 54);
               doc.line(10, 62, 190, 62);
               doc.text(10, 65, "02= "); doc.text(23, 65, this.eval_fig.pg002); doc.text(30, 65, "04= "); doc.text(43, 65, this.eval_fig.pg004);
               doc.text(50, 65, "06= "); doc.text(63, 65, this.eval_fig.pg006); doc.text(70, 65, "08= "); doc.text(83, 65, this.eval_fig.pg008);
               doc.text(90, 65, "10= "); doc.text(103, 65, this.eval_fig.pg010); doc.text(110, 65, "12= "); doc.text(123, 65, this.eval_fig.pg012);
               doc.text(130, 65, "14= "); doc.text(143, 65, this.eval_fig.pg014); doc.text(150, 65, "16= "); doc.text(163, 65, this.eval_fig.pg016);
               doc.text(170, 65, "18= "); doc.text(183, 65, this.eval_fig.pg018);
               doc.line(10, 66, 190, 66);
               doc.text(10, 69, "20= "); doc.text(23, 69, this.eval_fig.pg020); doc.text(30, 69, "22= "); doc.text(43, 69, this.eval_fig.pg022);
               doc.text(50, 69, "24= "); doc.text(63, 69, this.eval_fig.pg024); doc.text(70, 69, "26= "); doc.text(83, 69, this.eval_fig.pg026);
               doc.text(90, 69, "28= "); doc.text(103, 69, this.eval_fig.pg028); doc.text(110, 69, "30= "); doc.text(123, 69, this.eval_fig.pg030);
               doc.text(130, 69, "32= "); doc.text(143, 69, this.eval_fig.pg032); doc.text(150, 69, "34= "); doc.text(163, 69, this.eval_fig.pg034);
               doc.text(170, 69, "36= "); doc.text(183, 69, this.eval_fig.pg036);
               doc.line(10, 70, 190, 70);
               doc.text(10, 73, "38= "); doc.text(23, 73, this.eval_fig.pg038); doc.text(30, 73, "40= "); doc.text(43, 73, this.eval_fig.pg040);
               doc.text(50, 73, "42= "); doc.text(63, 73, this.eval_fig.pg042); doc.text(70, 73, "44= "); doc.text(83, 73, this.eval_fig.pg044);
               doc.text(90, 73, "46= "); doc.text(103, 73, this.eval_fig.pg046); doc.text(110, 73, "48= "); doc.text(123, 73, this.eval_fig.pg048);
               doc.line(10, 74, 130, 74);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_moss() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_moss.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "moss_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de SUPERVISION para " + this.eval_moss.nombre + " de " + this.eval_moss.empresa);

               this.respuestasmoss(doc);
               this.resultadosmoss(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosmoss() {

               /* ================================================================================= */
               /* Conteo para HR */
               if (this.eval_moss.pg001 === "c") {
                    this.res_moss.hr = this.res_moss.hr + 1;
               }
               if (this.eval_moss.pg010 === "c") {
                    this.res_moss.hr = this.res_moss.hr + 1;
               }
               if (this.eval_moss.pg011 === "a") {
                    this.res_moss.hr = this.res_moss.hr + 1;
               }
               if (this.eval_moss.pg013 === "d") {
                    this.res_moss.hr = this.res_moss.hr + 1;
               }
               if (this.eval_moss.pg025 === "b") {
                    this.res_moss.hr = this.res_moss.hr + 1;
               }

               /* ================================================================================= */
               /* Conteo para HS */
               if (this.eval_moss.pg002 === "b") { this.res_moss.hs = this.res_moss.hs + 1; }
               if (this.eval_moss.pg003 === "d") { this.res_moss.hs = this.res_moss.hs + 1; }
               if (this.eval_moss.pg016 === "d") { this.res_moss.hs = this.res_moss.hs + 1; }
               if (this.eval_moss.pg018 === "d") { this.res_moss.hs = this.res_moss.hs + 1; }
               if (this.eval_moss.pg024 === "d") { this.res_moss.hs = this.res_moss.hs + 1; }
               if (this.eval_moss.pg030 === "a") { this.res_moss.hs = this.res_moss.hs + 1; }

               /* ================================================================================= */
               /* Conteo para CD */
               if (this.eval_moss.pg004 === "b") { this.res_moss.cd = this.res_moss.cd + 1; }
               if (this.eval_moss.pg006 === "b") { this.res_moss.cd = this.res_moss.cd + 1; }
               if (this.eval_moss.pg020 === "b") { this.res_moss.cd = this.res_moss.cd + 1; }
               if (this.eval_moss.pg023 === "a") { this.res_moss.cd = this.res_moss.cd + 1; }
               if (this.eval_moss.pg029 === "c") { this.res_moss.cd = this.res_moss.cd + 1; }

               /* ================================================================================= */
               /* Conteo para SC */
               if (this.eval_moss.pg005 === "b") { this.res_moss.sc = this.res_moss.sc + 1; }
               if (this.eval_moss.pg008 === "b") { this.res_moss.sc = this.res_moss.sc + 1; }
               if (this.eval_moss.pg015 === "d") { this.res_moss.sc = this.res_moss.sc + 1; }
               if (this.eval_moss.pg017 === "b") { this.res_moss.sc = this.res_moss.sc + 1; }
               if (this.eval_moss.pg022 === "a") { this.res_moss.sc = this.res_moss.sc + 1; }
               if (this.eval_moss.pg028 === "c") { this.res_moss.sc = this.res_moss.sc + 1; }

               /* ================================================================================= */
               /* Conteo para CE */
               if (this.eval_moss.pg007 === "b") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg009 === "c") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg012 === "c") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg014 === "d") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg019 === "c") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg021 === "a") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg026 === "c") { this.res_moss.ce = this.res_moss.ce + 1; }
               if (this.eval_moss.pg027 === "a") { this.res_moss.ce = this.res_moss.ce + 1; }
               /* ================================================================================= */

               /* ================================================================================= */
               /* Conteo de todos los aciertos */
               this.res_moss.aciertos = 0;
               this.res_moss.aciertos = this.res_moss.hs + this.res_moss.cd + this.res_moss.ce + this.res_moss.hr + this.res_moss.sc;

               /* Busca el rango que le corresponde */
               this.res_moss.rangosHS = '';
               let comp1 = (this.res_moss.aciertos >= 0 && this.res_moss.aciertos <= 8); if (comp1 === true) { this.res_moss.rangosHS = 'INFERIOR'; }
               let comp2 = (this.res_moss.aciertos >= 9 && this.res_moss.aciertos <= 11); if (comp2 === true) { this.res_moss.rangosHS = 'POBRE'; }
               let comp3 = (this.res_moss.aciertos >= 12 && this.res_moss.aciertos <= 18); if (comp3 === true) { this.res_moss.rangosHS = 'MEDIO'; }
               let comp4 = (this.res_moss.aciertos >= 19 && this.res_moss.aciertos <= 23); if (comp4 === true) { this.res_moss.rangosHS = 'BUENO'; }
               let comp5 = (this.res_moss.aciertos >= 24 && this.res_moss.aciertos <= 30); if (comp5 === true) { this.res_moss.rangosHS = 'SUPERIOR'; }

          },
          resultadosmoss(doc) {

               this.res_moss = {
                    hs: 0, cd: 0, ce: 0, hr: 0, sc: 0,
                    aciertos: 0,
                    percentilHS: 0, rangoHS: "",
               };

               this.rangosmoss();

               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ")
               doc.line(10, 89, 195, 89);

               let aciertos = this.res_moss.aciertos;
               let rangosHS = this.res_moss.rangosHS;
               let hs = this.res_moss.hs;
               let cd = this.res_moss.cd;
               let ce = this.res_moss.ce;
               let hr = this.res_moss.hr;
               let sc = this.res_moss.sc;

               doc.text(20, 94, "Pc."); doc.text(30, 94, "RESULTADOS"); doc.text(63, 94, "RANGO");
               doc.text(20, 96, "-------"); doc.text(30, 96, "--------------------"); doc.text(60, 96, "-------------------");
               doc.text(10, 100, "[HS]");
               doc.text(22, 100, hs.toString()); doc.text(35, 100, aciertos.toString()); doc.text(62, 100, rangosHS);

               doc.text(10, 105, "[CD]");
               doc.text(22, 105, cd.toString());

               doc.text(10, 110, "[CE]");
               doc.text(22, 110, ce.toString());

               doc.text(10, 115, "[HR]");
               doc.text(22, 115, hr.toString());

               doc.text(10, 120, "[SC]");
               doc.text(22, 120, sc.toString());
               doc.text(20, 122, "-------"); doc.text(30, 122, "--------------------"); doc.text(60, 122, "-------------------");
               let desaciertos = 30 - aciertos;
               doc.text(10, 127, "Aciertos ? ");
               doc.text(25, 127, aciertos.toString());
               doc.text(32, 127, "No Aciertos ? ");
               doc.text(52, 127, desaciertos.toString());

          },
          respuestasmoss(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= "); doc.text(23, 45, this.eval_moss.pg001); doc.text(30, 45, "02= "); doc.text(43, 45, this.eval_moss.pg002);
               doc.text(50, 45, "03= "); doc.text(63, 45, this.eval_moss.pg003); doc.text(70, 45, "04= "); doc.text(83, 45, this.eval_moss.pg004);
               doc.text(90, 45, "05= "); doc.text(103, 45, this.eval_moss.pg005); doc.text(110, 45, "06= "); doc.text(123, 45, this.eval_moss.pg006);
               doc.text(130, 45, "07= "); doc.text(143, 45, this.eval_moss.pg007); doc.text(150, 45, "08= "); doc.text(163, 45, this.eval_moss.pg008);
               doc.text(170, 45, "09= "); doc.text(183, 45, this.eval_moss.pg009);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "10= "); doc.text(23, 49, this.eval_moss.pg010); doc.text(30, 49, "11= "); doc.text(43, 49, this.eval_moss.pg011);
               doc.text(50, 49, "12= "); doc.text(63, 49, this.eval_moss.pg012); doc.text(70, 49, "13= "); doc.text(83, 49, this.eval_moss.pg013);
               doc.text(90, 49, "14= "); doc.text(103, 49, this.eval_moss.pg014); doc.text(110, 49, "15= "); doc.text(123, 49, this.eval_moss.pg015);
               doc.text(130, 49, "16= "); doc.text(143, 49, this.eval_moss.pg016); doc.text(150, 49, "17= "); doc.text(163, 49, this.eval_moss.pg017);
               doc.text(170, 49, "18= "); doc.text(183, 49, this.eval_moss.pg018);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "19= "); doc.text(23, 53, this.eval_moss.pg019); doc.text(30, 53, "20= "); doc.text(43, 53, this.eval_moss.pg020);
               doc.text(50, 53, "21= "); doc.text(63, 53, this.eval_moss.pg021); doc.text(70, 53, "22= "); doc.text(83, 53, this.eval_moss.pg022);
               doc.text(90, 53, "23= "); doc.text(103, 53, this.eval_moss.pg023); doc.text(110, 53, "24= "); doc.text(123, 53, this.eval_moss.pg024);
               doc.text(130, 53, "25= "); doc.text(143, 53, this.eval_moss.pg025); doc.text(150, 53, "26= "); doc.text(163, 53, this.eval_moss.pg026);
               doc.text(170, 53, "27= "); doc.text(183, 53, this.eval_moss.pg027);
               doc.line(10, 54, 190, 54);
               doc.text(10, 57, "28= "); doc.text(23, 57, this.eval_moss.pg028); doc.text(30, 57, "29= "); doc.text(43, 57, this.eval_moss.pg029);
               doc.text(50, 57, "30= "); doc.text(63, 57, this.eval_moss.pg030);
               doc.line(10, 59, 65, 59);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_tav() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_tav.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "tav_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de APTITUD EN VENTAS para " + this.eval_tav.nombre + " de " + this.eval_tav.empresa);

               this.respuestastav(doc);
               this.resultadostav(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangostav() {

               /* ============================================================================================= */
               /* Pregunta 1 */
               if (this.eval_tav.pg001 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg001 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 2 */
               if (this.eval_tav.pg002 === 'd') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 3 */
               if (this.eval_tav.pg003 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg003 === 'b') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg003 === 'd') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 2;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 4 */
               if (this.eval_tav.pg004 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg004 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 5 */
               if (this.eval_tav.pg005 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 6 */
               /*  NO TIENE PONDERACION */


               /* ============================================================================================= */
               /* Pregunta 7 */
               if (this.eval_tav.pg007 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg007 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 8 */
               if (this.eval_tav.pg008 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg008 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg008 === 'c') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 1;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 9 */
               if (this.eval_tav.pg009 === 'b') {

                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg009 === 'd') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 10 */
               if (this.eval_tav.pg010 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg010 === 'b') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg010 === 'c') {
                              this.res_tav.errores = this.res_tav.errores + 2;
                         } else {
                              if (this.eval_tav.pg010 === 'd') {
                                   this.res_tav.aciertos = this.res_tav.aciertos + 2;
                              }
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 11 */
               if (this.eval_tav.pg011 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg011 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 12 */
               if (this.eval_tav.pg012 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 13 */
               /*  NO TIENE PONDERACION */


               /* ============================================================================================= */
               /* Pregunta 14 */
               if (this.eval_tav.pg014 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg014 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 15 */
               if (this.eval_tav.pg015 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               }
               /* ============================================================================================= */
               /* Pregunta 16 */
               if (this.eval_tav.pg016 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 17 */
               if (this.eval_tav.pg017 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg017 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 18 */
               if (this.eval_tav.pg018 === 'c') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 19 */
               if (this.eval_tav.pg019 === 'a') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg019 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 20 */
               if (this.eval_tav.pg020 === 'a') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               } else {
                    if (this.eval_tav.pg020 === 'd') {
                         this.res_tav.errores = this.res_tav.errores + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 21 */
               if (this.eval_tav.pg021 === 'b') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg021 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 22 */
               if (this.eval_tav.pg022 === 'c') {
                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg022 === 'd') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 23 */
               if (this.eval_tav.pg023 === 'b') {
                    this.res_tav.errores = this.res_tav.errores + 1;
               } else {
                    if (this.eval_tav.pg023 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 24 */
               /*  NO TIENE PONDERACION */

               /* ============================================================================================= */
               /* Pregunta 25 */
               if (this.eval_tav.pg025 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg025 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    } else {
                         if (this.eval_tav.pg025 === 'd') {
                              this.res_tav.errores = this.res_tav.errores + 2;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 26 */
               if (this.eval_tav.pg026 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg026 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 27 */
               if (this.eval_tav.pg027 === 'd') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 2;
               }
               /* ============================================================================================= */
               /* Pregunta 28 */
               if (this.eval_tav.pg028 === 'a') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg028 === 'b') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg028 === 'c') {
                              this.res_tav.aciertos = this.res_tav.aciertos + 1;
                         } else {
                              if (this.eval_tav.pg028 === 'd') {
                                   this.res_tav.errores = this.res_tav.errores + 1;
                              }
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 29 */
               if (this.eval_tav.pg029 === 'b') {

                    this.res_tav.errores = this.res_tav.errores + 2;
               } else {
                    if (this.eval_tav.pg029 === 'c') {
                         this.res_tav.aciertos = this.res_tav.aciertos + 2;
                    } else {
                         if (this.eval_tav.pg029 === 'd') {
                              this.res_tav.errores = this.res_tav.errores + 1;
                         }
                    }
               }
               /* ============================================================================================= */
               /* Pregunta 30 */
               if (this.eval_tav.pg030 === 'b') {
                    this.res_tav.aciertos = this.res_tav.aciertos + 1;
               } else {
                    if (this.eval_tav.pg030 === 'c') {
                         this.res_tav.errores = this.res_tav.errores + 1;
                    }
               }

               this.res_tav.resta = this.res_tav.aciertos - this.res_tav.errores;

               this.res_tav.rango = '';
               let comp1 = false;
               if (this.eval_tav.sexo === "M") {

                    comp1 = (this.res_tav.resta >= 1 && this.res_tav.resta <= 12); if (comp1 === true) { this.res_tav.rango = "Bajo"; }
                    comp1 = (this.res_tav.resta >= 13 && this.res_tav.resta <= 15); if (comp1 === true) { this.res_tav.rango = "Medio"; }
                    comp1 = (this.res_tav.resta >= 16 && this.res_tav.resta <= 18); if (comp1 === true) { this.res_tav.rango = "Bueno"; }
                    comp1 = (this.res_tav.resta >= 19 && this.res_tav.resta <= 20); if (comp1 === true) { this.res_tav.rango = "Muy Bueno"; }
                    comp1 = (this.res_tav.resta >= 21 && this.res_tav.resta <= 34); if (comp1 === true) { this.res_tav.rango = "Superior"; }
               } else {
                    comp1 = (this.res_tav.resta >= -4 && this.res_tav.resta <= 9); if (comp1 === true) { this.res_tav.rango = "Bajo"; }
                    comp1 = (this.res_tav.resta >= 10 && this.res_tav.resta <= 13); if (comp1 === true) { this.res_tav.rango = "Medio"; }
                    comp1 = (this.res_tav.resta >= 14 && this.res_tav.resta <= 15); if (comp1 === true) { this.res_tav.rango = "Bueno"; }
                    comp1 = (this.res_tav.resta >= 16 && this.res_tav.resta <= 17); if (comp1 === true) { this.res_tav.rango = "Muy Bueno"; }
                    comp1 = (this.res_tav.resta >= 18 && this.res_tav.resta <= 20); if (comp1 === true) { this.res_tav.rango = "Superior"; }
               }


               this.res_tav.genero = "NA";
               switch (this.eval_tav.sexo) {
                    case 'M': this.res_tav.genero = 'MASCULINO';
                         break;
                    case 'F': this.res_tav.genero = 'FEMENINO';
                         break;
               }
          }, 
          resultadostav(doc) {

               this.res_tav = {
                    rango: 0, resta: 0,
                    aciertos: 0, errores: 0,
                    genero: "",
               };

               this.rangostav();

               doc.setLineWidth(0.25);

               doc.text(10, 80, "SECCION DE RESULTADOS ")
               doc.line(10, 83, 206, 83);

               console.log("*-*-*-*-*-*-*-*-*-*-*- RESULTADOS *-*-*-*-*-*-*-*-*-*-*-");
               console.log("aciertos ? ", this.res_tav.aciertos, "; errores ? ", this.res_tav.errores);

               // let dif = this.res_tav.aciertos - this.res_tav.errores;
               let aciertos = this.res_tav.aciertos;
               let errores = this.res_tav.errores;
               let resta = this.res_tav.resta;
               let rango = this.res_tav.rango;
               let genero = this.res_tav.genero;
               doc.text(10, 90, "[ aciertos : "); doc.text(30, 90, aciertos.toString()); doc.text(50, 90, " ]")
               doc.text(10, 94, "[ errores : "); doc.text(30, 94, errores.toString()); doc.text(50, 94, " ]")
               doc.text(10, 98, "[ diferencia : "); doc.text(30, 98, resta.toString()); doc.text(50, 98, " ]")
               doc.text(10, 104, "[ rango : "); doc.text(30, 104, rango); doc.text(50, 104, " ]")
               doc.text(25, 108, genero);

          },
          respuestastav(doc) {
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01= "); doc.text(23, 45, this.eval_tav.pg001); doc.text(30, 45, "02= "); doc.text(43, 45, this.eval_tav.pg002);
               doc.text(50, 45, "03= "); doc.text(63, 45, this.eval_tav.pg003); doc.text(70, 45, "04= "); doc.text(83, 45, this.eval_tav.pg004);
               doc.text(90, 45, "05= "); doc.text(103, 45, this.eval_tav.pg005); doc.text(110, 45, "06= "); doc.text(123, 45, this.eval_tav.pg006);
               doc.text(130, 45, "07= "); doc.text(143, 45, this.eval_tav.pg007); doc.text(150, 45, "08= "); doc.text(163, 45, this.eval_tav.pg008);
               doc.text(170, 45, "09= "); doc.text(183, 45, this.eval_tav.pg009);
               doc.line(10, 46, 190, 46);
               doc.text(10, 49, "10= "); doc.text(23, 49, this.eval_tav.pg010); doc.text(30, 49, "11= "); doc.text(43, 49, this.eval_tav.pg011);
               doc.text(50, 49, "12= "); doc.text(63, 49, this.eval_tav.pg012); doc.text(70, 49, "13= "); doc.text(83, 49, this.eval_tav.pg013);
               doc.text(90, 49, "14= "); doc.text(103, 49, this.eval_tav.pg014); doc.text(110, 49, "15= "); doc.text(123, 49, this.eval_tav.pg015);
               doc.text(130, 49, "16= "); doc.text(143, 49, this.eval_tav.pg016); doc.text(150, 49, "17= "); doc.text(163, 49, this.eval_tav.pg017);
               doc.text(170, 49, "18= "); doc.text(183, 49, this.eval_tav.pg018);
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "19= "); doc.text(23, 53, this.eval_tav.pg019); doc.text(30, 53, "20= "); doc.text(43, 53, this.eval_tav.pg020);
               doc.text(50, 53, "21= "); doc.text(63, 53, this.eval_tav.pg021); doc.text(70, 53, "22= "); doc.text(83, 53, this.eval_tav.pg022);
               doc.text(90, 53, "23= "); doc.text(103, 53, this.eval_tav.pg023); doc.text(110, 53, "24= "); doc.text(123, 53, this.eval_tav.pg024);
               doc.text(130, 53, "25= "); doc.text(143, 53, this.eval_tav.pg025); doc.text(150, 53, "26= "); doc.text(163, 53, this.eval_tav.pg026);
               doc.text(170, 53, "27= "); doc.text(183, 53, this.eval_tav.pg027);
               doc.line(10, 54, 190, 54);
               doc.text(10, 57, "28= "); doc.text(23, 57, this.eval_tav.pg028); doc.text(30, 57, "29= "); doc.text(43, 57, this.eval_tav.pg029);
               doc.text(50, 57, "30= "); doc.text(63, 57, this.eval_tav.pg030);
               doc.line(10, 59, 65, 59);

          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_solemp() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_solemp.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "solemp_" + nusuario;
               // console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEASABIAAD/2wBDAAgGBgcGBQgHBwcJCQgKDBUODAsLDBkSEw8VHhsgHx4bHR0hJTApISMtJB0dKjkqLTEzNjY2ICg7Pzo0PjA1NjP/2wBDAQkJCQwLDBgODhgzIh0iMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzMzP/wAARCACMAS0DASIAAhEBAxEB/8QAHwAAAQUBAQEBAQEAAAAAAAAAAAECAwQFBgcICQoL/8QAtRAAAgEDAwIEAwUFBAQAAAF9AQIDAAQRBRIhMUEGE1FhByJxFDKBkaEII0KxwRVS0fAkM2JyggkKFhcYGRolJicoKSo0NTY3ODk6Q0RFRkdISUpTVFVWV1hZWmNkZWZnaGlqc3R1dnd4eXqDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uHi4+Tl5ufo6erx8vP09fb3+Pn6/8QAHwEAAwEBAQEBAQEBAQAAAAAAAAECAwQFBgcICQoL/8QAtREAAgECBAQDBAcFBAQAAQJ3AAECAxEEBSExBhJBUQdhcRMiMoEIFEKRobHBCSMzUvAVYnLRChYkNOEl8RcYGRomJygpKjU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6goOEhYaHiImKkpOUlZaXmJmaoqOkpaanqKmqsrO0tba3uLm6wsPExcbHyMnK0tPU1dbX2Nna4uPk5ebn6Onq8vP09fb3+Pn6/9oADAMBAAIRAxEAPwD3+iiigAooooAKKKKACjIqnqWpW2l2T3V1IEjUdz19q8+0/wCI5bXpPtS7bGUgJz9z3qowb2MamIp02lJ7nptFRwzRzxLJE4dGGQwOQakqTbcKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAooooAKKKKACiiigAoopDQBg6zrz2Nx9mgQGQDLFugyKl0XW21F2hlQLIBkFehFU9c0S4uLs3Nuu/djcueRgUzS7I6QHvb47AowqjrVaWObmqKprsdTVPUtSttKs3urqQJGv61x9/rFxe3BdXZEHCqDjiqEztcpsnYyLnOGOaOUmeKS0icp4l8T3PiG8LMSluv+rj9Pc1g16EbaDH+pj/75FY9lBG3iO+UxqVCjC44rqhNJaHh1qM5z5pO7ZP4O8ZyaPMtleuzWbHAJ5KH/AAr1+GZJo1kjYMjDII715j9mg/54p/3yKsx3E0SBI5GRB0APArGaTd0elha0qUeWWp6Qa5vU/EctvdtBbIuE4ZmqlpGuvazeXcuXhY4yedtP1LRZ5bprizXzYpPmBBrO1nqdcqrlG9M29G1f+042DJtlT7w7GtSsXQdIl09Xknx5j8bQegrapM3p83L724UZrG8VTSW/hq+khcpII+GXqKxbHwbb3FjBM+oX+XjDH976ikWdnRXGXHhTSrQZuNZvIh/t3GKrxaHoE0ixxa/cO7HAUXGSTQB3dFcr/wAILaf9BC//AO/1Ml8FWMMZkk1K/VFGSTN0oA62jNcCNI8O5AHiK45/6eavQ+D9OuU3w6teyL6rPmgDsM0V594g0BfD9gl/a3180scycGTORn0rSWXxJr65jCaVaEZDH5pWH9KAOtZ1RdzsFHqTUf2u3/57xf8AfYrkLzw1o1lD9p1nUriY/wB6WUjP0FZB/wCEMzgWt4y/3wr4oA9KR1dcqwYeoOadXDWHh7QdRUy6PqVzC6/885TkfUGrjf8ACS6ENwK6taDqD8sqj+tAHW0Vw2ueLRc6Vby6XcSW7+eFuf3ZMkI9xVS0v7m9nWCLxZIsjdBJBtz+YoA9EorlhoniE9PET/8AfoUf2H4i/wChif8A79CgDqaK5NtI11G2t4mIPoYwKUaP4kxmPxDu9N0QoA6uiuUJ8YWWOLK+UdQBsY1NZ+LoPtK2mqW0unXLcKJfuN9GoA6WikDBgCDkHoaWgAooooAazbVLHoBmuC1PUptQnLSfKin5UB4Fdlqd/b6fZST3MgRMY+prgCcsffmrgceKnZWQlGKKKs4bGJc+IRaTNDNZyK4/2utZlvraQ6rcXZhYiVQAueldBqemx6jFtYbZQPlb0rl7fRbqa+Nsybdh+dyOMVrBwtqcVVVVJWOh0/WTqE2yO1cKPvPuGBWrUFraRWcCxQqAo7+tT1m7X0Oumnb3twIyMHpW54f1OWG5SzY7on4GT90+1YdT2d1FZXcdxO22KM5Y0mro3pTcZJno1FRwzJPEskTB0YZDDvUlYnqmH4v/AORWv/8ArnVS+1d9K8N2S26b7y4jSOBM9WIFW/F//Iq3/wD1zrF0nbqfieyGd8Wn2SsBkYDsOv5UAaFh4PtSouNXJv7xxl2l+6D6AVn+JdI0/T59He0tIoXN6gLIuDiu26Vy/jL7+jf9fyUAdRWZ4h/5F++/64t/KtOszxD/AMi/f/8AXFv5UAZeh+HdIudBsZZdPgd3hUsxXknFUNZ0+PwqU1TSpDCC4V7TPyy59B610fh3/kXNO/64L/KsSAf8JH4pknf5rHTWKRqejydz+FAHSxhLy1jeWIfMA+x1ztNM1G+h0ywmu5mASJdxz/KrYrlfFGdS1fS9EH3JX86b/dXt+dADNG0V9XlGs60vmSycwQMPkiXtx611It4gu0RoB6BRipFUKoAGAKWgDmNc8OjnUtJH2fUIRuAjGFkHoRWnomqJrGmR3IG1/uun91h1FaeAa5bRx/Zvi/UdP6RXKi4iHoe9AEmv+HjO/wDaWl7YdQi54HEo/ukVRllsfEXhW7mNqkV5bqd64AaNxXZmuF8VQf2HfSapCpFrdxNDcoOm4jhqAOm8O3DXWgWMznLNEMmtQ1i+EQP+EX0/H/PIVt0AcXe6XBrPje4t7l5RGlqjKEcrg5xT7nRNS0BGvNHvZ54owWe1nbduA9DVq2/5KFd/9eSfzrpmAIwRkUAUdJ1GHVtOivIeA45HdT3FO1DTLTU7Zre7hWWNvUcj6VheFB9l1PW7BT+7hutyD0DDNdV1oA5LRbi40LVv7CvZGkgkybKZjzj+4a6zNcv41j8vSodRX/W2U6yg9wM8it/T7tb7T7e7QYWaMOAfegC1VLU9SttKsnurqQIiDv1J9BV2vIPiH/bB1PN2D9iyfI2/dx7+9XCPM7HPiqzo03JK5leIPEtz4g1RHclLdXHlx9h7mum7V53H/rU2/e3DH1zXV58QY48iuicEkkjwaNaU5OUtWxusahLp99bOnKlTvUdxmtW0u4r23WaJsqevsa5PWzfmSH7cE3BTt2fWn+HvtZvT9n/1X/LTPSiUUoXHCs3V5TqZ7hYE3Hk9h61nR3si3BkJyD1FR3IlMx8373b0xUXT6V8djcxrSre7okfomX5TQjQ973nLr/kb8ciyoHUgiqmpanFpsGThpWGET1qtYifzCIunv0rmNQ+1C+f7WD5vv0/Cvo8urvE01KSsfHZzQWCquEHdfkdRoNzJdWkksr7nMh/CrOqHGl3P+5WBo41QWZ+xCPytx+961ZvTrf2KYT+T5W35sdcV3OPvHmqo/Zlvwb4xl0eZLO8YvZvxknlD/hXr8E8dxCssTh0cZVh3r5wr1X4a/wBqmyl+0Z+w/wDLPf1z7e1TWgl7yOrLcVOUvZS1O5ubaK7t5IJ0DxSKVZT0Iqnpehadoxf7BbLD5mN2CTnFaVFcx7QVy/jL7+jf9fyf1rqK5fxl9/Rv+v5P60AdRWZ4h/5F+/8A+uLfyrTrM8Q/8i/f/wDXFv5UAZ8F5/Z/gOK67x2YI+uMCrPhay+w6Baow/eOvmOfVjyaw9TYj4eafGD/AK3yUP0NdlCgSNEHRVAFADzXL2gNx4/vZTyLe1WMexJzXUGuZ0D5vE2uuevmIv5CgDp6KKKACuV1nNv4y0O4AwJBJET68ZFdVXK+Kjt1jw+46i7x+YoA6kc81meIbBdR0O7t2GdyZH1Faa011DqVPQjFAGP4T48M2A9I8GtuqemWhsrJIP7ucVcoA5i2/wCShXf/AF5L/OunPSuWgYL8QbslgB9jXqfermt+JLXTrcxQus97INsUMZyS3v6UAUvDn73xH4gmTlPPVc+pArqelYvhfTH0vSQJ+bqdjLMf9onpWwzhQWJAA6kmgDnPHEmPDcsA+/cMsaD1JNa+i2jWOi2Vq/3oYVQ/UCueWT/hKPEsRi+bTtNbcX7SSdgPpXXgYoAWqepabbapZva3UYeNxj3HuKuUUCaTVmeF+IPDVz4f1VFYF7ZnHlyY6iun7V6Bqljb6jZSQXMYdMZGexFcC3U1tzuSPJqYVUZNx2ZhazpsuoX9qicIFO5vTmtW1tYrOBYYVCqP1qainzNqxlGmlLmIp7dZ0II+bsfSsyOykecxt0HU1a1LU4tOt8khpT9xO5965e31q7gvmuXfcGPzoehHtXDXyuliJqbR30M8q4ODpRd0/wADtI41ijCqMAVT1LTYtRg2sNsg+4/pU9rdxXkAmiYFT+lT12RiqatHSxxTn7b3pa3MvQbaS0spIpRh1kNWNUGdLuc/3KuVPZ2sV7dx2s43RSNhh7VXN1JhT05EYfgzwbJrEi3t6pSzU8A9XP8AhXr0MMcESxRIERRgKOgFEMKQRLHGgVFGAB2qSs5zcndnqYfDQoRtEKKKKg6Arl/GX39G/wCv5P611Fcv4y+/o3/X8n9aAOorN8Qf8i/f/wDXFv5VpVmeIf8AkX7/AP64t/KgDm9T48CaOewkgrtV6D6VyF9A03w2i2DLx28cgx2Iwf5V0um3C3WnW06nIeMH9KALbdq5nw7/AMjBr3/Xdf8A0GumPauY0g+V4w1qH++scgH4UAdRRRRQAVyni3/kJ6B/1+iurrlvEmJfEPh+AdfPZyPYCgDqBSHrSjrUF7MLe0mmJwEQnNAEkUiyruQ5FPNZPhqRptBtZWPLruP51r0Acl4htvDban5up3ZhudgBCyFcjt0qtYan4N0di9tNF5vdzl2/OrItbe68f3azwpKBZoQHXOOa6JdLsIzlLOAEeiCgDAbxvZSEpY2l5eSnosUR5/GojY694jONQI02xP3oY2zI49z2rrEjSMfIir9Bin0AVrKxttOtktrWJY4kGAoqzRRQAUUUGgBrDcCp6GuC1PTpdPuCrfMhOVbHWtnXNauILw21uwTaBuPc8ZpumXx1gPY3oEhIyr4wRVLTU5arhUfJ1OaorQ1DR7mzuNixs6H7rKM5qjNG1um+dTGucbnGBVp3OKUJR3MK48Oi6naaa8kZj7VnW+ixzarc2ZmcLEAQwHWun+0wf894/wDvqseyniXxHfM0iAFRg7uDWsXI4qkKd0WNP0b+z5t8V05U8MpHBrVqL7Tb/wDPeL/voVaS3mkUOkbOp6FRwahtt6nTCKWkSKt3w/pcstwl2/yxJ0yPvGmaRob3UokuVZIVOcEY3e1SalrM8V09vaN5UUfygAVDd9EdVOCgueZ19FYugatLqCvHP/rE5yO4rarNqx3xkpK6CiiigoK5bxl9/Rv+v5K6muW8Y/63Rv8Ar+SgDqazPEP/ACL9/wD9cW/lWnWb4g/5AF9/1wb+VAEWhwpceFrKJxlXtlUj2xWd4PnaCG60eY/vrGUqAe6Hoa1PDn/Iuaf/ANcF/lWV4ht5tL1CLxBZoT5Y2XUY/jT1/CgDpya5a4P2H4g20p4jvbYx5/2l5rorO8hvrWO5gcPFIMqRWJ4vs5ZtOivrVc3NjIJkA6kDqPyoA6SiqemahFqmnw3kLZSRc49D6VcoAK5aXF94/gVeRY2xLH3auhvLuOxtJbmZsRxruJrA8JwSyi61i5XbNfSblB/hQdBQB03SuU8d6i1torWsGTcXPyqo67RyTXS3V1Fa27zzOEjQZZiegrjLdJdaj1LxFdIViEDx2cZ7LjlvxoA3/CX/ACK+n/8AXIVt1ieEv+RX0/8A65CtugDmLb/koV3/ANeS/wA66euYtv8AkoV3/wBeS/zrp6ACiiigAooooAKKKKAMLWNCa+uPtELgORhg3Q0/RdEOnMZpSDKRjjoK2qKdzP2cebm6hVPUtNttVs3tbqPfE/6e4q5RSLavozwrxN4YuPD12QQXtn/1cn9DWB0/xr6I1HTbfVLGS1ukDxuMHI6VwGn/AA2aPXHN24exjbcmOr+xrphWXLqeHictl7S9PZmT4N8GPq8y3t6hWzXoM4L/AP1q9diiSGNY41CoowAOgoihSCJYolCIowqgcCpKwlJyd2erhsPGhCyENc5qnhyS4umntmUbzllJxzXSUVNzacFNWZl6PpI02NizBpX6kdBWpRRQ3ccYqKsgoNFFAzD1nxNa6Ncw2zwXE88qlgkKbiB6msnzbvxPqtjL9hmtbG0fzSZxhnbsAK1dZ8Mx6tfQ3iXtxaTxoU3QnqDVH/hDbkf8zHqX/fQoA6kVDewC6s5rc9JEK/mK53/hDrn/AKGLUv8AvoUf8Idcf9DFqX/fQoAp2Gt33h20TTdQ0q6mEPyxzQLuVl7V0ekata6/p5uIEcJuKPHIuCD3BFY//CG3H/Qxal/30K2ND0WLQ7JraOaSYvIZGkk6sTQBhT2N94VuXutNje40uQlpbUctF6lfb2rd0zWtP1m28y1nV+zIeGX2IrSIzWFqXhHTdQnNygktbr/ntbnac+/rQBnzaTqmhXct1oQWe1lbdLZyHGD6qe1OHiy9HyHw7qAmHGABjP1o/sfxNacWmtRXCjoLiLnH1FSbfGQ43aYf9r5s0AV/7N1bxHcRvrCLaaeh3C1Rss57bjW9f6pYaNaB7mVIkUYVe59gKxjpXim84uNYgtkJ5FvFk/nVvT/CGn2k4urhpL266+bcndz7DtQBg397/awjvdaZrDQ1kAjibO+du2QO1WdR8UWeoadJpeiwS3E0yeWm2MqiDpnJrZ8SaFJrVtbLBci3lt5fMRiu4flWcmg+I05j1u3T/dtgKAN7SLM6fpVraHG6KMKSPXFXea5f+xvFH/QwRf8Afij+xvFH/QwQ/wDfigBmsvPoviePWjBJNZPB5M3lLkpzwcVetfGeh3U8UCXZWWRtqq8bDJ9OlVDovicg51+I5/6YVAfCWq3N3avfatE8UMokIjgCkke9AHY0UCigAooooAKKKKACg9KKD0oArpfWsly1ulzE06/ejDgsPwqwOleeeGbCwk1Nb+abyr4X9wsYzzMPQ/SvQxQBXmvrW3mSGa4ijkf7qM4BNTivMfGUSSa/qcjoDJFDAY2P8HzjJFelwnMKZ/uj+VACS3EMDossqIXOFDHG4+1LBPHcRLLDIskbdGU5BrgfihLLCulSwj94kzEY/wB2ug8Dc+ELA4xlSf1oA35ZUhjMkjqiKMlmOAKZb3UF3EJbeaOaM/xxsGH5isrxZai98OXVv56QlgNrOcKTngH69KzfAqWqafd+RE8EonxPAekbgfw+xHNAHWMQqkk4AqCK+tpmRYp43Z13KFYHI9add/8AHnP/ANc2/lXnfgwf8TjSuP8AmHyf+h0AelVElxFJO8KSq0iffUHlfrUo6VyujceOde/3Iv5UAdVVO71SxsZAl1dwwswyA7gEirlcd44sbWefR5ZYEdzeJGSRklT2+lAHXo6yKHU5UjII702eeK2iMk8qRRjqzsAKWONY0VEUKqjAA7CuY8eIsulWUTjdG97GGX+8OeKAOmhmiuIhJDIkiHoyEEGnSOscbO7BVUZJJ4ArmPAqiPQ7iNRhUvJVUegzWp4lz/wjOpY/592/lQBdtb61vULWtzFMo6mNw2PyqxXnPw3VXvbyaGAwwrbxRsp4y3c/jXow6UAU49TsZbw2aXcLXC5zEHG4Y9quVw3haMnxZrT/ANnRsou5P9LyNyH+7Xc0AV5ry1t5khluYY5H+6juAW+gqxXnPjGxtv8AhJhd3ZEls8caSGI/vbY5+VsehNeiJjYuDkYoAdRgUUUAFQXN3b2aB7meKFScAyOFBP41PXFePrTz47KcrHOIS5e1ZsF1xyV9xQB2aMroGUhlIyCOQaJJEhjaSRwiKMszHAArN8O/ZR4fsRZu72/lDYz9ce9VfGcyw+ENSYnGYto/GgDYtrqC8hE1vMksR6MhyDU1cZ8M3UeGXt0YMsM7AMO+ea7OgAooooAKKKKACgjIoooA5+z8H6bZa0dTjacyb2dY2fKIzdSBXQUUUAYGqeEdO1fUkvrhpg4Ch1R8K+05GRW8qhVAHQcClooAzNV0K01iW3kud37gsVCnGcjBzU2k6ZDo+mQ2MDM0UQwpY81dooAp6pptvq+ny2V0CYpBg4OCPeq+iaFbaFbPDbvLIZH3vJK2WY1qUUAI6h0ZG6MMGsLR/CWn6LfSXds87OwKqJHyEUnOBW9RQADisM+GYP8AhITrCXdzHK2N8SPhHwO4rcooAAMVQ1PSYNUNsZ2YfZ5hMu09SPWr9FABWdrWjW+uWH2S5aRFDB1aM4ZWHQitGigDP0fSLfRdPWztmdkBLFnOSxPUmrN7aR31jPaSkiOZCjFTg4NT0UAZGkeHbTRZpZLVpMyRojBjkfKMA/WteiigDDsvDFtYa3PqcNzchpnZ3i3/ACEn2rcoooAwNW8I6drGppfXDTLIAodUbCuAcgGtHTbB9PjlR7qS43ys6l/4Qf4R7Cr1FABRRRQAVj654cs9fSEXLzRtESVeF9rYPUZrYooAzdN0aHSmItpZvK8tUWJ2yq47ipNV0qDWLE2lyW8ourHb3wc4q9RQBiW3hm1sr03FrPcQhpvNaJGAQnGMYx0rb7UUUAFFFFAH/9k=";

               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(13, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(13, 45, "SOLICITUD DE EMPLEO para " + this.eval_solemp.nombre + " de " + this.eval_solemp.empresa);

               this.solicitud(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          solicitud(doc) {

               // console.log("********************************");
               // console.log("EN SOLICITUD !!");
               // console.log(this.eval_solemp);

               var lblanco = '';
               var lfaplico = this.eval_solemp.fecha;
               var lempezo = this.eval_solemp.empezo;
               var ltermino = this.eval_solemp.termino;
               var lcodigo = this.eval_solemp.codigo;
               var lncompleto = this.eval_solemp.pg001;
               var llugnac = this.eval_solemp.pg002;
               var lfecnac = this.eval_solemp.pg003;
               var ledad = this.eval_solemp.pg004;
               var ldpi = this.eval_solemp.pg005;
               var lextendido = this.eval_solemp.pg006;
               var ligss = this.eval_solemp.pg007;
               var lnit = this.eval_solemp.pg008;
               var lpg007 = this.eval_solemp.pg007;
               var lpg008 = this.eval_solemp.pg008;
               var lpg009 = this.eval_solemp.pg009;
               var lpg010 = this.eval_solemp.pg010;
               var lpg011 = this.eval_solemp.pg011;
               var lpg012 = this.eval_solemp.pg012;
               var lpg013 = this.eval_solemp.pg013;
               var lpg014 = this.eval_solemp.pg014;
               var lpg015 = this.eval_solemp.pg015;
               var lpg016 = this.eval_solemp.pg016;
               var lpg017 = this.eval_solemp.pg017;
               var lpg018 = this.eval_solemp.pg018;
               var lpg019 = this.eval_solemp.pg019;
               var lpg020 = this.eval_solemp.pg020;
               var lpg021 = this.eval_solemp.pg021;
               var lpg023 = this.eval_solemp.pg023;
               var lpg025 = this.eval_solemp.pg025;
               var lpg022 = this.eval_solemp.pg022.toString() + '; ' + lpg023;
               var lpg024 = this.eval_solemp.pg024.toString() + '; ' + lpg025;

               var lpg026 = this.eval_solemp.pg026;
               var lpg027 = this.eval_solemp.pg027;
               var lpg028 = this.eval_solemp.pg028;
               var lpg029 = this.eval_solemp.pg029;
               var lpg030 = this.eval_solemp.pg030;
               var lpg031 = this.eval_solemp.pg031;
               var lpg032 = this.eval_solemp.pg032;
               var lpg033 = this.eval_solemp.pg033;
               var lpg034 = this.eval_solemp.pg034;
               var lpg035 = this.eval_solemp.pg035;
               var lpg036 = this.eval_solemp.pg036;
               var lpg037 = this.eval_solemp.pg037;
               var lpg038 = this.eval_solemp.pg038;
               var lpg039 = this.eval_solemp.pg039;
               var lpg040 = this.eval_solemp.pg040;
               var lpg041 = this.eval_solemp.pg041;
               var lpg042 = this.eval_solemp.pg042;
               var lpg043 = this.eval_solemp.pg043;
               var lpg044 = this.eval_solemp.pg044;
               var lpg045 = this.eval_solemp.pg045;
               var lpg046 = this.eval_solemp.pg046;
               var lpg047 = this.eval_solemp.pg047;
               var lpg048 = this.eval_solemp.pg048;
               var lpg049 = this.eval_solemp.pg049;
               var lpg050 = this.eval_solemp.pg050;
               var lpg051 = this.eval_solemp.pg051;
               var lpg052 = this.eval_solemp.pg052;
               var lpg053 = this.eval_solemp.pg053;
               var lpg054 = this.eval_solemp.pg054;
               var lpg055 = this.eval_solemp.pg055;
               var lpg056 = this.eval_solemp.pg056;
               var lpg057 = this.eval_solemp.pg057;
               var lpg058 = this.eval_solemp.pg058;
               var lpg059 = this.eval_solemp.pg059;
               var lpg060 = this.eval_solemp.pg060;
               var lpg061 = this.eval_solemp.pg061;
               var lpg062 = this.eval_solemp.pg062;
               var lpg063 = this.eval_solemp.pg063;
               var lpg064 = this.eval_solemp.pg064;
               var lpg065 = this.eval_solemp.pg065;
               var lpg066 = this.eval_solemp.pg066;
               var lpg067 = this.eval_solemp.pg067;
               var lpg068 = this.eval_solemp.pg068;
               var lpg069 = this.eval_solemp.pg069;
               var lpg070 = this.eval_solemp.pg070;
               var lpg071 = this.eval_solemp.pg071;
               var lpg072 = this.eval_solemp.pg072;
               var lpg073 = this.eval_solemp.pg073;
               var lpg074 = this.eval_solemp.pg074;
               var lpg075 = this.eval_solemp.pg075;
               var lpg076 = this.eval_solemp.pg076;
               var lpg077 = this.eval_solemp.pg077;
               var lpg078 = this.eval_solemp.pg078;
               var lpg079 = this.eval_solemp.pg079;
               var lpg080 = this.eval_solemp.pg080;
               var lpg081 = this.eval_solemp.pg081;
               var lpg082 = this.eval_solemp.pg082;
               var lpg083 = this.eval_solemp.pg083;
               var lpg084 = this.eval_solemp.pg084;
               var lpg085 = this.eval_solemp.pg085;
               var lpg086 = this.eval_solemp.pg086;
               var lpg087 = this.eval_solemp.pg087;
               var lpg088 = this.eval_solemp.pg088;
               var lpg089 = this.eval_solemp.pg089;
               var lpg090 = this.eval_solemp.pg090;
               var lpg091 = this.eval_solemp.pg091;
               var lpg092 = this.eval_solemp.pg092;
               var lpg093 = this.eval_solemp.pg093;
               var lpg094 = this.eval_solemp.pg094;
               var lpg095 = this.eval_solemp.pg095;
               var lpg096 = this.eval_solemp.pg096;
               var lpg097 = this.eval_solemp.pg097;
               var lpg098 = this.eval_solemp.pg098;
               var lpg099 = this.eval_solemp.pg099;
               var lpg100 = this.eval_solemp.pg100;
               var lpg101 = this.eval_solemp.pg101;
               var lpg102 = this.eval_solemp.pg102;
               var lpg103 = this.eval_solemp.pg103;
               var lpg104 = this.eval_solemp.pg104;
               var lpg105 = this.eval_solemp.pg105;
               var lpg106 = this.eval_solemp.pg106;
               var lpg107 = this.eval_solemp.pg107;
               var lpg108 = this.eval_solemp.pg108;
               var lpg109 = this.eval_solemp.pg109;
               var lpg110 = this.eval_solemp.pg110;
               var lpg111 = this.eval_solemp.pg111;
               var lpg112 = this.eval_solemp.pg112;
               var lpg113 = this.eval_solemp.pg113;
               var lpg114 = this.eval_solemp.pg114;
               var lpg115 = this.eval_solemp.pg115;
               var lpg116 = this.eval_solemp.pg116;
               var lpg117 = this.eval_solemp.pg117;
               var lpg118 = this.eval_solemp.pg118;
               var lpg119 = this.eval_solemp.pg119;
               var lpg120 = this.eval_solemp.pg120;
               var lpg121 = this.eval_solemp.pg121;
               var lpg122 = this.eval_solemp.pg122;
               var lpg123 = this.eval_solemp.pg123;
               var lpg124 = this.eval_solemp.pg124;
               var lpg125 = this.eval_solemp.pg125;
               var lpg126 = this.eval_solemp.pg126;
               var lpg127 = this.eval_solemp.pg127;
               var lpg128 = this.eval_solemp.pg128;
               var lpg129 = this.eval_solemp.pg129;
               var lpg130 = this.eval_solemp.pg130;
               var lpg131 = this.eval_solemp.pg131;
               var lpg132 = this.eval_solemp.pg132;
               var lpg133 = this.eval_solemp.pg133;
               var lpg134 = this.eval_solemp.pg134;
               var lpg135 = this.eval_solemp.pg135;
               var lpg136 = this.eval_solemp.pg136;
               var lpg137 = this.eval_solemp.pg137;
               var lpg138 = this.eval_solemp.pg138;
               var lpg139 = this.eval_solemp.pg139;
               var lpg140 = this.eval_solemp.pg140;
               var lpg141 = this.eval_solemp.pg141;
               var lpg142 = this.eval_solemp.pg142;
               var lpg143 = this.eval_solemp.pg143;
               var lpg144 = this.eval_solemp.pg144;
               var lpg145 = this.eval_solemp.pg145;
               var lpg146 = this.eval_solemp.pg146;
               var lpg147 = this.eval_solemp.pg147;
               var lpg148 = this.eval_solemp.pg148;
               var lpg149 = this.eval_solemp.pg149;
               var lpg150 = this.eval_solemp.pg150;
               var lpg151 = this.eval_solemp.pg151;
               var lpg152 = this.eval_solemp.pg152;
               var lpg153 = this.eval_solemp.pg153;
               var lpg154 = this.eval_solemp.pg154;
               var lpg155 = this.eval_solemp.pg155;
               var lpg156 = this.eval_solemp.pg156;
               var lpg157 = this.eval_solemp.pg157;
               var lpg158 = this.eval_solemp.pg158;
               var lpg159 = this.eval_solemp.pg159;
               var lpg160 = this.eval_solemp.pg160;
               var lpg161 = this.eval_solemp.pg161;
               var lpg162 = this.eval_solemp.pg162;
               var lpg163 = this.eval_solemp.pg163;
               var lpg164 = this.eval_solemp.pg164;
               var lpg165 = this.eval_solemp.pg165;
               var lpg166 = this.eval_solemp.pg166;
               var lpg167 = this.eval_solemp.pg167;
               var lpg168 = this.eval_solemp.pg168;
               var lpg169 = this.eval_solemp.pg169;
               var lpg170 = this.eval_solemp.pg170;
               var lpg171 = this.eval_solemp.pg171;
               var lpg172 = this.eval_solemp.pg172;
               var lpg173 = this.eval_solemp.pg173;
               var lpg174 = this.eval_solemp.pg174;
               var lpg175 = this.eval_solemp.pg175;
               var lpg176 = this.eval_solemp.pg176;
               var lpg177 = this.eval_solemp.pg177;
               var lpg178 = this.eval_solemp.pg178;
               var lpg179 = this.eval_solemp.pg179;
               var lpg180 = this.eval_solemp.pg180;
               var lpg181 = this.eval_solemp.pg181;
               var lpg182 = this.eval_solemp.pg182;
               var lpg183 = this.eval_solemp.pg183;
               var lpg184 = this.eval_solemp.pg184;
               var lpg185 = this.eval_solemp.pg185;
               var lpg186 = this.eval_solemp.pg186;
               var lpg187 = this.eval_solemp.pg187;
               var lpg188 = this.eval_solemp.pg188;
               var lpg189 = this.eval_solemp.pg189;
               var lpg190 = this.eval_solemp.pg190;
               var lpg191 = this.eval_solemp.pg191;
               var lpg192 = this.eval_solemp.pg192;
               var lpg193 = this.eval_solemp.pg193;
               var lpg194 = this.eval_solemp.pg194;
               var lpg195 = this.eval_solemp.pg195;
               var lpg196 = this.eval_solemp.pg196;
               var lpg197 = this.eval_solemp.pg197;
               var lpg198 = this.eval_solemp.pg198;
               var lpg199 = this.eval_solemp.pg199;
               var lpg200 = this.eval_solemp.pg200;
               var lpg201 = this.eval_solemp.pg201;
               var lpg202 = this.eval_solemp.pg202;
               var lpg203 = this.eval_solemp.pg203;
               var lpg204 = this.eval_solemp.pg204;
               var lpg205 = this.eval_solemp.pg205;
               var lpg206 = this.eval_solemp.pg206;
               var lpg207 = this.eval_solemp.pg207;

               console.log("1. termine de cargar valores");
               doc.setLineWidth(0.7);
               doc.line(13, 50, 195, 50); // horizontal line (init_col, init_row, , )

               doc.setFontSize(9);
               doc.setFontType("bold");
               doc.text(13, 57, 'I) INFORMACION PERSONAL');
               doc.setLineWidth(0.5);
               doc.rect(12, 59, 185, 45);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(15, 65, 'LUGAR Y FECHA DE NACIMIENTO:');
               doc.text(15, 71, 'EDAD:');
               doc.text(35, 71, 'DPI:');
               doc.text(100, 71, 'EXTENDIDA EN:');
               let llugfecnac = llugnac + '; ' + lfecnac;

               doc.setFontType("normal");
               doc.text(72, 65, llugfecnac);
               doc.text(27, 71, ledad.toString());
               doc.text(45, 71, ldpi);
               doc.text(127, 71, lextendido);

               doc.setFontType("bolditalic");
               doc.text(15, 77, 'AFILIACION AL IGSS:');
               doc.text(95, 77, 'NIT:');
               doc.text(130, 77, 'ESTADO CIVIL:');
               doc.setFontType("normal");
               doc.text(50, 77, lpg007);
               doc.text(103, 77, lpg008);
               doc.text(160, 77, lpg009);

               doc.setFontType("bolditalic");
               doc.text(15, 81.5, 'NACIONALIDAD:');          /* pg010 */
               doc.text(15, 85, 'PROFESION U OFICIO:');
               doc.setFontType("normal");
               doc.text(45, 81.5, lpg010);
               doc.text(15, 88, lpg011);

               doc.setFontType("bolditalic");
               doc.text(15, 91, 'DIRECCION ACTUAL:');
               doc.text(15, 98, 'E-MAIL:');
               doc.setFontType("normal");
               var msg = 'E-MAIL';
               var pos1 = 140 + msg.length + 7;
               doc.text(15, 94, lpg012);
               doc.text(35, 98, lpg013);

               doc.setFontType("bolditalic");
               let msg1 = 'TELEFONO DOMICILIO:';
               let msg2 = 'TELEFONO CELULAR:';
               pos1 = 15 + msg1.length + 20;
               let pos2 = 101 + msg2.length + 20;
               doc.text(15, 102.5, msg1);
               doc.text(100, 102.5, msg2);
               doc.setFontType("normal");
               doc.text(pos1, 102.5, lpg014);
               doc.text(pos2, 102.5, lpg015);

               doc.rect(12, 111, 185, 120);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bold");
               doc.text(13, 110, 'II) DATOS FAMILIARES');
               doc.setFontType("bolditalic");
               doc.text(15, 116, 'NOMBRE DEL PADRE:');
               doc.text(145, 116, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(53, 116, lpg016);
               doc.text(165, 116, lpg017);

               doc.setFontType("bolditalic");
               doc.text(15, 121, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(53, 121, lpg018);

               doc.setFontType("bolditalic");
               doc.text(15, 127, 'NOMBRE DE LA MADRE:');
               doc.text(145, 127, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(55, 127, lpg019);
               doc.text(165, 127, lpg020);

               doc.setFontType("bolditalic");
               doc.text(15, 133, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(55, 133, lpg021);

               doc.setFontType("bolditalic");
               doc.text(15, 137.5, 'No. DE HERMANOS Y PROFESIONES:');
               doc.text(15, 144.5, 'No. DE CARGAS FAMILIARES Y QUIENES:');
               doc.setFontType("normal");
               doc.text(15, 140.5, lpg022);
               doc.text(15, 147, lpg024);

               doc.setFontType("bolditalic");
               doc.text(75, 150.5, '------ DATOS DEL CONYUGUE ------');
               doc.text(15, 154, 'NOMBRE COMPLETO:');
               doc.text(15, 157, 'OCUPACION:');
               doc.setFontType("normal");
               doc.text(55, 154, lpg026);
               doc.text(35, 158, lpg027);

               doc.setFontType("bolditalic");
               doc.text(15, 163, 'LUGAR DE TRABAJO:');
               doc.setFontType("normal");
               doc.text(55, 163, lpg028);
               doc.setFontType("bolditalic");
               doc.text(15, 168, 'DIRECCION:');
               doc.text(110, 168, 'TELEFONO:');
               doc.setFontType("normal");
               doc.text(15, 171, lpg029);
               doc.text(135, 169, lpg030);
               doc.setFontType("bolditalic");
               doc.text(15, 175, 'CARGO QUE OCUPA:');
               doc.setFontType("normal");
               doc.text(55, 175, lpg031);
               doc.setFontType("bolditalic");

               doc.text(75, 180, '------ DATOS DE LOS HIJOS ------');
               doc.text(15, 186, '1) NOMBRE:');
               doc.text(140, 186, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 186, lpg032);
               doc.text(165, 186, lpg033);

               doc.setFontType("bolditalic");
               doc.text(18, 190, 'ESCOLARIDAD:');
               doc.text(18, 193, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(45, 190, lpg034);
               doc.text(45, 193, lpg035);
               doc.setFontType("bolditalic");

               doc.text(15, 198, '2) NOMBRE:');
               doc.text(140, 198, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 198, lpg036);
               doc.text(165, 198, lpg037);

               doc.setFontType("bolditalic");
               doc.text(18, 202, 'ESCOLARIDAD:');
               doc.text(18, 205, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(45, 202, lpg038);
               doc.text(45, 205, lpg039);
               doc.setFontType("bolditalic");

               doc.text(15, 210, '3) NOMBRE:');
               doc.text(140, 210, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 210, lpg040);
               doc.text(165, 210, lpg041);
               
               doc.setFontType("bolditalic");
               doc.text(18, 214, 'ESCOLARIDAD:');
               doc.text(18, 217, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(45, 214, lpg042);
               doc.text(45, 217, lpg043);

               doc.setFontType("bolditalic");
               doc.text(15, 222, '4) NOMBRE:');
               doc.text(140, 222, 'EDAD:');
               doc.setFontType("normal");
               doc.text(55, 222, lpg044);
               doc.text(165, 222, lpg045);
               doc.setFontType("bolditalic");

               doc.text(18, 226, 'ESCOLARIDAD:');
               doc.text(18, 229, 'INSTITUCION:');
               doc.setFontType("normal");
               doc.text(45, 226, lpg046);
               doc.text(45, 229    , lpg047);

               console.log("antes de informacion socioeconomica");
               doc.rect(12, 239, 185, 30);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bold");
               doc.text(13, 238, 'III) INFORMACION SOCIOECONOMICA');
               doc.setFontType("bolditalic");
               doc.text(15, 244, 'VIVE EN CASA PROPIA ?');
               doc.text(85, 244, 'ALQUILA ?');
               doc.text(130, 244, 'DE SUS PADRES ?');
               doc.setFontType("normal");
               doc.text(55, 244, lpg048);
               doc.text(105, 244, lpg049);
               doc.text(160, 244, lpg050);
               doc.setFontType("bolditalic");
               doc.text(15, 250, 'TIENE VEHICULO PROPIO ?');
               doc.text(70, 250, 'MARCA Y AÑO');
               doc.setFontType("normal");
               doc.text(60, 250, lpg051);
               let lpg5253 = lpg052 + '; ' + lpg053;
               doc.text(95, 250, lpg5253);
               doc.setFontType("bolditalic");
               doc.text(15, 256, 'RECIBE OTROS INGRESOS QUE NO SEAN DE SU SUELDO ?');
               doc.text(130, 256, 'MONTO');
               doc.setFontType("normal");
               doc.text(110, 256, lpg054);
               doc.text(160, 256, lpg055);
               doc.setFontType("bolditalic");
               doc.text(15, 262, 'DE DONDE PROCEDE ESTE INGRESO');
               doc.setFontType("normal");
               doc.text(15, 265, lpg056);
               doc.setFontType("bolditalic");

               doc.setFontType("normal");
               console.log("antes de pagina 2")
               /* ========================================================================================== */
               /* PAGINA 2 */
               doc.addPage();
               doc.text(15, 10, 'Segunda Página');
               doc.text(125, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
               doc.setFontType("bold");
               doc.text(13, 20, 'IV) FORMACION ACADEMICA');
               doc.rect(12, 22, 190, 125);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(73, 26, '- POSTGRADO ');
               doc.text(13, 29, '1) INSTITUCION:');
               doc.text(13, 33, 'GRADO Y TITULO:');
               doc.text(13, 39, 'FECHA:');

               doc.setFontType("normal");
               doc.text(43, 30, lpg057);
               doc.text(13, 36, lpg058);
               doc.text(30, 39, lpg059);

               doc.setFontType("bolditalic");
               doc.text(13, 44, '2) INSTITUCION:');
               doc.text(13, 48, 'GRADO Y TITULO:');
               doc.text(13, 55, 'FECHA:');
               doc.setFontType("normal");
               doc.text(39, 44, lpg060);
               doc.text(13, 51, lpg061);
               doc.text(30, 55, lpg062);
               doc.setFontType("bolditalic");

               doc.text(73, 59, '- UNIVERSITARIA');
               doc.text(13, 62, 'INSTITUCION:');
               doc.text(13, 66, 'GRADO Y TITULO:');
               doc.text(13, 73, 'FECHA:');
               doc.setFontType("normal");
               doc.text(36, 62, lpg063);
               doc.text(13, 69, lpg064);
               doc.text(30, 73, lpg065);
               doc.setFontType("bolditalic");

               doc.text(73, 76, '- DIVERSIFICADA');
               doc.text(13, 79, 'INSTITUCION:');
               doc.text(13, 85, 'GRADO OBTENIDO Y TITULO:');
               doc.text(13, 91, 'FECHA:');
               doc.setFontType("normal");
               doc.text(13, 82, lpg066);
               doc.text(13, 87, lpg067);
               doc.text(30, 91, lpg068);
               doc.setFontType("bolditalic");               

               doc.text(13, 96, '- OTROS CURSOS DE ACTUALIZACION RELACIONADOS CON SU PROFESION:');
               doc.setFontType("normal");
               doc.text(13, 99, lpg069);
               doc.setFontType("bolditalic");

               doc.text(13, 103, '- OTROS CONOCIMIENTOS O HABILIDADES QUE POSEE:');
               doc.setFontType("normal");
               doc.text(13, 105, lpg070);
               doc.setFontType("bolditalic");

               doc.text(13, 110, '- PREMIOS O MENCIONES HONORIFICAS OBTENIDAS:');
               doc.text(13, 119, '- ESTUDIA ACTUALMENTE ?');
               doc.text(65, 119, 'ESPECIFIQUE:');
               doc.text(13, 126, '  HORARIO:');
               doc.setFontType("normal");
               doc.text(13, 112, lpg071.substring(0,100));
               doc.text(13, 114, lpg071.substring(101));
               doc.text(59, 118.5, lpg072);
               doc.text(13, 122, lpg073);
               doc.text(13, 128, lpg074);
               doc.setFontType("bolditalic");

               console.log("antes de idiomas adicionales")
               doc.text(75, 132, '------ IDIOMAS ADICIONALES ------');
               doc.text(13, 135, '1) IDIOMA:');
               doc.text(13, 138, 'LEE ');
               doc.text(45, 138, 'ESCRIBE');
               doc.text(85, 138, 'CONVERSA');
               doc.setFontType("normal");
               doc.text(35, 135, lpg075);
               doc.text(25, 138, lpg076);
               doc.text(65, 138, lpg077);
               doc.text(110, 138, lpg078);
               doc.setFontType("bolditalic");

               doc.text(13, 142, '2) IDIOMA:');
               doc.text(13, 145, 'LEE ');
               doc.text(45, 145, 'ESCRIBE');
               doc.text(85, 145, 'CONVERSA');
               doc.setFontType("normal");
               doc.text(35, 142, lpg079);
               doc.text(25, 145, lpg080);
               doc.text(65, 145, lpg081);
               doc.text(110, 145, lpg082);

               doc.setFontType("bold");
               doc.text(13, 150, 'V) EXPERIENCIA LABORAL (LOS TRES ULTIMOS EMPLEOS)');
               doc.rect(12, 152, 190, 130);              /*  rect(init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 156, '- EMPRESA 1 ');
               doc.text(13, 160, '  NOMBRE:');
               doc.text(13, 163, '  TELEFONO:');
               doc.text(13, 168, '  DIRECCION:');
               doc.text(13, 174, '  GIRO DEL NEGOCIO:');

               doc.setFontSize(8);
               doc.text(13, 180, 'FECHA DE INGRESO:');

               doc.setFontSize(9);
               doc.text(85, 180, 'FECHA EGRESO:');
               doc.text(143, 180, 'TRABAJA ACTUALMENTE AQUI ?');
               doc.text(13, 184, '  CARGO INICIAL:');
               doc.text(13, 187, '  CARGO ACTUAL:');
               doc.text(13, 192, '  SALARIO INICIAL:');
               doc.text(110, 192, 'SALARIO ACTUAL:');
               doc.text(13, 198, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 212, ' 1) ');
               doc.text(13, 218, ' 2) ');
               doc.text(13, 224, ' 3) ');
               doc.text(13, 230, ' 4) ');
               doc.text(13, 236, ' 5) ');
               doc.text(13, 242, ' 6) ');
               doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 253, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 265, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 278, '  PORQUE:');
               doc.setFontType("normal");
               console.log("lpg090 ? ", this.eval_solemp.pg090);

               doc.text(35, 160, lpg083);
               doc.text(35, 163, lpg085);
               doc.text(15, 171, lpg084);
               doc.text(15, 176, lpg086);

               doc.setFontSize(8);
               doc.text(49, 180, lpg087);
               doc.text(113, 180, lpg088);
               doc.text(196, 180, lpg089);

               doc.setFontSize(9);
               doc.text(42, 184, lpg090);
               doc.text(42, 187, lpg091);
               doc.text(45, 192, lpg092);
               doc.text(145, 192, lpg093);
               doc.text(15, 202, lpg094);

               doc.setFontSize(8);
               doc.text(19, 212, lpg095);
               doc.text(19, 218, lpg096);
               doc.text(19, 224, lpg097);
               doc.text(19, 230, lpg098);
               doc.text(19, 236, lpg099);
               doc.text(19, 242, lpg100);

               doc.setFontSize(9);
               doc.text(79, 248, lpg101);
               doc.text(15, 256, lpg102);
               doc.text(79, 260, lpg103);
               doc.text(15, 267, lpg104);
               doc.text(79, 272, lpg105);
               doc.text(15, 281, lpg106);

               /* PAGINA 3 */
               doc.addPage();
               doc.text(15, 10, 'Tercera Página');
               doc.text(125, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )

               doc.rect(12, 20, 190, 265);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 24, '- EMPRESA 2 ');
               doc.text(13, 30, '  NOMBRE:');
               doc.text(13, 33, '  TELEFONO:');
               doc.text(13, 38, '  DIRECCION:');
               doc.text(13, 44, '  GIRO DEL NEGOCIO:');
               doc.text(13, 50, 'FECHA DE INGRESO:');
               doc.text(85, 50, 'FECHA EGRESO:');
               doc.text(143, 50, 'TRABAJA ACTUALMENTE AQUI ?');
               doc.text(13, 54, '  CARGO INICIAL:');
               doc.text(13, 57, '  CARGO ACTUAL:');
               doc.text(13, 62, '  SALARIO INICIAL:');
               doc.text(110, 62, '  SALARIO ACTUAL:');
               doc.text(13, 68, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 76, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 82, ' 1) ');
               doc.text(13, 88, ' 2) ');
               doc.text(13, 94, ' 3) ');
               doc.text(13, 100, '4) ');
               doc.text(13, 106, '5) ');
               doc.text(13, 112, '6) ');
               doc.text(13, 118, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 123, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 130, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 135, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 142, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 147, '  PORQUE:');
               doc.setFontType("normal");
               doc.text(35, 30, lpg107);
               doc.text(35, 33, lpg108);
               doc.text(15, 41, lpg109);
               doc.text(15, 46, lpg110);

               doc.setFontSize(8);
               doc.text(49, 50, lpg111);
               doc.text(113, 50, lpg112);
               doc.text(196, 50, lpg113);

               doc.setFontSize(9);
               doc.text(45, 54, lpg114);
               doc.text(45, 57, lpg115);
               doc.text(45, 62, lpg116);
               doc.text(145, 62, lpg117);
               doc.text(15, 72, lpg118);

               doc.setFontSize(8);
               doc.text(19, 82, lpg119);
               doc.text(19, 88, lpg120);
               doc.text(19, 94, lpg121);
               doc.text(19, 100, lpg122);
               doc.text(19, 106, lpg123);
               doc.text(19, 112, lpg124);

               doc.setFontSize(9);
               doc.text(15, 121, lpg125);
               doc.text(15, 126, lpg126);
               doc.text(79, 130, lpg127);
               doc.text(15, 138, lpg128);
               doc.text(79, 142, lpg129);
               doc.text(15, 149, lpg130);


               doc.line(13, 150, 200, 150); // horizontal line (init_col, init_row, , )
               doc.setFontType("bolditalic");
               doc.text(13, 156, '- EMPRESA 3 ');
               doc.text(13, 160, '  NOMBRE:');
               doc.text(13, 163, 'TELEFONO:');
               doc.text(13, 168, ' DIRECCION:');
               doc.text(13, 174, '  GIRO DEL NEGOCIO:');

               doc.setFontSize(8);
               doc.text(13, 180, 'FECHA DE INGRESO:');

               doc.setFontSize(9);
               doc.text(85, 180, 'FECHA DE EGRESO:');
               doc.text(145, 180, 'TRABAJA ACTUALMENTE AQUI ?');
               doc.text(13, 184, '  CARGO INICIAL:');
               doc.text(13, 187, 'CARGO ACTUAL:');
               doc.text(13, 192, '  SALARIO INICIAL:');
               doc.text(110, 192, 'SALARIO ACTUAL:');
               doc.text(13, 198, '  OTRAS PRESTACIONES DE LEY (ALMUERZOS, PARQUEO, MEMBRESIAS, ETC.)');
               doc.text(65, 206, '------ FUNCIONES PRINCIPALES DESEMPEÑADAS ------');
               doc.text(13, 212, ' 1) ');
               doc.text(13, 218, ' 2) ');
               doc.text(13, 224, ' 3) ');
               doc.text(13, 230, ' 4) ');
               doc.text(13, 236, ' 5) ');
               doc.text(13, 242, ' 6) ');
               doc.text(13, 248, '  NOMBRE DE SU JEFE INMEDIATO:');
               doc.text(13, 253, '  PUESTO DE SU JEFE INMEDIATO:');
               doc.text(13, 260, '  NUMERO DE PERSONAS A SU CARGO:');
               doc.text(13, 265, '  MOTIVO DE SU RETIRO:');
               doc.text(13, 272, '  PODEMOS PEDIR REFERENCIAS ?');
               doc.text(13, 278, '  PORQUE:');
               doc.setFontType("normal");
               doc.text(35, 160, lpg131);
               doc.text(35, 163, lpg133);
               doc.text(15, 171, lpg132);
               doc.text(15, 176, lpg134);

               doc.setFontSize(8);
               doc.text(49, 180, lpg135);
               doc.text(118, 180, lpg136);
               doc.text(198, 180, lpg137);

               doc.setFontSize(9);
               doc.text(42, 184, lpg138);
               doc.text(42, 187, lpg139);
               doc.text(45, 192, lpg140);
               doc.text(145, 192, lpg141);
               doc.text(15, 202, lpg142);

               doc.setFontSize(8);
               doc.text(19, 212, lpg143);
               doc.text(19, 218, lpg144);
               doc.text(19, 224, lpg145);
               doc.text(19, 230, lpg146);
               doc.text(19, 236, lpg147);
               doc.text(19, 242, lpg148);

               doc.setFontSize(9);
               doc.text(79, 248, lpg149);
               doc.text(15, 256, lpg150);
               doc.text(79, 260, lpg151);
               doc.text(15, 267, lpg152);
               doc.text(79, 272, lpg153);
               doc.text(15, 281, lpg154);

               /* PAGINA 4 */
               doc.addPage(); 
               doc.text(15, 10, 'Cuarta Página');
               doc.text(125, 10, lncompleto);
               doc.setLineWidth(0.7);
               doc.line(13, 14, 200, 14); // horizontal line (init_col, init_row, , )
               doc.setFontType("bold");
               doc.text(13, 20, 'VI) FORMACION ACADEMICA');
               doc.rect(12, 22, 190, 260);    /*  RECTANGULO (init_col, init_row, end_col, end_row) */
               doc.setFontType("bolditalic");
               doc.text(13, 32, 'Organización, cultural, deportiva, religiosa, sindical u otras a las que pertenecido:');
               doc.text(13, 50, 'Escriba algún deporte o pasatiempo preferido:');
               doc.text(13, 68, '* Salud en General:');

               doc.text(13, 74, '  Ha padecido de alguna enfermedad en los últimos 3 años ?');
               doc.text(13, 80, '  ESPECIFIQUE:');
               doc.text(13, 86, '* Condiciones de Trabajo:');
               doc.text(13, 92, '  Puesto al que aplica ?');
               doc.text(13, 98, '  Expectativa salarial ');
               doc.text(13, 106, '  Tiene limitaciones de horario ?');
               doc.text(75, 106, '  ESPECIFIQUE:');
               doc.text(13, 112, '  ¿ A partir de qué fecha está disponible ?');
               doc.text(13, 118, '  Está dispuesto a viajar como parte de su trabajo ?');
               doc.text(13, 124, '  Posee pasaporte vigente ?');
               doc.text(70, 124, '  No. de Pasaporte ');
               doc.text(13, 130, '* Información complementaria:');
               doc.text(13, 136, '  Ha tenido problemas con la justicia ?');
               doc.text(85, 136, '  EXPLIQUE:');
               doc.text(13, 142, '  Hay deudas de alguna naturaleza ?');
               doc.text(85, 142, '  EXPLIQUE:');
               doc.text(13, 148, '  Tiene tatuajes ?');
               doc.setFontType("normal");
               doc.text(13, 36, '* ' + lpg155);
               doc.text(13, 42, '* ' + lpg156);
               doc.text(13, 54, lpg157);
               doc.text(13, 57, lpg158);
               doc.text(13, 60, lpg159);
               doc.text(13, 63, lpg160);

               doc.text(120, 74, lpg161);
               doc.text(15, 83, lpg162);
               doc.text(15, 89, lpg163);
               doc.text(15, 95, lpg164);
               doc.text(63, 106, lpg165);
               doc.text(15, 109, lpg166);
               doc.text(15, 115, lpg167);
               doc.text(95, 118, lpg168);
               doc.text(62, 124, lpg169);
               doc.text(99, 124, lpg170);
               doc.text(75, 136, lpg171);
               doc.text(15, 139, lpg172);
               doc.text(75, 142, lpg173);
               doc.text(15, 145, lpg174);
               doc.text(75, 148, lpg175);

               doc.line(13, 151, 200, 151); // horizontal line (init_col, init_row, , )
               doc.setFontType("bolditalic");
               doc.text(13, 160, 'VII) REFERENCIAS PERSONALES Y LABORALES');
               doc.text(13, 166, '* Referencias Personales:');
               doc.text(13, 172, '  a) NOMBRE:');
               doc.text(140, 172, '  TELEFONO:');
               doc.text(13, 178, '       E-MAIL:');
               doc.text(140, 178, '  OCUPACION:');
               doc.text(13, 184, '  b) NOMBRE:');
               doc.text(140, 184, '  TELEFONO:');
               doc.text(13, 190, '       E-MAIL:');
               doc.text(140, 190, '  OCUPACION:');
               doc.text(13, 196, '  c) NOMBRE:');
               doc.text(140, 196, '  TELEFONO:');
               doc.text(13, 202, '       E-MAIL:');
               doc.text(140, 202, '  OCUPACION:');
               doc.text(13, 208, '  d) NOMBRE:');
               doc.text(140, 208, '  TELEFONO:');
               doc.text(13, 214, '       E-MAIL:');
               doc.text(140, 214, '  OCUPACION:');
               doc.setFontType("normal");
               doc.text(35, 172, lpg176);
               doc.text(165, 172, lpg177);
               doc.text(35, 178, lpg178);
               doc.text(15, 181, lpg179);
               doc.text(35, 184, lpg180);
               doc.text(165, 184, lpg181);
               doc.text(35, 190, lpg182);
               doc.text(15, 193, lpg183);
               doc.text(35, 196, lpg184);
               doc.text(165, 196, lpg185);
               doc.text(35, 202, lpg186);
               doc.text(15, 205, lpg187);
               doc.text(35, 208, lpg188);
               doc.text(165, 208, lpg189);
               doc.text(35, 214, lpg190);
               doc.text(15, 217, lpg191);

               doc.setFontType("bolditalic");
               doc.text(13, 228, '* Referencias Laborales:');
               doc.text(13, 234, '  a) EMPRESA:');
               doc.text(16, 237, '  NOMBRE:');
               doc.text(13, 240, '       TEL Y E-MAIL:');
               doc.text(16, 243, '  OCUPACION:');

               doc.text(13, 246, '  b) EMPRESA:');
               doc.text(16, 249, '  NOMBRE:');
               doc.text(13, 252, '       TEL Y E-MAIL:');
               doc.text(16, 255, '  OCUPACION:');

               doc.text(13, 258, '  c) EMPRESA:');
               doc.text(16, 261, '  NOMBRE:');
               doc.text(13, 264, '       TEL Y E-MAIL:');
               doc.text(16, 267, '  OCUPACION:');

               doc.text(13, 270, '  d) EMPRESA:');
               doc.text(16, 273, '  NOMBRE:');
               doc.text(13, 276, '       TEL Y E-MAIL:');
               doc.text(16, 279, '  OCUPACION:');
               doc.setFontType("normal");
               doc.text(37, 234, lpg192);
               doc.text(35, 237, lpg193);
               doc.text(43, 240, lpg194);
               doc.text(39, 243, lpg195);

               doc.text(37, 246, lpg196);
               doc.text(35, 249, lpg197);
               doc.text(43, 252, lpg198);
               doc.text(39, 255, lpg199);

               doc.text(37, 258, lpg200);
               doc.text(35, 261    , lpg201);
               doc.text(43, 264, lpg202);
               doc.text(39, 267, lpg203);

               doc.text(37, 270, lpg204);
               doc.text(35, 273, lpg205);
               doc.text(43, 276, lpg206);
               doc.text(39, 279, lpg207);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_emoc() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_emoc.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "emoc_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación de EMOCIONES para " + this.eval_emoc.nombre + " de " + this.eval_emoc.empresa);

               this.respuestasemoc(doc);
               this.resultadosemoc(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosemoc() {

               /* ==============================================================================================================
               *  AUTO CONCIENCIA */
               let comp1 = false;
               this.res_emoc.autocon_A = 0;
               this.res_emoc.autocon_B = 0;
               comp1 = (this.eval_emoc.pg001 >= 1 && this.eval_emoc.pg001 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg006 >= 1 && this.eval_emoc.pg006 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg011 >= 1 && this.eval_emoc.pg011 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg012 >= 1 && this.eval_emoc.pg012 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg013 >= 1 && this.eval_emoc.pg013 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg014 >= 1 && this.eval_emoc.pg014 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg015 >= 1 && this.eval_emoc.pg015 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg017 >= 1 && this.eval_emoc.pg017 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg018 >= 1 && this.eval_emoc.pg018 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg019 >= 1 && this.eval_emoc.pg019 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg020 >= 1 && this.eval_emoc.pg020 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               comp1 = (this.eval_emoc.pg021 >= 1 && this.eval_emoc.pg021 <= 4);
               if (comp1 === true) { this.res_emoc.autocon_A = this.res_emoc.autocon_A + 1; } else { this.res_emoc.autocon_B = this.res_emoc.autocon_B + 1; }
               this.res_emoc.autocon = this.res_emoc.autocon_A + this.res_emoc.autocon_B;

               /* ==============================================================================================================
                *  CONTROL EMOCIONES */
               this.res_emoc.emocion_A = 0;
               this.res_emoc.emocion_B = 0;
               comp1 = (this.eval_emoc.pg001 >= 1 && this.eval_emoc.pg001 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg002 >= 1 && this.eval_emoc.pg002 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg003 >= 1 && this.eval_emoc.pg003 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg004 >= 1 && this.eval_emoc.pg004 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg005 >= 1 && this.eval_emoc.pg005 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg007 >= 1 && this.eval_emoc.pg007 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg009 >= 1 && this.eval_emoc.pg009 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg013 >= 1 && this.eval_emoc.pg013 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               comp1 = (this.eval_emoc.pg027 >= 1 && this.eval_emoc.pg027 <= 4);
               if (comp1 === true) { this.res_emoc.emocion_A = this.res_emoc.emocion_A + 1; } else { this.res_emoc.emocion_B = this.res_emoc.emocion_B + 1; }
               this.res_emoc.emocion = this.res_emoc.emocion_A + this.res_emoc.emocion_B;

               /* ==============================================================================================================
                *  CONTROL EMOCIONES */
               this.res_emoc.motivacion_A = 0;
               this.res_emoc.motivacion_B = 0;
               comp1 = (this.eval_emoc.pg007 >= 1 && this.eval_emoc.pg007 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg022 >= 1 && this.eval_emoc.pg022 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg023 >= 1 && this.eval_emoc.pg023 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg025 >= 1 && this.eval_emoc.pg025 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg026 >= 1 && this.eval_emoc.pg026 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg027 >= 1 && this.eval_emoc.pg027 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               comp1 = (this.eval_emoc.pg028 >= 1 && this.eval_emoc.pg028 <= 4);
               if (comp1 === true) { this.res_emoc.motivacion_A = this.res_emoc.motivacion_A + 1; } else { this.res_emoc.motivacion_B = this.res_emoc.motivacion_B + 1; }
               this.res_emoc.motivacion = this.res_emoc.motivacion_A + this.res_emoc.motivacion_B;

               /* ==============================================================================================================
                *  CONTROL EMOCIONES */
               this.res_emoc.relacionarse_A = 0;
               this.res_emoc.relacionarse_B = 0;
               comp1 = (this.eval_emoc.pg008 >= 1 && this.eval_emoc.pg008 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg016 >= 1 && this.eval_emoc.pg016 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg019 >= 1 && this.eval_emoc.pg019 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg020 >= 1 && this.eval_emoc.pg020 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg029 >= 1 && this.eval_emoc.pg029 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg030 >= 1 && this.eval_emoc.pg030 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg031 >= 1 && this.eval_emoc.pg031 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg032 >= 1 && this.eval_emoc.pg032 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg033 >= 1 && this.eval_emoc.pg033 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg034 >= 1 && this.eval_emoc.pg034 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg035 >= 1 && this.eval_emoc.pg035 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg036 >= 1 && this.eval_emoc.pg036 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg037 >= 1 && this.eval_emoc.pg037 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg038 >= 1 && this.eval_emoc.pg038 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg039 >= 1 && this.eval_emoc.pg039 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg042 >= 1 && this.eval_emoc.pg042 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg043 >= 1 && this.eval_emoc.pg043 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg044 >= 1 && this.eval_emoc.pg044 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               comp1 = (this.eval_emoc.pg045 >= 1 && this.eval_emoc.pg045 <= 4);
               if (comp1 === true) { this.res_emoc.relacionarse_A = this.res_emoc.relacionarse_A + 1; } else { this.res_emoc.relacionarse_B = this.res_emoc.relacionarse_B + 1; }
               this.res_emoc.relacionarse = this.res_emoc.relacionarse_A + this.res_emoc.relacionarse_B;

               /* ==============================================================================================================
                *  AUTO CONCIENCIA */
               this.res_emoc.asesoria_A = 0;
               this.res_emoc.asesoria_B = 0;
               comp1 = (this.eval_emoc.pg008 >= 1 && this.eval_emoc.pg008 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg010 >= 1 && this.eval_emoc.pg010 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg016 >= 1 && this.eval_emoc.pg016 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg018 >= 1 && this.eval_emoc.pg018 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg034 >= 1 && this.eval_emoc.pg034 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg035 >= 1 && this.eval_emoc.pg035 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg037 >= 1 && this.eval_emoc.pg037 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg038 >= 1 && this.eval_emoc.pg038 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg039 >= 1 && this.eval_emoc.pg039 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg040 >= 1 && this.eval_emoc.pg040 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg041 >= 1 && this.eval_emoc.pg041 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg044 >= 1 && this.eval_emoc.pg044 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               comp1 = (this.eval_emoc.pg045 >= 1 && this.eval_emoc.pg045 <= 4);
               if (comp1 === true) { this.res_emoc.asesoria_A = this.res_emoc.asesoria_A + 1; } else { this.res_emoc.asesoria_B = this.res_emoc.asesoria_B + 1; }
               this.res_emoc.asesoria = this.res_emoc.asesoria_A + this.res_emoc.asesoria_B;

          },
          resultadosemoc(doc) {
               this.res_emoc = {
                    autocon_A: 0, autocon_B: 0, autocon: 0,
                    emocion_A: 0, emocion_B: 0, emocion: 0,
                    motivacion_A: 0, motivacion_B: 0, motivacion: 0,
                    relacionarse_A: 0, relacionarse_B: 0, relacionarse: 0,
                    asesoria_A: 0, asesoria_B: 0, asesoria: 0,
               };

               this.rangosemoc();

               doc.setLineWidth(0.25);

               doc.text(10, 88, "SECCION DE RESULTADOS ")
               doc.line(10, 89, 206, 89);

               let autocon_A = this.res_emoc.autocon_A;
               let autocon_B = this.res_emoc.autocon_B;
               let autocon = this.res_emoc.autocon;

               let emocion_A = this.res_emoc.emocion_A;
               let emocion_B = this.res_emoc.emocion_B;
               let emocion = this.res_emoc.emocion;

               let motivacion_A = this.res_emoc.motivacion_A;
               let motivacion_B = this.res_emoc.motivacion_B;
               let motivacion = this.res_emoc.motivacion;

               let relacionarse_A = this.res_emoc.relacionarse_A;
               let relacionarse_B = this.res_emoc.relacionarse_B;
               let relacionarse = this.res_emoc.relacionarse;

               let asesoria_A = this.res_emoc.asesoria_A;
               let asesoria_B = this.res_emoc.asesoria_B;
               let asesoria = this.res_emoc.asesoria;

               doc.text(43, 94, "APTITUD"); doc.text(63, 94, "CON 4 MAS"); doc.text(83, 94, "CON 5 O MAS");
               doc.text(43, 96, "-------------"); doc.text(63, 96, "-----------------"); doc.text(83, 96, "-------------------");
               doc.text(15, 100, "INTRA-PERSONAL");
               doc.text(15, 105, "Autoconciencia");
               doc.text(48, 105, autocon_A.toString()); doc.text(68, 105, autocon_B.toString()); doc.text(90, 105, autocon.toString());

               doc.text(15, 110, "Control Emociones");
               doc.text(48, 110, emocion_A.toString()); doc.text(68, 110, emocion_B.toString()); doc.text(90, 110, emocion.toString());

               doc.text(15, 115, "Automotivación");
               doc.text(48, 115, motivacion_A.toString()); doc.text(68, 115, motivacion_B.toString()); doc.text(90, 115, motivacion.toString());

               doc.text(15, 120, "INTER-PERSONAL");
               doc.text(15, 125, "Relacionarse bien");
               doc.text(48, 125, relacionarse_A.toString()); doc.text(68, 125, relacionarse_B.toString()); doc.text(90, 125, relacionarse.toString());

               doc.text(15, 130, "Asesoría emocional");
               doc.text(48, 130, asesoria_A.toString()); doc.text(68, 130, asesoria_B.toString()); doc.text(90, 130, asesoria.toString());

          },
          respuestasemoc(doc) {

               console.log("EN RESPUESTAS");
               console.log(this.eval_emoc);

               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);
               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 190, 42);
               doc.text(10, 45, "01) "); doc.text(23, 45, this.eval_emoc.pg001.toString()); doc.text(30, 45, "02) "); doc.text(43, 45, this.eval_emoc.pg002.toString());
               doc.text(50, 45, "03) "); doc.text(63, 45, this.eval_emoc.pg003.toString()); doc.text(70, 45, "04) "); doc.text(83, 45, this.eval_emoc.pg004.toString());
               doc.text(90, 45, "05) "); doc.text(103, 45, this.eval_emoc.pg005.toString()); doc.text(110, 45, "06) "); doc.text(123, 45, this.eval_emoc.pg006.toString());
               doc.text(130, 45, "07) "); doc.text(143, 45, this.eval_emoc.pg007.toString()); doc.text(150, 45, "08) "); doc.text(163, 45, this.eval_emoc.pg008.toString());
               doc.text(170, 45, "09) "); doc.text(183, 45, this.eval_emoc.pg009.toString());
               doc.line(10, 46, 190, 46);
               console.log(this.eval_emoc.pg010, this.eval_emoc.pg011, this.eval_emoc.pg012, this.eval_emoc.pg013, this.eval_emoc.pg014, this.eval_emoc.pg015, this.eval_emoc.pg016,
                    this.eval_emoc.pg017, this.eval_emoc.pg018)
               // let pg10 = this.eval_emoc.pg010; let pg11 = this.eval_emoc.pg011; let pg12 = this.eval_emoc.pg012; let pg13 = this.eval_emoc.pg013; 
               // let pg15 = this.eval_emoc.pg014; let pg15 = this.eval_emoc.pg015; let pg17 = this.eval_emoc.pg017; let pg18 = this.eval_emoc.pg018
               doc.text(10, 49, "10) "); doc.text(23, 49, this.eval_emoc.pg010.toString()); doc.text(30, 49, "11) "); doc.text(43, 49, this.eval_emoc.pg011.toString());
               doc.text(50, 49, "12) "); doc.text(63, 49, this.eval_emoc.pg012.toString()); doc.text(70, 49, "13) "); doc.text(83, 49, this.eval_emoc.pg013.toString());
               doc.text(90, 49, "14) "); doc.text(103, 49, this.eval_emoc.pg014.toString()); doc.text(110, 49, "15) "); doc.text(123, 49, this.eval_emoc.pg015.toString());
               doc.text(130, 49, "16) "); doc.text(143, 49, this.eval_emoc.pg016.toString()); doc.text(150, 49, "17) "); doc.text(163, 49, this.eval_emoc.pg017.toString());
               doc.text(170, 49, "18) "); doc.text(183, 49, this.eval_emoc.pg018.toString());
               doc.line(10, 50, 190, 50);
               doc.text(10, 53, "19) "); doc.text(23, 53, this.eval_emoc.pg019.toString()); doc.text(30, 53, "20) "); doc.text(43, 53, this.eval_emoc.pg020.toString());
               doc.text(50, 53, "21) "); doc.text(63, 53, this.eval_emoc.pg021.toString()); doc.text(70, 53, "22) "); doc.text(83, 53, this.eval_emoc.pg022.toString());
               doc.text(90, 53, "23) "); doc.text(103, 53, this.eval_emoc.pg023.toString()); doc.text(110, 53, "24) "); doc.text(123, 53, this.eval_emoc.pg024.toString());
               doc.text(130, 53, "25) "); doc.text(143, 53, this.eval_emoc.pg025.toString()); doc.text(150, 53, "26) "); doc.text(163, 53, this.eval_emoc.pg026.toString());
               doc.text(170, 53, "27) "); doc.text(183, 53, this.eval_emoc.pg027.toString());
               doc.line(10, 54, 190, 54);
               doc.text(10, 57, "28) "); doc.text(23, 57, this.eval_emoc.pg028.toString()); doc.text(30, 57, "29) "); doc.text(43, 57, this.eval_emoc.pg029.toString());
               doc.text(50, 57, "30) "); doc.text(63, 57, this.eval_emoc.pg030.toString()); doc.text(70, 57, "31) "); doc.text(83, 57, this.eval_emoc.pg031.toString());
               doc.text(90, 57, "32) "); doc.text(103, 57, this.eval_emoc.pg032.toString()); doc.text(110, 57, "33) "); doc.text(123, 57, this.eval_emoc.pg033.toString());
               doc.text(130, 57, "34) "); doc.text(143, 57, this.eval_emoc.pg034.toString()); doc.text(150, 57, "35) "); doc.text(163, 57, this.eval_emoc.pg035.toString());
               doc.text(170, 57, "36) "); doc.text(183, 57, this.eval_emoc.pg036.toString());
               doc.line(10, 58, 190, 58);
               doc.text(10, 61, "37) "); doc.text(23, 61, this.eval_emoc.pg037.toString()); doc.text(30, 61, "38) "); doc.text(43, 61, this.eval_emoc.pg038.toString());
               doc.text(50, 61, "39) "); doc.text(63, 61, this.eval_emoc.pg039.toString()); doc.text(70, 61, "40) "); doc.text(83, 61, this.eval_emoc.pg040.toString());
               doc.text(90, 61, "41) "); doc.text(103, 61, this.eval_emoc.pg041.toString()); doc.text(110, 61, "42) "); doc.text(123, 61, this.eval_emoc.pg042.toString());
               doc.text(130, 61, "43) "); doc.text(143, 61, this.eval_emoc.pg043.toString()); doc.text(150, 61, "44) "); doc.text(163, 61, this.eval_emoc.pg044.toString());
               doc.text(170, 61, "45) "); doc.text(183, 61, this.eval_emoc.pg045.toString());
               doc.line(10, 62, 190, 62);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          crearPDF_vtas2() {

               /** CREACION DEL ARCHIVO PDF */
               var cadena = this.eval_vtas.nombre,
                    patron = / /g,
                    nuevoValor = "",
                    nusuario = cadena.replace(patron, nuevoValor);

               var nArchivo = "vtas_" + nusuario;
               console.log("archivo a crear ? ", nArchivo);

               var imagen = "data:image/jpeg;base64,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";
               var doc = new jsPDF('portrait');
               var linea = 5;

               /** Muestra el logo.        (izq, top, ancho, alto) */
               doc.addImage(imagen, 'JPEG', 155, linea, 50, 20);
               /** fila, columna */

               /** CIRCULOS  */
               doc.setLineWidth(1);                    // Grosor de la línea del borde
               doc.setDrawColor(0);

               /** ................................................................................................................ 
               /* TEXTO INTRODUCTORIO */
               let meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];

               var lhoy = new Date();
               //lhoy=   lhoy.toString();
               var ldia = lhoy.getDate();
               var lmes = meses[lhoy.getMonth()];
               var lanio = lhoy.getFullYear();

               // console.log("lhoy ? ",lhoy);
               // console.log("ldia ? ",ldia,", lmes ? ",lmes,", lanio ? ",lanio);
               doc.setFontSize(9);
               doc.text(10, 20, "Ciudad de Guatemala, " + ldia + " de " + lmes + " de " + lanio);
               doc.text(10, 30, "Evaluación ORIENTACION EN VENTAS para " + this.eval_vtas.nombre + " de " + this.eval_vtas.empresa);

               this.respuestasvtas2(doc);
               this.resultadosvtas2(doc);

               doc.save(nArchivo);
               doc.autoPrint();
               window.open(doc.output('bloburl'), '_blank');
          },
          rangosvtas2() {
               this.res_vtas = {
                    grupo1: 0, grupo2: 0, grupo3: 0, grupo4: 0,
                    grupo5: 0, grupo6: 0, grupo7: 0, grupo8: 0,
                    grupoR: 0, grupoA: 0, grupoCol: 0,
               }
               /* ==============================================================================================================
                *  AUTO CONCIENCIA */

               this.res_vtas.grupo1 = 0;
               if (this.eval_vtas.pg001 === "b") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg002 === "b") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg019 === "c") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg020 === "b") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg037 === "a") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg038 === "c") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg055 === "b") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg056 === "a") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg073 === "c") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg074 === "a") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }
               if (this.eval_vtas.pg075 === "c") { this.res_vtas.grupo1 = this.res_vtas.grupo1 + 1; }

               this.res_vtas.grupo2 = 0;
               if (this.eval_vtas.pg003 === "b") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg004 === "b") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg021 === "c") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg022 === "c") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg039 === "a") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg040 === "a") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg057 === "a") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg058 === "c") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg059 === "b") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg076 === "c") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }
               if (this.eval_vtas.pg077 === "b") { this.res_vtas.grupo2 = this.res_vtas.grupo2 + 1; }

               this.res_vtas.grupo3 = 0;
               if (this.eval_vtas.pg005 === "a") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg006 === "c") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg007 === "a") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg023 === "b") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg024 === "c") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg025 === "c") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg041 === "a") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg042 === "a") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg043 === "b") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg060 === "b") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }
               if (this.eval_vtas.pg078 === "b") { this.res_vtas.grupo3 = this.res_vtas.grupo3 + 1; }

               this.res_vtas.grupo4 = 0;
               if (this.eval_vtas.pg008 === "b") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg026 === "b") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg044 === "a") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg061 === "b") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg062 === "a") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg079 === "b") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg080 === "c") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               if (this.eval_vtas.pg081 === "c") { this.res_vtas.grupo4 = this.res_vtas.grupo4 + 1; }
               this.res_vtas.grupo4 = 8 - this.res_vtas.grupo4;

               this.res_vtas.grupo5 = 0;
               if (this.eval_vtas.pg009 === "a") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg010 === "b") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg011 === "b") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg027 === "a") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg028 === "c") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg029 === "c") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg045 === "b") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg046 === "b") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg063 === "b") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg064 === "a") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }
               if (this.eval_vtas.pg082 === "c") { this.res_vtas.grupo5 = this.res_vtas.grupo5 + 1; }

               this.res_vtas.grupo6 = 0;
               if (this.eval_vtas.pg012 === "c") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg013 === "b") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg030 === "b") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg031 === "c") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg047 === "c") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg048 === "a") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg049 === "a") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg065 === "c") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg066 === "a") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg083 === "b") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }
               if (this.eval_vtas.pg084 === "a") { this.res_vtas.grupo6 = this.res_vtas.grupo6 + 1; }

               this.res_vtas.grupo7 = 0;
               if (this.eval_vtas.pg014 === "b") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg032 === "c") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg050 === "c") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg067 === "b") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg068 === "a") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg085 === "c") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg086 === "a") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }
               if (this.eval_vtas.pg087 === "a") { this.res_vtas.grupo7 = this.res_vtas.grupo7 + 1; }

               this.res_vtas.grupo8 = 0;
               if (this.eval_vtas.pg015 === "a") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg033 === "b") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg034 === "c") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg051 === "b") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg052 === "a") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg069 === "b") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg070 === "c") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }
               if (this.eval_vtas.pg071 === "b") { this.res_vtas.grupo8 = this.res_vtas.grupo8 + 1; }

               this.res_vtas.grupo9 = 0;
               if (this.eval_vtas.pg016 === "c") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg017 === "b") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg018 === "c") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg035 === "a") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg036 === "c") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg053 === "b") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg054 === "a") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               if (this.eval_vtas.pg072 === "a") { this.res_vtas.grupo9 = this.res_vtas.grupo9 + 1; }
               console.log("17 ", this.eval_vtas.pg017);
               console.log("18 ", this.eval_vtas.pg018);
               console.log("35 ", this.eval_vtas.pg035);
               console.log("g9 ", this.res_vtas.grupo9);

               this.res_vtas.grupoR = this.res_vtas.grupo1 + this.res_vtas.grupo2 + this.res_vtas.grupo3 + this.res_vtas.grupo4;
               this.res_vtas.grupoA = this.res_vtas.grupo5 + this.res_vtas.grupo6 + this.res_vtas.grupo7 + this.res_vtas.grupo8 + this.res_vtas.grupo9;

               this.res_vtas.grupoCol = 0;
               if (this.eval_vtas.pg001 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg002 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg003 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg004 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg005 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg006 === "c") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg007 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg008 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg009 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg010 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg011 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg012 === "c") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg013 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg014 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg015 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg016 === "c") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg017 === "b") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg018 === "c") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg027 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
               if (this.eval_vtas.pg035 === "a") { this.res_vtas.grupoCol = this.res_vtas.grupoCol + 1; }
          },
          resultadosvtas2(doc) {

               this.rangosvtas2();

               doc.setLineWidth(0.25);

               doc.text(10, 85, "SECCION DE RESULTADOS ")
               doc.line(10, 86, 206, 86);

               doc.text(10, 95, "* Grupo 1 "); doc.text(30, 95, this.res_vtas.grupo1.toString());
               doc.text(10, 100, "* Grupo 2 "); doc.text(30, 100, this.res_vtas.grupo2.toString());
               doc.text(10, 105, "* Grupo 3 "); doc.text(30, 105, this.res_vtas.grupo3.toString());
               doc.text(10, 110, "* Grupo 4 "); doc.text(30, 110, this.res_vtas.grupo4.toString());
               doc.text(10, 115, "* Grupo 5 "); doc.text(30, 115, this.res_vtas.grupo5.toString());
               doc.text(10, 120, "* Grupo 6 "); doc.text(30, 120, this.res_vtas.grupo6.toString());
               doc.text(10, 125, "* Grupo 7 "); doc.text(30, 125, this.res_vtas.grupo7.toString());
               doc.text(10, 130, "* Grupo 8 "); doc.text(30, 130, this.res_vtas.grupo8.toString());
               doc.text(10, 135, "* Grupo 9 "); doc.text(30, 135, this.res_vtas.grupo9.toString());
               doc.text(10, 140, "* Grupo R "); doc.text(30, 140, this.res_vtas.grupoR.toString());
               doc.text(10, 145, "* Grupo A "); doc.text(30, 145, this.res_vtas.grupoA.toString());
               doc.text(10, 150, "* Grupo Columna "); doc.text(40, 150, this.res_vtas.grupoCol.toString());

          },
          respuestasvtas2(doc) {

               console.log("Respuestas ");
               console.log(this.eval_vtas);
               /* Muestra las preguntas */
               /* (izquierda, diangonal derecha abajo, largo, diagonal izquierda abajo) */
               doc.setLineWidth(0.25);

               doc.text(10, 40, "SECCION DE RESPUESTAS ")
               doc.line(10, 42, 206, 42);
               // doc.text(10, 45, this.eval_vtas.pg001 === "a" ? "| 01= (a)" : "| 01= (b)");
               doc.text(10, 45, this.eval_vtas.pg001 === "a" ? "| 01= (a)" : this.eval_vtas.pg001 === "b" ? "| 01= (b)" : "| 01= (c)");
               doc.text(23, 45, this.eval_vtas.pg002 === "a" ? "| 02= (a)" : this.eval_vtas.pg002 === "b" ? "| 02= (b)" : "| 02= (c)");
               doc.text(36, 45, this.eval_vtas.pg003 === "a" ? "| 03= (a)" : this.eval_vtas.pg003 === "b" ? "| 03= (b)" : "| 03= (c)");
               doc.text(49, 45, this.eval_vtas.pg004 === "a" ? "| 04= (a)" : this.eval_vtas.pg004 === "b" ? "| 04= (b)" : "| 04= (c)");
               doc.text(62, 45, this.eval_vtas.pg005 === "a" ? "| 05= (a)" : this.eval_vtas.pg005 === "b" ? "| 05= (b)" : "| 05= (c)");
               doc.text(75, 45, this.eval_vtas.pg006 === "a" ? "| 06= (a)" : this.eval_vtas.pg006 === "b" ? "| 06= (b)" : "| 06= (c)");
               doc.text(88, 45, this.eval_vtas.pg007 === "a" ? "| 07= (a)" : this.eval_vtas.pg007 === "b" ? "| 07= (b)" : "| 07= (c)");
               doc.text(101, 45, this.eval_vtas.pg008 === "a" ? "| 08= (a)" : this.eval_vtas.pg008 === "b" ? "| 08= (b)" : "| 08= (c)");
               doc.text(114, 45, this.eval_vtas.pg009 === "a" ? "| 09= (a)" : this.eval_vtas.pg009 === "b" ? "| 09= (b)" : "| 09= (c)");
               doc.text(127, 45, this.eval_vtas.pg010 === "a" ? "| 10= (a)" : this.eval_vtas.pg010 === "b" ? "| 10= (b)" : "| 10= (c)");
               doc.text(140, 45, this.eval_vtas.pg011 === "a" ? "| 11= (a)" : this.eval_vtas.pg011 === "b" ? "| 11= (b)" : "| 11= (c)");
               doc.text(153, 45, this.eval_vtas.pg012 === "a" ? "| 12= (a)" : this.eval_vtas.pg012 === "b" ? "| 12= (b)" : "| 12= (c)");
               doc.text(166, 45, this.eval_vtas.pg013 === "a" ? "| 13= (a)" : this.eval_vtas.pg013 === "b" ? "| 13= (b)" : "| 13= (c)");
               doc.text(179, 45, this.eval_vtas.pg014 === "a" ? "| 14= (a)" : this.eval_vtas.pg014 === "b" ? "| 14= (b)" : "| 14= (c)");
               doc.text(192, 45, this.eval_vtas.pg015 === "a" ? "| 15= (a) |" : this.eval_vtas.pg015 === "b" ? "| 15= (b) |" : "| 15= (c) |");
               doc.line(10, 46, 206, 46);

               doc.text(10, 49, this.eval_vtas.pg016 === "a" ? "| 16= (a)" : this.eval_vtas.pg016 === "b" ? "| 16= (b)" : "| 16= (c)");
               doc.text(23, 49, this.eval_vtas.pg017 === "a" ? "| 17= (a)" : this.eval_vtas.pg017 === "b" ? "| 17= (b)" : "| 17= (c)");
               doc.text(36, 49, this.eval_vtas.pg018 === "a" ? "| 18= (a)" : this.eval_vtas.pg018 === "b" ? "| 18= (b)" : "| 18= (c)");
               doc.text(49, 49, this.eval_vtas.pg019 === "a" ? "| 19= (a)" : this.eval_vtas.pg019 === "b" ? "| 19= (b)" : "| 19= (c)");
               doc.text(62, 49, this.eval_vtas.pg020 === "a" ? "| 20= (a)" : this.eval_vtas.pg020 === "b" ? "| 20= (b)" : "| 20= (c)");
               doc.text(75, 49, this.eval_vtas.pg021 === "a" ? "| 21= (a)" : this.eval_vtas.pg021 === "b" ? "| 21= (b)" : "| 21= (c)");
               doc.text(88, 49, this.eval_vtas.pg022 === "a" ? "| 22= (a)" : this.eval_vtas.pg022 === "b" ? "| 22= (b)" : "| 22= (c)");
               doc.text(101, 49, this.eval_vtas.pg023 === "a" ? "| 23= (a)" : this.eval_vtas.pg023 === "b" ? "| 23= (b)" : "| 23= (c)");
               doc.text(114, 49, this.eval_vtas.pg024 === "a" ? "| 24= (a)" : this.eval_vtas.pg024 === "b" ? "| 24= (b)" : "| 24= (c)");
               doc.text(127, 49, this.eval_vtas.pg025 === "a" ? "| 25= (a)" : this.eval_vtas.pg025 === "b" ? "| 25= (b)" : "| 25= (c)");
               doc.text(140, 49, this.eval_vtas.pg026 === "a" ? "| 26= (a)" : this.eval_vtas.pg026 === "b" ? "| 26= (b)" : "| 26= (c)");
               doc.text(153, 49, this.eval_vtas.pg027 === "a" ? "| 27= (a)" : this.eval_vtas.pg027 === "b" ? "| 27= (b)" : "| 27= (c)");
               doc.text(166, 49, this.eval_vtas.pg028 === "a" ? "| 28= (a)" : this.eval_vtas.pg028 === "b" ? "| 28= (b)" : "| 28= (c)");
               doc.text(179, 49, this.eval_vtas.pg029 === "a" ? "| 29= (a)" : this.eval_vtas.pg029 === "b" ? "| 29= (b)" : "| 29= (c)");
               doc.text(192, 49, this.eval_vtas.pg030 === "a" ? "| 30= (a) |" : this.eval_vtas.pg030 === "b" ? "| 30= (b) |" : "| 30= (c) |");
               doc.line(10, 50, 206, 50);

               doc.text(10, 53, this.eval_vtas.pg031 === "a" ? "| 31= (a)" : this.eval_vtas.pg031 === "b" ? "| 39= (b)" : "| 31= (c)");
               doc.text(23, 53, this.eval_vtas.pg032 === "a" ? "| 32= (a)" : this.eval_vtas.pg032 === "b" ? "| 39= (b)" : "| 32= (c)");
               doc.text(36, 53, this.eval_vtas.pg033 === "a" ? "| 33= (a)" : this.eval_vtas.pg033 === "b" ? "| 39= (b)" : "| 33= (c)");
               doc.text(49, 53, this.eval_vtas.pg034 === "a" ? "| 34= (a)" : this.eval_vtas.pg034 === "b" ? "| 39= (b)" : "| 34= (c)");
               doc.text(62, 53, this.eval_vtas.pg035 === "a" ? "| 35= (a)" : this.eval_vtas.pg035 === "b" ? "| 39= (b)" : "| 35= (c)");
               doc.text(75, 53, this.eval_vtas.pg036 === "a" ? "| 36= (a)" : this.eval_vtas.pg036 === "b" ? "| 39= (b)" : "| 36= (c)");
               doc.text(88, 53, this.eval_vtas.pg037 === "a" ? "| 37= (a)" : this.eval_vtas.pg037 === "b" ? "| 39= (b)" : "| 37= (c)");
               doc.text(101, 53, this.eval_vtas.pg038 === "a" ? "| 38= (a)" : this.eval_vtas.pg038 === "b" ? "| 39= (b)" : "| 38= (c)");
               doc.text(114, 53, this.eval_vtas.pg039 === "a" ? "| 39= (a)" : this.eval_vtas.pg039 === "b" ? "| 39= (b)" : "| 39= (c)");
               doc.text(127, 53, this.eval_vtas.pg040 === "a" ? "| 40= (a)" : this.eval_vtas.pg040 === "b" ? "| 39= (b)" : "| 40= (c)");
               doc.text(140, 53, this.eval_vtas.pg041 === "a" ? "| 41= (a)" : this.eval_vtas.pg041 === "b" ? "| 39= (b)" : "| 41= (c)");
               doc.text(153, 53, this.eval_vtas.pg042 === "a" ? "| 42= (a)" : this.eval_vtas.pg042 === "b" ? "| 39= (b)" : "| 42= (c)");
               doc.text(166, 53, this.eval_vtas.pg043 === "a" ? "| 43= (a)" : this.eval_vtas.pg043 === "b" ? "| 39= (b)" : "| 43= (c)");
               doc.text(179, 53, this.eval_vtas.pg044 === "a" ? "| 44= (a)" : this.eval_vtas.pg044 === "b" ? "| 39= (b)" : "| 44= (c)");
               doc.text(192, 53, this.eval_vtas.pg045 === "a" ? "| 45= (a) |" : this.eval_vtas.pg045 === "b" ? "| 39= (b) |" : "| 45= (c) |");
               doc.line(10, 54, 206, 54);

               doc.text(10, 57, this.eval_vtas.pg046 === "a" ? "| 46= (a)" : this.eval_vtas.pg046 === "b" ? "| 46= (b)" : "| 46= (c)");
               doc.text(23, 57, this.eval_vtas.pg047 === "a" ? "| 47= (a)" : this.eval_vtas.pg047 === "b" ? "| 47= (b)" : "| 47= (c)");
               doc.text(36, 57, this.eval_vtas.pg048 === "a" ? "| 48= (a)" : this.eval_vtas.pg048 === "b" ? "| 48= (b)" : "| 48= (c)");
               doc.text(49, 57, this.eval_vtas.pg049 === "a" ? "| 49= (a)" : this.eval_vtas.pg049 === "b" ? "| 49= (b)" : "| 49= (c)");
               doc.text(62, 57, this.eval_vtas.pg050 === "a" ? "| 50= (a)" : this.eval_vtas.pg050 === "b" ? "| 50= (b)" : "| 50= (c)");
               doc.text(75, 57, this.eval_vtas.pg051 === "a" ? "| 51= (a)" : this.eval_vtas.pg051 === "b" ? "| 51= (b)" : "| 51= (c)");
               doc.text(88, 57, this.eval_vtas.pg052 === "a" ? "| 52= (a)" : this.eval_vtas.pg052 === "b" ? "| 52= (b)" : "| 52= (c)");
               doc.text(101, 57, this.eval_vtas.pg053 === "a" ? "| 53= (a)" : this.eval_vtas.pg053 === "b" ? "| 53= (b)" : "| 53= (c)");
               doc.text(114, 57, this.eval_vtas.pg054 === "a" ? "| 54= (a)" : this.eval_vtas.pg054 === "b" ? "| 54= (b)" : "| 54= (c)");
               doc.text(127, 57, this.eval_vtas.pg055 === "a" ? "| 55= (a)" : this.eval_vtas.pg055 === "b" ? "| 55= (b)" : "| 55= (c)");
               doc.text(140, 57, this.eval_vtas.pg056 === "a" ? "| 56= (a)" : this.eval_vtas.pg056 === "b" ? "| 56= (b)" : "| 56= (c)");
               doc.text(153, 57, this.eval_vtas.pg057 === "a" ? "| 57= (a)" : this.eval_vtas.pg057 === "b" ? "| 57= (b)" : "| 57= (c)");
               doc.text(166, 57, this.eval_vtas.pg058 === "a" ? "| 58= (a)" : this.eval_vtas.pg058 === "b" ? "| 58= (b)" : "| 58= (c)");
               doc.text(179, 57, this.eval_vtas.pg059 === "a" ? "| 59= (a)" : this.eval_vtas.pg059 === "b" ? "| 59= (b)" : "| 59= (c)");
               doc.text(192, 57, this.eval_vtas.pg060 === "a" ? "| 60= (a) |" : this.eval_vtas.pg060 === "b" ? "| 60= (b) |" : "| 60= (c) |");
               doc.line(10, 58, 206, 58);

               doc.text(10, 61, this.eval_vtas.pg061 === "a" ? "| 61= (a)" : this.eval_vtas.pg061 === "b" ? "| 61= (b)" : "| 61= (c)");
               doc.text(23, 61, this.eval_vtas.pg062 === "a" ? "| 62= (a)" : this.eval_vtas.pg062 === "b" ? "| 62= (b)" : "| 62= (c)");
               doc.text(36, 61, this.eval_vtas.pg063 === "a" ? "| 63= (a)" : this.eval_vtas.pg063 === "b" ? "| 63= (b)" : "| 63= (c)");
               doc.text(49, 61, this.eval_vtas.pg064 === "a" ? "| 64= (a)" : this.eval_vtas.pg064 === "b" ? "| 64= (b)" : "| 64= (c)");
               doc.text(62, 61, this.eval_vtas.pg065 === "a" ? "| 65= (a)" : this.eval_vtas.pg065 === "b" ? "| 65= (b)" : "| 65= (c)");
               doc.text(75, 61, this.eval_vtas.pg066 === "a" ? "| 66= (a)" : this.eval_vtas.pg066 === "b" ? "| 66= (b)" : "| 66= (c)");
               doc.text(88, 61, this.eval_vtas.pg067 === "a" ? "| 67= (a)" : this.eval_vtas.pg067 === "b" ? "| 67= (b)" : "| 67= (c)");
               doc.text(101, 61, this.eval_vtas.pg068 === "a" ? "| 68= (a)" : this.eval_vtas.pg068 === "b" ? "| 68= (b)" : "| 68= (c)");
               doc.text(114, 61, this.eval_vtas.pg069 === "a" ? "| 69= (a)" : this.eval_vtas.pg069 === "b" ? "| 69= (b)" : "| 69= (c)");
               doc.text(127, 61, this.eval_vtas.pg070 === "a" ? "| 70= (a)" : this.eval_vtas.pg070 === "b" ? "| 70= (b)" : "| 70= (c)");
               doc.text(140, 61, this.eval_vtas.pg071 === "a" ? "| 71= (a)" : this.eval_vtas.pg071 === "b" ? "| 71= (b)" : "| 71= (c)");
               doc.text(153, 61, this.eval_vtas.pg072 === "a" ? "| 72= (a)" : this.eval_vtas.pg072 === "b" ? "| 72= (b)" : "| 72= (c)");
               doc.text(166, 61, this.eval_vtas.pg073 === "a" ? "| 73= (a)" : this.eval_vtas.pg073 === "b" ? "| 73= (b)" : "| 73= (c)");
               doc.text(179, 61, this.eval_vtas.pg074 === "a" ? "| 74= (a)" : this.eval_vtas.pg074 === "b" ? "| 74= (b)" : "| 74= (c)");
               doc.text(192, 61, this.eval_vtas.pg075 === "a" ? "| 75= (a) |" : this.eval_vtas.pg075 === "b" ? "| 75= (b) |" : "| 75= (c) |");
               doc.line(10, 62, 206, 62);

               doc.text(10, 65, this.eval_vtas.pg076 === "a" ? "| 76= (a)" : this.eval_vtas.pg076 === "b" ? "| 76= (b)" : "| 76= (c)");
               doc.text(23, 65, this.eval_vtas.pg077 === "a" ? "| 77= (a)" : this.eval_vtas.pg077 === "b" ? "| 77= (b)" : "| 77= (c)");
               doc.text(36, 65, this.eval_vtas.pg078 === "a" ? "| 78= (a)" : this.eval_vtas.pg078 === "b" ? "| 78= (b)" : "| 78= (c)");
               doc.text(49, 65, this.eval_vtas.pg079 === "a" ? "| 79= (a)" : this.eval_vtas.pg079 === "b" ? "| 79= (b)" : "| 79= (c)");
               doc.text(62, 65, this.eval_vtas.pg080 === "a" ? "| 80= (a)" : this.eval_vtas.pg080 === "b" ? "| 80= (b)" : "| 80= (c)");
               doc.text(75, 65, this.eval_vtas.pg081 === "a" ? "| 81= (a)" : this.eval_vtas.pg081 === "b" ? "| 81= (b)" : "| 81= (c)");
               doc.text(88, 65, this.eval_vtas.pg082 === "a" ? "| 82= (a)" : this.eval_vtas.pg082 === "b" ? "| 82= (b)" : "| 82= (c)");
               doc.text(101, 65, this.eval_vtas.pg083 === "a" ? "| 83= (a)" : this.eval_vtas.pg083 === "b" ? "| 83= (b)" : "| 83= (c)");
               doc.text(114, 65, this.eval_vtas.pg084 === "a" ? "| 84= (a)" : this.eval_vtas.pg084 === "b" ? "| 84= (b)" : "| 84= (c)");
               doc.text(127, 65, this.eval_vtas.pg085 === "a" ? "| 85= (a)" : this.eval_vtas.pg085 === "b" ? "| 85= (b)" : "| 85= (c)");
               doc.text(140, 65, this.eval_vtas.pg086 === "a" ? "| 86= (a)" : this.eval_vtas.pg086 === "b" ? "| 86= (b)" : "| 86= (c)");
               doc.text(153, 65, this.eval_vtas.pg087 === "a" ? "| 87= (a)" : this.eval_vtas.pg087 === "b" ? "| 87= (b)" : "| 87= (c)");
               doc.line(10, 66, 206, 66);
          },

          //? ====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========****====****========**** */
          getEvalTipolo(losCasos) {

               this.evaluacionesT = [];
               this.limite = 0;

               /* Tipología = Myers */
               for (let key in losCasos) {

                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "TIPOLOGIA",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg013, pg014: losCasos[key].pg014,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048, pg049: losCasos[key].pg049, pg050: losCasos[key].pg050,
                         pg051: losCasos[key].pg051, pg052: losCasos[key].pg052, pg053: losCasos[key].pg053, pg054: losCasos[key].pg054, pg055: losCasos[key].pg055,
                         pg056: losCasos[key].pg056, pg057: losCasos[key].pg057, pg058: losCasos[key].pg058, pg059: losCasos[key].pg059, pg060: losCasos[key].pg060,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg066: losCasos[key].pg066, pg067: losCasos[key].pg067, pg068: losCasos[key].pg068, pg069: losCasos[key].pg069, pg070: losCasos[key].pg070,
                    })
               } // for
          },
          getEvalFactor(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "FACTORES",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg013, pg014: losCasos[key].pg014,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048, pg049: losCasos[key].pg049, pg050: losCasos[key].pg050,
                         pg051: losCasos[key].pg051, pg052: losCasos[key].pg052, pg053: losCasos[key].pg053, pg054: losCasos[key].pg054, pg055: losCasos[key].pg055,
                         pg056: losCasos[key].pg056, pg057: losCasos[key].pg057, pg058: losCasos[key].pg058, pg059: losCasos[key].pg059, pg060: losCasos[key].pg060,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg066: losCasos[key].pg066, pg067: losCasos[key].pg067, pg068: losCasos[key].pg068, pg069: losCasos[key].pg069, pg070: losCasos[key].pg070,
                         pg071: losCasos[key].pg071, pg062: losCasos[key].pg072, pg073: losCasos[key].pg073, pg074: losCasos[key].pg074, pg075: losCasos[key].pg075,
                         pg076: losCasos[key].pg076, pg067: losCasos[key].pg077, pg078: losCasos[key].pg078, pg079: losCasos[key].pg079, pg080: losCasos[key].pg080,
                         pg081: losCasos[key].pg081, pg082: losCasos[key].pg082, pg083: losCasos[key].pg083, pg084: losCasos[key].pg084, pg085: losCasos[key].pg085,
                         pg086: losCasos[key].pg086, pg087: losCasos[key].pg087, pg088: losCasos[key].pg088, pg089: losCasos[key].pg089, pg080: losCasos[key].pg090,
                         pg091: losCasos[key].pg091, pg092: losCasos[key].pg092, pg093: losCasos[key].pg093, pg094: losCasos[key].pg094, pg095: losCasos[key].pg095,
                         pg096: losCasos[key].pg096, pg097: losCasos[key].pg097, pg098: losCasos[key].pg098, pg099: losCasos[key].pg099, pg090: losCasos[key].pg100,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg0101: losCasos[key].pg101, pg0102: losCasos[key].pg102,
                    })
               } // for
          },
          getEvalEstabi(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "ESTABILIDAD",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                    })
               } // for

               // this.limite = this.evaluacionesT.length; // cantidad de datos                

               // this.eval_copia = this.evaluacionesT;
               // store.state.st_eval = this.evaluacionesT;
          },
          getEvalSociab(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "SOCIABILIDAD",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                    })
               } // for

               // this.limite = this.evaluacionesT.length; // cantidad de datos                

               // this.eval_copia = this.evaluacionesT;
               // store.state.st_eval = this.evaluacionesT;
          },
          getEvalPerfil(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "PERFIL",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048,
                    })
               } // for

               // this.limite = this.evaluacionesT.length; // cantidad de datos                

               // this.eval_copia = this.evaluacionesT;
               // store.state.st_eval = this.evaluacionesT;
          },
          getEvalSuperv(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "MOSS",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                    })
               } // for

               // this.limite = this.evaluacionesT.length; // cantidad de datos                

               // this.eval_copia = this.evaluacionesT;
               // store.state.st_eval = this.evaluacionesT;
          }, 
          getEvalApvtas(losCasos) {

               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         sexo: losCasos[key].sexo,
                         steval: "TAV",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                    })
               } // for

               // this.limite = this.evaluacionesT.length; // cantidad de datos                

               // this.eval_copia = this.evaluacionesT;
               // store.state.st_eval = this.evaluacionesT;
          }, 
          getEvalSolemp(losCasos) {

               // console.log("entre a getEvalSolemp !!")
               /* Tipología = Myers */
               for (let key in losCasos) {

                    // console.log("[culturaGlistado.js]-getEvaluaciones(), key: ",key,"; codigo ? ",losCasos[key].empresa,"; nombre ? ",losCasos[key].nombre);
                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         sexo: losCasos[key].sexo,
                         steval: "SOLEMP",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg014, pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048, pg049: losCasos[key].pg049, pg050: losCasos[key].pg050,
                         pg051: losCasos[key].pg051, pg052: losCasos[key].pg052, pg053: losCasos[key].pg053, pg054: losCasos[key].pg054, pg055: losCasos[key].pg055,
                         pg056: losCasos[key].pg056, pg057: losCasos[key].pg057, pg058: losCasos[key].pg058, pg059: losCasos[key].pg059, pg060: losCasos[key].pg060,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg066: losCasos[key].pg066, pg067: losCasos[key].pg067, pg068: losCasos[key].pg068, pg069: losCasos[key].pg069, pg070: losCasos[key].pg070,
                         pg071: losCasos[key].pg071, pg072: losCasos[key].pg072, pg073: losCasos[key].pg073, pg074: losCasos[key].pg074, pg075: losCasos[key].pg075,
                         pg076: losCasos[key].pg076, pg077: losCasos[key].pg077, pg078: losCasos[key].pg078, pg079: losCasos[key].pg079, pg080: losCasos[key].pg080,
                         pg081: losCasos[key].pg081, pg082: losCasos[key].pg082, pg083: losCasos[key].pg083, pg084: losCasos[key].pg084, pg085: losCasos[key].pg085,
                         pg086: losCasos[key].pg086, pg087: losCasos[key].pg087, pg088: losCasos[key].pg088, pg089: losCasos[key].pg089, pg090: losCasos[key].pg090,
                         pg091: losCasos[key].pg091, pg092: losCasos[key].pg092, pg093: losCasos[key].pg093, pg094: losCasos[key].pg094, pg095: losCasos[key].pg095,
                         pg096: losCasos[key].pg096, pg097: losCasos[key].pg097, pg098: losCasos[key].pg098, pg099: losCasos[key].pg099, pg100: losCasos[key].pg100,
                         pg101: losCasos[key].pg101, pg102: losCasos[key].pg102, pg103: losCasos[key].pg103, pg104: losCasos[key].pg104, pg105: losCasos[key].pg105,
                         pg106: losCasos[key].pg106, pg107: losCasos[key].pg107, pg108: losCasos[key].pg108, pg109: losCasos[key].pg109, pg110: losCasos[key].pg110,
                         pg111: losCasos[key].pg111, pg112: losCasos[key].pg112, pg113: losCasos[key].pg113, pg114: losCasos[key].pg114, pg115: losCasos[key].pg115,
                         pg116: losCasos[key].pg116, pg117: losCasos[key].pg117, pg118: losCasos[key].pg118, pg119: losCasos[key].pg119, pg120: losCasos[key].pg120,
                         pg121: losCasos[key].pg121, pg122: losCasos[key].pg122, pg123: losCasos[key].pg123, pg124: losCasos[key].pg124, pg125: losCasos[key].pg125,
                         pg126: losCasos[key].pg126, pg127: losCasos[key].pg127, pg128: losCasos[key].pg128, pg129: losCasos[key].pg129, pg130: losCasos[key].pg130,
                         pg131: losCasos[key].pg131, pg132: losCasos[key].pg132, pg133: losCasos[key].pg133, pg134: losCasos[key].pg134, pg135: losCasos[key].pg135,
                         pg136: losCasos[key].pg136, pg137: losCasos[key].pg137, pg138: losCasos[key].pg138, pg139: losCasos[key].pg139, pg140: losCasos[key].pg140,
                         pg141: losCasos[key].pg141, pg142: losCasos[key].pg142, pg143: losCasos[key].pg143, pg144: losCasos[key].pg144, pg145: losCasos[key].pg145,
                         pg146: losCasos[key].pg146, pg147: losCasos[key].pg147, pg148: losCasos[key].pg148, pg149: losCasos[key].pg149, pg150: losCasos[key].pg150,
                         pg151: losCasos[key].pg151, pg152: losCasos[key].pg152, pg153: losCasos[key].pg153, pg154: losCasos[key].pg154, pg155: losCasos[key].pg155,
                         pg156: losCasos[key].pg156, pg157: losCasos[key].pg157, pg158: losCasos[key].pg158, pg159: losCasos[key].pg159, pg160: losCasos[key].pg160,
                         pg161: losCasos[key].pg161, pg162: losCasos[key].pg162, pg163: losCasos[key].pg163, pg164: losCasos[key].pg164, pg165: losCasos[key].pg165,
                         pg166: losCasos[key].pg166, pg167: losCasos[key].pg167, pg168: losCasos[key].pg168, pg169: losCasos[key].pg169, pg170: losCasos[key].pg170,
                         pg171: losCasos[key].pg171, pg172: losCasos[key].pg172, pg173: losCasos[key].pg173, pg174: losCasos[key].pg174, pg175: losCasos[key].pg175,
                         pg176: losCasos[key].pg176, pg177: losCasos[key].pg177, pg178: losCasos[key].pg178, pg179: losCasos[key].pg179, pg180: losCasos[key].pg180,
                         pg181: losCasos[key].pg181, pg182: losCasos[key].pg182, pg183: losCasos[key].pg183, pg184: losCasos[key].pg184, pg185: losCasos[key].pg185,
                         pg186: losCasos[key].pg186, pg187: losCasos[key].pg187, pg188: losCasos[key].pg188, pg189: losCasos[key].pg189, pg190: losCasos[key].pg190,
                         pg191: losCasos[key].pg191, pg192: losCasos[key].pg192, pg193: losCasos[key].pg193, pg194: losCasos[key].pg194, pg195: losCasos[key].pg195,
                         pg196: losCasos[key].pg196, pg197: losCasos[key].pg197, pg198: losCasos[key].pg198, pg199: losCasos[key].pg199, pg200: losCasos[key].pg200,
                         pg201: losCasos[key].pg201, pg202: losCasos[key].pg102, pg203: losCasos[key].pg203, pg204: losCasos[key].pg204, pg205: losCasos[key].pg205,
                         pg206: losCasos[key].pg206, pg207: losCasos[key].pg207,

                    })
               } // for
               // console.log("SALI CON ", this.evaluacionesT);
               this.limite = this.evaluacionesT.length; // cantidad de datos                

               this.eval_copia = this.evaluacionesT;
               store.state.st_eval = this.evaluacionesT;

          },
          getEvalEmoc(losCasos) {

               // this.evaluacionesT = [];
               // this.limite = 0;

               /* Tipología = Myers */
               for (let key in losCasos) {

                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,                         
                         steval: "EMOCIONES",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg013, pg014: losCasos[key].pg014,
                         pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                    })
               } // for
               this.limite = this.evaluacionesT.length; // cantidad de datos                

               this.eval_copia = this.evaluacionesT;
               store.state.st_eval = this.evaluacionesT;
          },
          getEvalApvtas2(losCasos) {

               // this.evaluacionesT = [];
               // this.limite = 0;

               /* Tipología = Myers */
               for (let key in losCasos) {

                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "ORIENTACION",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg013, pg014: losCasos[key].pg014,
                         pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048, pg049: losCasos[key].pg049, pg050: losCasos[key].pg050,
                         pg051: losCasos[key].pg051, pg052: losCasos[key].pg052, pg053: losCasos[key].pg053, pg054: losCasos[key].pg054, pg055: losCasos[key].pg055,
                         pg056: losCasos[key].pg056, pg057: losCasos[key].pg057, pg058: losCasos[key].pg058, pg059: losCasos[key].pg059, pg060: losCasos[key].pg060,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg066: losCasos[key].pg066, pg067: losCasos[key].pg067, pg068: losCasos[key].pg068, pg069: losCasos[key].pg069, pg070: losCasos[key].pg070,
                         pg071: losCasos[key].pg071, pg072: losCasos[key].pg072, pg073: losCasos[key].pg073, pg074: losCasos[key].pg074, pg075: losCasos[key].pg075,
                         pg076: losCasos[key].pg076, pg077: losCasos[key].pg077, pg078: losCasos[key].pg078, pg079: losCasos[key].pg079, pg080: losCasos[key].pg080,
                         pg081: losCasos[key].pg081, pg082: losCasos[key].pg082, pg083: losCasos[key].pg083, pg084: losCasos[key].pg084, pg085: losCasos[key].pg085,
                         pg086: losCasos[key].pg086, pg087: losCasos[key].pg087,
                    })
               } // for
               this.limite = this.evaluacionesT.length; // cantidad de datos                

               this.eval_copia = this.evaluacionesT;
               store.state.st_eval = this.evaluacionesT;
          },
          getEvalAEDP(losCasos) {

               // this.evaluacionesT = [];
               // this.limite = 0;

               /* Tipología = Myers */
               for (let key in losCasos) {

                    this.evaluacionesT.push({

                         llave: key,                                             // 1
                         empresa: losCasos[key].empresa,
                         nombre: losCasos[key].nombre,
                         fecha: losCasos[key].fecha,
                         empezo: losCasos[key].empezo,
                         termino: losCasos[key].termino,
                         steval: "AEDP",
                         pg001: losCasos[key].pg001, pg002: losCasos[key].pg002, pg003: losCasos[key].pg003, pg004: losCasos[key].pg004, pg005: losCasos[key].pg005,
                         pg006: losCasos[key].pg006, pg007: losCasos[key].pg007, pg008: losCasos[key].pg008, pg009: losCasos[key].pg009, pg010: losCasos[key].pg010,
                         pg011: losCasos[key].pg011, pg012: losCasos[key].pg012, pg013: losCasos[key].pg013, pg014: losCasos[key].pg013, pg014: losCasos[key].pg014,
                         pg015: losCasos[key].pg015,
                         pg016: losCasos[key].pg016, pg017: losCasos[key].pg017, pg018: losCasos[key].pg018, pg019: losCasos[key].pg019, pg020: losCasos[key].pg020,
                         pg021: losCasos[key].pg021, pg022: losCasos[key].pg022, pg023: losCasos[key].pg023, pg024: losCasos[key].pg024, pg025: losCasos[key].pg025,
                         pg026: losCasos[key].pg026, pg027: losCasos[key].pg027, pg028: losCasos[key].pg028, pg029: losCasos[key].pg029, pg030: losCasos[key].pg030,
                         pg031: losCasos[key].pg031, pg032: losCasos[key].pg032, pg033: losCasos[key].pg033, pg034: losCasos[key].pg034, pg035: losCasos[key].pg035,
                         pg036: losCasos[key].pg036, pg037: losCasos[key].pg037, pg038: losCasos[key].pg038, pg039: losCasos[key].pg039, pg040: losCasos[key].pg040,
                         pg041: losCasos[key].pg041, pg042: losCasos[key].pg042, pg043: losCasos[key].pg043, pg044: losCasos[key].pg044, pg045: losCasos[key].pg045,
                         pg046: losCasos[key].pg046, pg047: losCasos[key].pg047, pg048: losCasos[key].pg048, pg049: losCasos[key].pg049, pg050: losCasos[key].pg050,
                         pg051: losCasos[key].pg051, pg052: losCasos[key].pg052, pg053: losCasos[key].pg053, pg054: losCasos[key].pg054, pg055: losCasos[key].pg055,
                         pg056: losCasos[key].pg056, pg057: losCasos[key].pg057, pg058: losCasos[key].pg058, pg059: losCasos[key].pg059, pg060: losCasos[key].pg060,
                         pg061: losCasos[key].pg061, pg062: losCasos[key].pg062, pg063: losCasos[key].pg063, pg064: losCasos[key].pg064, pg065: losCasos[key].pg065,
                         pg066: losCasos[key].pg066, pg067: losCasos[key].pg067, pg068: losCasos[key].pg068, pg069: losCasos[key].pg069, pg070: losCasos[key].pg070,
                         pg071: losCasos[key].pg071, pg072: losCasos[key].pg072, pg073: losCasos[key].pg073, pg074: losCasos[key].pg074, 
                         pg074b: losCasos[key].pg074b, pg074c: losCasos[key].pg074c, pg074d: losCasos[key].pg074d, 
                         pg074e: losCasos[key].pg074e, pg074f: losCasos[key].pg074f, pg074g: losCasos[key].pg074g, 
                         pg074h: losCasos[key].pg074h, pg074i: losCasos[key].pg074i,
                         pg075: losCasos[key].pg075,
                         pg076: losCasos[key].pg076, pg077: losCasos[key].pg077, pg078: losCasos[key].pg078, pg079: losCasos[key].pg079, pg080: losCasos[key].pg080,
                         pg081: losCasos[key].pg081, pg082: losCasos[key].pg082, pg083: losCasos[key].pg083, pg084: losCasos[key].pg084, pg085: losCasos[key].pg085,
                         pg086: losCasos[key].pg086, pg087: losCasos[key].pg087, pg088: losCasos[key].pg088, pg089: losCasos[key].pg089, pg090: losCasos[key].pg090,
                         pg091: losCasos[key].pg091, pg092: losCasos[key].pg092, pg093: losCasos[key].pg093, pg094: losCasos[key].pg094, pg095: losCasos[key].pg095,
                         pg096: losCasos[key].pg096, pg097: losCasos[key].pg097, pg098: losCasos[key].pg098, pg099: losCasos[key].pg099, pg100: losCasos[key].pg100,
                         pg101: losCasos[key].pg101, pg102: losCasos[key].pg102, pg103: losCasos[key].pg103, pg104: losCasos[key].pg104, pg105: losCasos[key].pg105,
                         pg106: losCasos[key].pg106, pg107: losCasos[key].pg107, pg108: losCasos[key].pg108, pg109: losCasos[key].pg109, pg110: losCasos[key].pg110,
                         pg111: losCasos[key].pg111, pg112: losCasos[key].pg112, pg113: losCasos[key].pg113, pg114: losCasos[key].pg114, pg115: losCasos[key].pg115,
                         pg116: losCasos[key].pg116, pg117: losCasos[key].pg117, pg118: losCasos[key].pg118, pg119: losCasos[key].pg119, pg120: losCasos[key].pg120,

                         pg121: losCasos[key].pg121, pg122: losCasos[key].pg122, pg123: losCasos[key].pg123, pg124: losCasos[key].pg124, pg125: losCasos[key].pg125,
                         pg126: losCasos[key].pg126, pg127: losCasos[key].pg127, pg128: losCasos[key].pg128, pg129: losCasos[key].pg129, pg130: losCasos[key].pg130,
                         pg131: losCasos[key].pg131, pg132: losCasos[key].pg132, pg133: losCasos[key].pg133, pg134: losCasos[key].pg134, pg135: losCasos[key].pg135,
                         pg136: losCasos[key].pg136, pg137: losCasos[key].pg137, pg138: losCasos[key].pg138, pg139: losCasos[key].pg139, pg140: losCasos[key].pg140,
                         pg141: losCasos[key].pg141, pg142: losCasos[key].pg142, pg143: losCasos[key].pg143, pg144: losCasos[key].pg144, pg145: losCasos[key].pg145,
                         pg146: losCasos[key].pg146, pg147: losCasos[key].pg147, pg148: losCasos[key].pg148, pg149: losCasos[key].pg149, pg150: losCasos[key].pg150,
                         pg151: losCasos[key].pg151, pg152: losCasos[key].pg152, pg153: losCasos[key].pg153, pg154: losCasos[key].pg154, pg155: losCasos[key].pg155, 
                         pg156: losCasos[key].pg156, pg157: losCasos[key].pg157, pg158: losCasos[key].pg158, pg159: losCasos[key].pg159, pg160: losCasos[key].pg160,
                         pg161: losCasos[key].pg161, pg162: losCasos[key].pg162, pg163: losCasos[key].pg163, pg164: losCasos[key].pg164, pg165: losCasos[key].pg165,
                         pg166: losCasos[key].pg166, pg167: losCasos[key].pg167, pg168: losCasos[key].pg168, pg169: losCasos[key].pg169, pg170: losCasos[key].pg170,
                         pg171: losCasos[key].pg171, pg172: losCasos[key].pg172, pg173: losCasos[key].pg173, pg174: losCasos[key].pg174, pg175: losCasos[key].pg175,
                         pg176: losCasos[key].pg176, pg177: losCasos[key].pg177, pg178: losCasos[key].pg178, pg179: losCasos[key].pg179, pg180: losCasos[key].pg180,

                         pg181: losCasos[key].pg181, pg182: losCasos[key].pg182, pg183: losCasos[key].pg183, pg184: losCasos[key].pg184, pg185: losCasos[key].pg185,
                         pg186: losCasos[key].pg186, pg187: losCasos[key].pg187, pg188: losCasos[key].pg188, pg189: losCasos[key].pg189, pg190: losCasos[key].pg190,
                         pg191: losCasos[key].pg191, pg192: losCasos[key].pg192, pg193: losCasos[key].pg193, pg194: losCasos[key].pg194, pg195: losCasos[key].pg195, 
                         pg196: losCasos[key].pg196, pg197: losCasos[key].pg197, pg198: losCasos[key].pg198, pg199: losCasos[key].pg199, pg200: losCasos[key].pg200,
                         pg201: losCasos[key].pg201, pg202: losCasos[key].pg202, pg203: losCasos[key].pg203, pg204: losCasos[key].pg204, pg205: losCasos[key].pg205,
                         pg206: losCasos[key].pg206, pg207: losCasos[key].pg207, pg208: losCasos[key].pg208, pg209: losCasos[key].pg209, pg210: losCasos[key].pg210,
                         pg211: losCasos[key].pg211, pg212: losCasos[key].pg212, pg213: losCasos[key].pg213, pg214: losCasos[key].pg214, pg215: losCasos[key].pg215,
                         pg216: losCasos[key].pg216, pg217: losCasos[key].pg217, pg218: losCasos[key].pg218, pg219: losCasos[key].pg219, pg220: losCasos[key].pg220,
                         pg221: losCasos[key].pg221, pg222: losCasos[key].pg222, pg223: losCasos[key].pg223, pg224: losCasos[key].pg224, pg225: losCasos[key].pg225,
                         pg226: losCasos[key].pg226, pg227: losCasos[key].pg227, pg228: losCasos[key].pg228, pg229: losCasos[key].pg229, pg230: losCasos[key].pg230,
                         pg231: losCasos[key].pg231, pg232: losCasos[key].pg232, pg233: losCasos[key].pg233, pg234: losCasos[key].pg234, pg235: losCasos[key].pg235,
                         pg236: losCasos[key].pg236, pg237: losCasos[key].pg237, pg238: losCasos[key].pg238, pg239: losCasos[key].pg239, pg240: losCasos[key].pg240,
                         pg241: losCasos[key].pg241, pg242: losCasos[key].pg242, pg243: losCasos[key].pg243, pg244: losCasos[key].pg244, pg245: losCasos[key].pg245,
                         pg246: losCasos[key].pg246, pg247: losCasos[key].pg247, pg248: losCasos[key].pg248, pg249: losCasos[key].pg249, pg250: losCasos[key].pg250,
                         pg251: losCasos[key].pg251, pg252: losCasos[key].pg252, pg253: losCasos[key].pg253, pg254: losCasos[key].pg254, 

                    })
               } // for
               this.limite = this.evaluacionesT.length; // cantidad de datos                

               this.eval_copia = this.evaluacionesT;
               store.state.st_eval = this.evaluacionesT;
          },


          bdRead() {

               var dummy = store.state.st_dbEvalTipolo
                    .on('value', snapshot => this.getEvalTipolo(snapshot.val()));

               var dummy = store.state.st_dbEvalFactor
                    .on('value', snapshot => this.getEvalFactor(snapshot.val()));

               var dummy = store.state.st_dbEvalEstabi
                    .on('value', snapshot => this.getEvalEstabi(snapshot.val()));

               var dummy = store.state.st_dbEvalSociab
                    .on('value', snapshot => this.getEvalSociab(snapshot.val()));

               var dummy = store.state.st_dbEvalPerfil
                    .on('value', snapshot => this.getEvalPerfil(snapshot.val()));

               var dummy = store.state.st_dbEvalSuperv
                    .on('value', snapshot => this.getEvalSuperv(snapshot.val()));

               var dummy = store.state.st_dbEvalApvtas
                    .on('value', snapshot => this.getEvalApvtas(snapshot.val()));

               var dummy = store.state.st_dbEvalSolemp
                    .on('value', snapshot => this.getEvalSolemp(snapshot.val()));

               var dummy = store.state.st_dbEvalEmoc
                    .on('value', snapshot => this.getEvalEmoc(snapshot.val()));

               var dummy = store.state.st_dbEvalVtas2
                    .on('value', snapshot => this.getEvalApvtas2(snapshot.val()));

               var dummy = store.state.st_dbEvalAEDP
                    .on('value', snapshot => this.getEvalAEDP(snapshot.val()));

          },                                  
     }, // methods    
} // export



// WEBPACK FOOTER //
// ./src/components/ev_consultas.js